
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9816"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9816"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bMZn5", function(module, exports) {

$parcel$export(module.exports, "auth", function () { return $8953c87b21bd174e$export$73693bad9f5880b0; });
$parcel$export(module.exports, "db", function () { return $8953c87b21bd174e$export$f932f06c7eb6abeb; });
$parcel$export(module.exports, "getAuthError", function () { return $8953c87b21bd174e$export$8de0cebc3335dbc4; });
$parcel$export(module.exports, "requireAuth", function () { return $8953c87b21bd174e$export$dec636a5200b8ec0; });
$parcel$export(module.exports, "getUserProfile", function () { return $8953c87b21bd174e$export$cb01c83fc8789b9b; });
$parcel$export(module.exports, "redirectIfAuth", function () { return $8953c87b21bd174e$export$be71936eb0baabfd; });
$parcel$export(module.exports, "loginWithEmail", function () { return $8953c87b21bd174e$export$aa6adce333380966; });
$parcel$export(module.exports, "registerWithEmail", function () { return $8953c87b21bd174e$export$c8962abba5d5d32a; });
$parcel$export(module.exports, "resendVerificationEmail", function () { return $8953c87b21bd174e$export$89f2809d56506ac7; });
$parcel$export(module.exports, "resetPassword", function () { return $8953c87b21bd174e$export$dc726c8e334dd814; });
$parcel$export(module.exports, "loginWithGoogle", function () { return $8953c87b21bd174e$export$d25f561707ef4ea2; });
$parcel$export(module.exports, "logout", function () { return $8953c87b21bd174e$export$a0973bcfe11b05c9; });

var $7iEdO = parcelRequire("7iEdO");

var $eyjy7 = parcelRequire("eyjy7");
parcelRequire("ftYLF");
var $4GiHF = parcelRequire("4GiHF");
var $75ECW = parcelRequire("75ECW");
const $8953c87b21bd174e$export$73693bad9f5880b0 = (0, $eyjy7.getAuth)((0, $7iEdO.app));
const $8953c87b21bd174e$export$f932f06c7eb6abeb = (0, $4GiHF.aX)((0, $7iEdO.app), 'default');
const $8953c87b21bd174e$var$googleProvider = new (0, $eyjy7.GoogleAuthProvider)();
// Auth error messages
const $8953c87b21bd174e$var$AUTH_ERRORS = {
    'auth/email-already-in-use': 'An account with this email already exists.',
    'auth/invalid-credential': 'Incorrect email or password.',
    'auth/wrong-password': 'Incorrect email or password.',
    'auth/user-not-found': 'No account found with this email.',
    'auth/weak-password': 'Password must be at least 6 characters.',
    'auth/too-many-requests': 'Too many attempts. Try again later.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/popup-closed-by-user': 'Sign-in was cancelled.',
    'auth/email-not-verified': 'Please verify your email before signing in. Check your inbox (and spam folder).'
};
function $8953c87b21bd174e$export$8de0cebc3335dbc4(code) {
    return $8953c87b21bd174e$var$AUTH_ERRORS[code] || 'Something went wrong. Please try again.';
}
async function $8953c87b21bd174e$var$computeGravatarHash(email) {
    const data = new TextEncoder().encode(email.trim().toLowerCase());
    const buf = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(buf)).map((b)=>b.toString(16).padStart(2, '0')).join('');
}
function $8953c87b21bd174e$export$dec636a5200b8ec0(onUser, { returnTo: returnTo = '' } = {}) {
    const loginUrl = returnTo ? `/login?return=${encodeURIComponent(returnTo)}` : '/login';
    return (0, $eyjy7.onAuthStateChanged)($8953c87b21bd174e$export$73693bad9f5880b0, async (user)=>{
        if (!user) {
            window.location.href = loginUrl;
            return;
        }
        if (!user.emailVerified) {
            await (0, $eyjy7.signOut)($8953c87b21bd174e$export$73693bad9f5880b0);
            window.location.href = loginUrl;
            return;
        }
        let profile = null;
        try {
            profile = await $8953c87b21bd174e$export$cb01c83fc8789b9b(user.uid);
        } catch (err) {
            console.error('[auth] Failed to load user profile:', err.message);
        }
        (0, $7iEdO.Analytics).identifyUser(user.uid, {
            plan: profile?.plan || 'free',
            handle: profile?.username || null
        });
        onUser(user, profile);
    });
}
function $8953c87b21bd174e$export$be71936eb0baabfd(returnUrl = '/studio') {
    return (0, $eyjy7.onAuthStateChanged)($8953c87b21bd174e$export$73693bad9f5880b0, (user)=>{
        if (user && user.emailVerified) window.location.href = returnUrl;
    });
}
async function $8953c87b21bd174e$export$cb01c83fc8789b9b(uid) {
    const snap = await (0, $75ECW.getDoc)((0, $4GiHF.a6)($8953c87b21bd174e$export$f932f06c7eb6abeb, 'users', uid));
    return snap.exists() ? snap.data() : null;
}
async function $8953c87b21bd174e$export$aa6adce333380966(email, password) {
    const cred = await (0, $eyjy7.signInWithEmailAndPassword)($8953c87b21bd174e$export$73693bad9f5880b0, email, password);
    if (!cred.user.emailVerified) {
        await (0, $eyjy7.signOut)($8953c87b21bd174e$export$73693bad9f5880b0);
        const err = new Error('Email not verified');
        err.code = 'auth/email-not-verified';
        throw err;
    }
    (0, $7iEdO.Analytics).trackSignIn('email');
    return cred.user;
}
async function $8953c87b21bd174e$export$c8962abba5d5d32a(email, password, displayName) {
    const { user: user } = await (0, $eyjy7.createUserWithEmailAndPassword)($8953c87b21bd174e$export$73693bad9f5880b0, email, password);
    await (0, $eyjy7.updateProfile)(user, {
        displayName: displayName
    });
    // Create user profile in Firestore
    await (0, $75ECW.setDoc)((0, $4GiHF.a6)($8953c87b21bd174e$export$f932f06c7eb6abeb, 'users', user.uid), {
        uid: user.uid,
        email: email,
        displayName: displayName,
        username: '',
        plan: 'free',
        bio: '',
        expertiseLine: '',
        primaryContentUrl: '',
        availabilityEnabled: false,
        availabilityConfig: {},
        gravatarHash: await $8953c87b21bd174e$var$computeGravatarHash(email),
        createdAt: (0, $4GiHF.a$)()
    });
    await (0, $eyjy7.sendEmailVerification)(user);
    await (0, $eyjy7.signOut)($8953c87b21bd174e$export$73693bad9f5880b0);
    (0, $7iEdO.Analytics).trackSignUp('email');
    return {
        verificationSent: true
    };
}
async function $8953c87b21bd174e$export$89f2809d56506ac7(email, password) {
    const cred = await (0, $eyjy7.signInWithEmailAndPassword)($8953c87b21bd174e$export$73693bad9f5880b0, email, password);
    if (!cred.user.emailVerified) await (0, $eyjy7.sendEmailVerification)(cred.user);
    await (0, $eyjy7.signOut)($8953c87b21bd174e$export$73693bad9f5880b0);
}
async function $8953c87b21bd174e$export$dc726c8e334dd814(email) {
    await (0, $eyjy7.sendPasswordResetEmail)($8953c87b21bd174e$export$73693bad9f5880b0, email);
}
async function $8953c87b21bd174e$export$d25f561707ef4ea2() {
    const { user: user } = await (0, $eyjy7.signInWithPopup)($8953c87b21bd174e$export$73693bad9f5880b0, $8953c87b21bd174e$var$googleProvider);
    // Create profile if first time
    const existing = await $8953c87b21bd174e$export$cb01c83fc8789b9b(user.uid);
    if (!existing) {
        await (0, $75ECW.setDoc)((0, $4GiHF.a6)($8953c87b21bd174e$export$f932f06c7eb6abeb, 'users', user.uid), {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName || '',
            username: '',
            plan: 'free',
            bio: '',
            expertiseLine: '',
            primaryContentUrl: '',
            availabilityEnabled: false,
            availabilityConfig: {},
            gravatarHash: await $8953c87b21bd174e$var$computeGravatarHash(user.email),
            createdAt: (0, $4GiHF.a$)()
        });
        (0, $7iEdO.Analytics).trackSignUp('google');
    } else (0, $7iEdO.Analytics).trackSignIn('google');
    return user;
}
async function $8953c87b21bd174e$export$a0973bcfe11b05c9() {
    await (0, $eyjy7.signOut)($8953c87b21bd174e$export$73693bad9f5880b0);
    window.location.href = '/login';
}

});
parcelRegister("7iEdO", function(module, exports) {

$parcel$export(module.exports, "app", function () { return $55096a08d23c1fd2$export$729c8b7179294ba; });
$parcel$export(module.exports, "Analytics", function () { return $55096a08d23c1fd2$export$2b3af6baec22bd98; });
parcelRequire("gKkQl");
var $bVYHX = parcelRequire("bVYHX");
parcelRequire("arkTP");
var $7E3lN = parcelRequire("7E3lN");
const $55096a08d23c1fd2$var$firebaseConfig = {
    apiKey: 'AIzaSyAWC1pO2r4oyZB2mXrOcprt8WMnHhz0K-8',
    authDomain: 'thinqwith.firebaseapp.com',
    projectId: 'thinqwith',
    storageBucket: 'thinqwith.firebasestorage.app',
    messagingSenderId: '518730117909',
    appId: '1:518730117909:web:85cce4ba6ec6daad512f1c',
    measurementId: 'G-C05XR3PDKV'
};
const $55096a08d23c1fd2$export$729c8b7179294ba = (0, $bVYHX.initializeApp)($55096a08d23c1fd2$var$firebaseConfig);
const $55096a08d23c1fd2$export$71a493436f9bccb6 = (0, $7E3lN.getAnalytics)($55096a08d23c1fd2$export$729c8b7179294ba);
const $55096a08d23c1fd2$export$2b3af6baec22bd98 = {
    // ── Identity ──────────────────────────────────────────────────────────────
    // Call once per session after auth resolves. Enables GA4 User Explorer so
    // you can look up any individual by their Firebase UID.
    identifyUser: (uid, { plan: plan = 'free', handle: handle = null } = {})=>{
        (0, $7E3lN.setUserId)($55096a08d23c1fd2$export$71a493436f9bccb6, uid);
        (0, $7E3lN.setUserProperties)($55096a08d23c1fd2$export$71a493436f9bccb6, {
            plan: plan,
            has_handle: handle ? 'yes' : 'no'
        });
    },
    // ── Page views ────────────────────────────────────────────────────────────
    trackPageView: (name)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'page_view', {
            page_title: name
        }),
    // ── Auth ──────────────────────────────────────────────────────────────────
    trackSignIn: (method)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'login', {
            method: method
        }),
    trackSignUp: (method)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'sign_up', {
            method: method
        }),
    // ── Creator actions ───────────────────────────────────────────────────────
    trackCardGenerate: ()=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'card_generate'),
    trackCardPublish: (cardId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'card_publish', {
            card_id: cardId
        }),
    trackProfileUpdated: ()=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'profile_updated'),
    // ── Billing ───────────────────────────────────────────────────────────────
    trackUpgradeClick: (location)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'upgrade_click', {
            location: location
        }),
    trackCheckoutStarted: ()=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'begin_checkout'),
    // ── Reader actions ────────────────────────────────────────────────────────
    trackCardView: (cardId, creatorId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'card_view', {
            card_id: cardId,
            creator_id: creatorId
        }),
    trackProfileView: (username)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'profile_view', {
            username: username
        }),
    trackPlatformModal: (vectorId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'platform_modal_open', {
            vector_id: vectorId
        }),
    trackVectorLaunch: (vectorId, platform)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'vector_launch', {
            vector_id: vectorId,
            platform: platform
        }),
    trackBookmark: (cardId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'bookmark_card', {
            card_id: cardId
        }),
    trackFollow: (creatorId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'follow_creator', {
            creator_id: creatorId
        }),
    trackObservation: (cardId, vectorId)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'save_observation', {
            card_id: cardId,
            vector_id: vectorId
        }),
    // ── Errors ────────────────────────────────────────────────────────────────
    trackError: (msg, ctx)=>(0, $7E3lN.logEvent)($55096a08d23c1fd2$export$71a493436f9bccb6, 'error', {
            error_message: msg,
            context: ctx
        })
};

});
parcelRegister("gKkQl", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("bVYHX")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("bVYHX")).registerVersion; });

var $bVYHX = parcelRequire("bVYHX");
var $c3111c3e3c6a9bdc$var$name = "firebase";
var $c3111c3e3c6a9bdc$var$version = "12.9.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $bVYHX.registerVersion)($c3111c3e3c6a9bdc$var$name, $c3111c3e3c6a9bdc$var$version, 'app');

});

parcelRegister("arkTP", function(module, exports) {
$parcel$export(module.exports, "getAnalytics", function () { return (parcelRequire("7E3lN")).getAnalytics; });
$parcel$export(module.exports, "logEvent", function () { return (parcelRequire("7E3lN")).logEvent; });
$parcel$export(module.exports, "setUserId", function () { return (parcelRequire("7E3lN")).setUserId; });
$parcel$export(module.exports, "setUserProperties", function () { return (parcelRequire("7E3lN")).setUserProperties; });
parcelRequire("7E3lN");

});
parcelRegister("7E3lN", function(module, exports) {

$parcel$export(module.exports, "getAnalytics", function () { return $590ede2df69f5cab$export$b0297573c90085aa; });
$parcel$export(module.exports, "setUserId", function () { return $590ede2df69f5cab$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "setUserProperties", function () { return $590ede2df69f5cab$export$d0e176862bf869b8; });
$parcel$export(module.exports, "logEvent", function () { return $590ede2df69f5cab$export$5e9eec8001665ac5; });

var $bVYHX = parcelRequire("bVYHX");

var $6mnY8 = parcelRequire("6mnY8");

var $9k0Bn = parcelRequire("9k0Bn");

var $aPEEV = parcelRequire("aPEEV");
parcelRequire("ey9Ug");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Analytics.
 */ const $590ede2df69f5cab$var$ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
const $590ede2df69f5cab$var$GA_FID_KEY = 'firebase_id';
const $590ede2df69f5cab$var$ORIGIN_KEY = 'origin';
const $590ede2df69f5cab$var$FETCH_TIMEOUT_MILLIS = 60000;
const $590ede2df69f5cab$var$DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
const $590ede2df69f5cab$var$GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $590ede2df69f5cab$var$logger = new (0, $6mnY8.Logger)('@firebase/analytics');
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $590ede2df69f5cab$var$ERRORS = {
    ["already-exists" /* AnalyticsError.ALREADY_EXISTS */ ]: "A Firebase Analytics instance with the appId {$id}  already exists. Only one Firebase Analytics instance can be created for each appId.",
    ["already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ ]: "initializeAnalytics() cannot be called again with different options than those it was initially called with. It can be called again with the same options to return the existing instance, or getAnalytics() can be used to get a reference to the already-initialized instance.",
    ["already-initialized-settings" /* AnalyticsError.ALREADY_INITIALIZED_SETTINGS */ ]: "Firebase Analytics has already been initialized.settings() must be called before initializing any Analytics instanceor it will have no effect.",
    ["interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ ]: 'Firebase Analytics Interop Component failed to instantiate: {$reason}',
    ["invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ ]: "Firebase Analytics is not supported in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ ]: "IndexedDB unavailable or restricted in this environment. Wrap initialization of analytics in analytics.isSupported() to prevent initialization in unsupported environments. Details: {$errorInfo}",
    ["fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ ]: "The config fetch request timed out while in an exponential backoff state. Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.",
    ["config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ ]: 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}',
    ["no-api-key" /* AnalyticsError.NO_API_KEY */ ]: 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid API key.',
    ["no-app-id" /* AnalyticsError.NO_APP_ID */ ]: 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field tocontain a valid app ID.',
    ["no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ]: 'The "client_id" field is empty.',
    ["invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ ]: 'Trusted Types detected an invalid gtag resource: {$gtagURL}.'
};
const $590ede2df69f5cab$var$ERROR_FACTORY = new (0, $9k0Bn.ErrorFactory)('analytics', 'Analytics', $590ede2df69f5cab$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies and creates a TrustedScriptURL.
 */ function $590ede2df69f5cab$var$createGtagTrustedTypesScriptURL(url) {
    if (!url.startsWith($590ede2df69f5cab$var$GTAG_URL)) {
        const err = $590ede2df69f5cab$var$ERROR_FACTORY.create("invalid-gtag-resource" /* AnalyticsError.INVALID_GTAG_RESOURCE */ , {
            gtagURL: url
        });
        $590ede2df69f5cab$var$logger.warn(err.message);
        return '';
    }
    return url;
}
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */ function $590ede2df69f5cab$var$promiseAllSettled(promises) {
    return Promise.all(promises.map((promise)=>promise.catch((e)=>e)));
}
/**
 * Creates a TrustedTypePolicy object that implements the rules passed as policyOptions.
 *
 * @param policyName A string containing the name of the policy
 * @param policyOptions Object containing implementations of instance methods for TrustedTypesPolicy, see {@link https://developer.mozilla.org/en-US/docs/Web/API/TrustedTypePolicy#instance_methods
 * | the TrustedTypePolicy reference documentation}.
 */ function $590ede2df69f5cab$var$createTrustedTypesPolicy(policyName, policyOptions) {
    // Create a TrustedTypes policy that we can use for updating src
    // properties
    let trustedTypesPolicy;
    if (window.trustedTypes) trustedTypesPolicy = window.trustedTypes.createPolicy(policyName, policyOptions);
    return trustedTypesPolicy;
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $590ede2df69f5cab$var$insertScriptTag(dataLayerName, measurementId) {
    const trustedTypesPolicy = $590ede2df69f5cab$var$createTrustedTypesPolicy('firebase-js-sdk-policy', {
        createScriptURL: $590ede2df69f5cab$var$createGtagTrustedTypesScriptURL
    });
    const script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    const gtagScriptURL = `${$590ede2df69f5cab$var$GTAG_URL}?l=${dataLayerName}&id=${measurementId}`;
    script.src = trustedTypesPolicy ? trustedTypesPolicy?.createScriptURL(gtagScriptURL) : gtagScriptURL;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */ function $590ede2df69f5cab$var$getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    let dataLayer = [];
    if (Array.isArray(window[dataLayerName])) dataLayer = window[dataLayerName];
    else window[dataLayerName] = dataLayer;
    return dataLayer;
}
/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */ async function $590ede2df69f5cab$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
    // If config is already fetched, we know the appId and can use it to look up what FID promise we
    /// are waiting for, and wait only on that one.
    const correspondingAppId = measurementIdToAppId[measurementId];
    try {
        if (correspondingAppId) await initializationPromisesMap[correspondingAppId];
        else {
            // If config is not fetched yet, wait for all configs (we don't know which one we need) and
            // find the appId (if any) corresponding to this measurementId. If there is one, wait on
            // that appId's initialization promise. If there is none, promise resolves and gtag
            // call goes through.
            const dynamicConfigResults = await $590ede2df69f5cab$var$promiseAllSettled(dynamicConfigPromisesList);
            const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === measurementId);
            if (foundConfig) await initializationPromisesMap[foundConfig.appId];
        }
    } catch (e) {
        $590ede2df69f5cab$var$logger.error(e);
    }
    gtagCore("config" /* GtagCommand.CONFIG */ , measurementId, gtagParams);
}
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */ async function $590ede2df69f5cab$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
    try {
        let initializationPromisesToWaitFor = [];
        // If there's a 'send_to' param, check if any ID specified matches
        // an initializeIds() promise we are waiting for.
        if (gtagParams && gtagParams['send_to']) {
            let gaSendToList = gtagParams['send_to'];
            // Make it an array if is isn't, so it can be dealt with the same way.
            if (!Array.isArray(gaSendToList)) gaSendToList = [
                gaSendToList
            ];
            // Checking 'send_to' fields requires having all measurement ID results back from
            // the dynamic config fetch.
            const dynamicConfigResults = await $590ede2df69f5cab$var$promiseAllSettled(dynamicConfigPromisesList);
            for (const sendToId of gaSendToList){
                // Any fetched dynamic measurement ID that matches this 'send_to' ID
                const foundConfig = dynamicConfigResults.find((config)=>config.measurementId === sendToId);
                const initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                if (initializationPromise) initializationPromisesToWaitFor.push(initializationPromise);
                else {
                    // Found an item in 'send_to' that is not associated
                    // directly with an FID, possibly a group.  Empty this array,
                    // exit the loop early, and let it get populated below.
                    initializationPromisesToWaitFor = [];
                    break;
                }
            }
        }
        // This will be unpopulated if there was no 'send_to' field , or
        // if not all entries in the 'send_to' field could be mapped to
        // a FID. In these cases, wait on all pending initialization promises.
        if (initializationPromisesToWaitFor.length === 0) /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
        // Run core gtag function with args after all relevant initialization
        // promises have been resolved.
        await Promise.all(initializationPromisesToWaitFor);
        // Workaround for http://b/141370449 - third argument cannot be undefined.
        gtagCore("event" /* GtagCommand.EVENT */ , measurementId, gtagParams || {});
    } catch (e) {
        $590ede2df69f5cab$var$logger.error(e);
    }
}
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */ function $590ede2df69f5cab$var$wrapGtag(gtagCore, /**
 * Allows wrapped gtag calls to wait on whichever initialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */ initializationPromisesMap, /**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */ dynamicConfigPromisesList, /**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */ measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */ async function gtagWrapper(command, ...args) {
        try {
            // If event, check that relevant initialization promises have completed.
            if (command === "event" /* GtagCommand.EVENT */ ) {
                const [measurementId, gtagParams] = args;
                // If EVENT, second arg must be measurementId.
                await $590ede2df69f5cab$var$gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams);
            } else if (command === "config" /* GtagCommand.CONFIG */ ) {
                const [measurementId, gtagParams] = args;
                // If CONFIG, second arg must be measurementId.
                await $590ede2df69f5cab$var$gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams);
            } else if (command === "consent" /* GtagCommand.CONSENT */ ) {
                const [consentAction, gtagParams] = args;
                // consentAction can be one of 'default' or 'update'.
                gtagCore("consent" /* GtagCommand.CONSENT */ , consentAction, gtagParams);
            } else if (command === "get" /* GtagCommand.GET */ ) {
                const [measurementId, fieldName, callback] = args;
                gtagCore("get" /* GtagCommand.GET */ , measurementId, fieldName, callback);
            } else if (command === "set" /* GtagCommand.SET */ ) {
                const [customParams] = args;
                // If SET, second arg must be params.
                gtagCore("set" /* GtagCommand.SET */ , customParams);
            } else gtagCore(command, ...args);
        } catch (e) {
            $590ede2df69f5cab$var$logger.error(e);
        }
    }
    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */ function $590ede2df69f5cab$var$wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    let gtagCore = function(..._args) {
        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') // @ts-ignore
    gtagCore = window[gtagFunctionName];
    window[gtagFunctionName] = $590ede2df69f5cab$var$wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns the script tag in the DOM matching both the gtag url pattern
 * and the provided data layer name.
 */ function $590ede2df69f5cab$var$findGtagScriptOnPage(dataLayerName) {
    const scriptTags = window.document.getElementsByTagName('script');
    for (const tag of Object.values(scriptTags)){
        if (tag.src && tag.src.includes($590ede2df69f5cab$var$GTAG_URL) && tag.src.includes(dataLayerName)) return tag;
    }
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */ const $590ede2df69f5cab$var$LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */ const $590ede2df69f5cab$var$BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */ class $590ede2df69f5cab$var$RetryData {
    constructor(throttleMetadata = {}, intervalMillis = $590ede2df69f5cab$var$BASE_INTERVAL_MILLIS){
        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }
    getThrottleMetadata(appId) {
        return this.throttleMetadata[appId];
    }
    setThrottleMetadata(appId, metadata) {
        this.throttleMetadata[appId] = metadata;
    }
    deleteThrottleMetadata(appId) {
        delete this.throttleMetadata[appId];
    }
}
const $590ede2df69f5cab$var$defaultRetryData = new $590ede2df69f5cab$var$RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */ function $590ede2df69f5cab$var$getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */ async function $590ede2df69f5cab$var$fetchDynamicConfig(appFields) {
    const { appId: appId, apiKey: apiKey } = appFields;
    const request = {
        method: 'GET',
        headers: $590ede2df69f5cab$var$getHeaders(apiKey)
    };
    const appUrl = $590ede2df69f5cab$var$DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
    const response = await fetch(appUrl, request);
    if (response.status !== 200 && response.status !== 304) {
        let errorMessage = '';
        try {
            // Try to get any error message text from server response.
            const jsonResponse = await response.json();
            if (jsonResponse.error?.message) errorMessage = jsonResponse.error.message;
        } catch (_ignored) {}
        throw $590ede2df69f5cab$var$ERROR_FACTORY.create("config-fetch-failed" /* AnalyticsError.CONFIG_FETCH_FAILED */ , {
            httpStatus: response.status,
            responseMessage: errorMessage
        });
    }
    return response.json();
}
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */ async function $590ede2df69f5cab$var$fetchDynamicConfigWithRetry(app, // retryData and timeoutMillis are parameterized to allow passing a different value for testing.
retryData = $590ede2df69f5cab$var$defaultRetryData, timeoutMillis) {
    const { appId: appId, apiKey: apiKey, measurementId: measurementId } = app.options;
    if (!appId) throw $590ede2df69f5cab$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!apiKey) {
        if (measurementId) return {
            measurementId: measurementId,
            appId: appId
        };
        throw $590ede2df69f5cab$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    const throttleMetadata = retryData.getThrottleMetadata(appId) || {
        backoffCount: 0,
        throttleEndTimeMillis: Date.now()
    };
    const signal = new $590ede2df69f5cab$var$AnalyticsAbortSignal();
    setTimeout(async ()=>{
        // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
        signal.abort();
    }, timeoutMillis !== undefined ? timeoutMillis : $590ede2df69f5cab$var$FETCH_TIMEOUT_MILLIS);
    return $590ede2df69f5cab$var$attemptFetchDynamicConfigWithRetry({
        appId: appId,
        apiKey: apiKey,
        measurementId: measurementId
    }, throttleMetadata, signal, retryData);
}
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */ async function $590ede2df69f5cab$var$attemptFetchDynamicConfigWithRetry(appFields, { throttleEndTimeMillis: throttleEndTimeMillis, backoffCount: backoffCount }, signal, retryData = $590ede2df69f5cab$var$defaultRetryData // for testing
) {
    const { appId: appId, measurementId: measurementId } = appFields;
    // Starts with a (potentially zero) timeout to support resumption from stored state.
    // Ensures the throttle end time is honored if the last attempt timed out.
    // Note the SDK will never make a request if the fetch timeout expires at this point.
    try {
        await $590ede2df69f5cab$var$setAbortableTimeout(signal, throttleEndTimeMillis);
    } catch (e) {
        if (measurementId) {
            $590ede2df69f5cab$var$logger.warn(`Timed out fetching this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${e?.message}]`);
            return {
                appId: appId,
                measurementId: measurementId
            };
        }
        throw e;
    }
    try {
        const response = await $590ede2df69f5cab$var$fetchDynamicConfig(appFields);
        // Note the SDK only clears throttle state if response is success or non-retriable.
        retryData.deleteThrottleMetadata(appId);
        return response;
    } catch (e) {
        const error = e;
        if (!$590ede2df69f5cab$var$isRetriableError(error)) {
            retryData.deleteThrottleMetadata(appId);
            if (measurementId) {
                $590ede2df69f5cab$var$logger.warn(`Failed to fetch this Firebase app's measurement ID from the server.` + ` Falling back to the measurement ID ${measurementId}` + ` provided in the "measurementId" field in the local Firebase config. [${error?.message}]`);
                return {
                    appId: appId,
                    measurementId: measurementId
                };
            } else throw e;
        }
        const backoffMillis = Number(error?.customData?.httpStatus) === 503 ? (0, $9k0Bn.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, $590ede2df69f5cab$var$LONG_RETRY_FACTOR) : (0, $9k0Bn.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
        // Increments backoff state.
        const throttleMetadata = {
            throttleEndTimeMillis: Date.now() + backoffMillis,
            backoffCount: backoffCount + 1
        };
        // Persists state.
        retryData.setThrottleMetadata(appId, throttleMetadata);
        $590ede2df69f5cab$var$logger.debug(`Calling attemptFetch again in ${backoffMillis} millis`);
        return $590ede2df69f5cab$var$attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData);
    }
}
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */ function $590ede2df69f5cab$var$setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise((resolve, reject)=>{
        // Derives backoff from given end time, normalizing negative numbers to zero.
        const backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        const timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(()=>{
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject($590ede2df69f5cab$var$ERROR_FACTORY.create("fetch-throttle" /* AnalyticsError.FETCH_THROTTLE */ , {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */ function $590ede2df69f5cab$var$isRetriableError(e) {
    if (!(e instanceof (0, $9k0Bn.FirebaseError)) || !e.customData) return false;
    // Uses string index defined by ErrorData, which FirebaseError implements.
    const httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */ class $590ede2df69f5cab$var$AnalyticsAbortSignal {
    constructor(){
        this.listeners = [];
    }
    addEventListener(listener) {
        this.listeners.push(listener);
    }
    abort() {
        this.listeners.forEach((listener)=>listener());
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Event parameters to set on 'gtag' during initialization.
 */ let $590ede2df69f5cab$var$defaultEventParametersForInit;
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */ async function $590ede2df69f5cab$var$logEvent$1(gtagFunction, initializationPromise, eventName, eventParams, options) {
    if (options && options.global) {
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, eventParams);
        return;
    } else {
        const measurementId = await initializationPromise;
        const params = {
            ...eventParams,
            'send_to': measurementId
        };
        gtagFunction("event" /* GtagCommand.EVENT */ , eventName, params);
    }
}
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */ async function $590ede2df69f5cab$var$setCurrentScreen$1(gtagFunction, initializationPromise, screenName, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'screen_name': screenName
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'screen_name': screenName
        });
    }
}
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */ async function $590ede2df69f5cab$var$setUserId$1(gtagFunction, initializationPromise, id, options) {
    if (options && options.global) {
        gtagFunction("set" /* GtagCommand.SET */ , {
            'user_id': id
        });
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_id': id
        });
    }
}
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */ async function $590ede2df69f5cab$var$setUserProperties$1(gtagFunction, initializationPromise, properties, options) {
    if (options && options.global) {
        const flatProperties = {};
        for (const key of Object.keys(properties))// use dot notation for merge behavior in gtag.js
        flatProperties[`user_properties.${key}`] = properties[key];
        gtagFunction("set" /* GtagCommand.SET */ , flatProperties);
        return Promise.resolve();
    } else {
        const measurementId = await initializationPromise;
        gtagFunction("config" /* GtagCommand.CONFIG */ , measurementId, {
            update: true,
            'user_properties': properties
        });
    }
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 */ async function $590ede2df69f5cab$var$internalGetGoogleAnalyticsClientId(gtagFunction, initializationPromise) {
    const measurementId = await initializationPromise;
    return new Promise((resolve, reject)=>{
        gtagFunction("get" /* GtagCommand.GET */ , measurementId, 'client_id', (clientId)=>{
            if (!clientId) reject($590ede2df69f5cab$var$ERROR_FACTORY.create("no-client-id" /* AnalyticsError.NO_CLIENT_ID */ ));
            resolve(clientId);
        });
    });
}
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */ async function $590ede2df69f5cab$var$setAnalyticsCollectionEnabled$1(initializationPromise, enabled) {
    const measurementId = await initializationPromise;
    window[`ga-disable-${measurementId}`] = !enabled;
}
/**
 * Consent parameters to default to during 'gtag' initialization.
 */ let $590ede2df69f5cab$var$defaultConsentSettingsForInit;
/**
 * Sets the variable {@link defaultConsentSettingsForInit} for use in the initialization of
 * analytics.
 *
 * @param consentSettings Maps the applicable end user consent state for gtag.js.
 */ function $590ede2df69f5cab$var$_setConsentDefaultForInit(consentSettings) {
    $590ede2df69f5cab$var$defaultConsentSettingsForInit = consentSettings;
}
/**
 * Sets the variable `defaultEventParametersForInit` for use in the initialization of
 * analytics.
 *
 * @param customParams Any custom params the user may pass to gtag.js.
 */ function $590ede2df69f5cab$var$_setDefaultEventParametersForInit(customParams) {
    $590ede2df69f5cab$var$defaultEventParametersForInit = customParams;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $590ede2df69f5cab$var$validateIndexedDB() {
    if (!(0, $9k0Bn.isIndexedDBAvailable)()) {
        $590ede2df69f5cab$var$logger.warn($590ede2df69f5cab$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: 'IndexedDB is not available in this environment.'
        }).message);
        return false;
    } else try {
        await (0, $9k0Bn.validateIndexedDBOpenable)();
    } catch (e) {
        $590ede2df69f5cab$var$logger.warn($590ede2df69f5cab$var$ERROR_FACTORY.create("indexeddb-unavailable" /* AnalyticsError.INDEXEDDB_UNAVAILABLE */ , {
            errorInfo: e?.toString()
        }).message);
        return false;
    }
    return true;
}
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */ async function $590ede2df69f5cab$var$_initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
    const dynamicConfigPromise = $590ede2df69f5cab$var$fetchDynamicConfigWithRetry(app);
    // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.
    dynamicConfigPromise.then((config)=>{
        measurementIdToAppId[config.measurementId] = config.appId;
        if (app.options.measurementId && config.measurementId !== app.options.measurementId) $590ede2df69f5cab$var$logger.warn(`The measurement ID in the local Firebase config (${app.options.measurementId})` + ` does not match the measurement ID fetched from the server (${config.measurementId}).` + ` To ensure analytics events are always sent to the correct Analytics property,` + ` update the` + ` measurement ID field in the local config or remove it from the local config.`);
    }).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
    // Add to list to track state of all dynamic config promises.
    dynamicConfigPromisesList.push(dynamicConfigPromise);
    const fidPromise = $590ede2df69f5cab$var$validateIndexedDB().then((envIsValid)=>{
        if (envIsValid) return installations.getId();
        else return undefined;
    });
    const [dynamicConfig, fid] = await Promise.all([
        dynamicConfigPromise,
        fidPromise
    ]);
    // Detect if user has already put the gtag <script> tag on this page with the passed in
    // data layer name.
    if (!$590ede2df69f5cab$var$findGtagScriptOnPage(dataLayerName)) $590ede2df69f5cab$var$insertScriptTag(dataLayerName, dynamicConfig.measurementId);
    // Detects if there are consent settings that need to be configured.
    if ($590ede2df69f5cab$var$defaultConsentSettingsForInit) {
        gtagCore("consent" /* GtagCommand.CONSENT */ , 'default', $590ede2df69f5cab$var$defaultConsentSettingsForInit);
        $590ede2df69f5cab$var$_setConsentDefaultForInit(undefined);
    }
    // This command initializes gtag.js and only needs to be called once for the entire web app,
    // but since it is idempotent, we can call it multiple times.
    // We keep it together with other initialization logic for better code structure.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtagCore('js', new Date());
    // User config added first. We don't want users to accidentally overwrite
    // base Firebase config properties.
    const configProperties = options?.config ?? {};
    // guard against developers accidentally setting properties with prefix `firebase_`
    configProperties[$590ede2df69f5cab$var$ORIGIN_KEY] = 'firebase';
    configProperties.update = true;
    if (fid != null) configProperties[$590ede2df69f5cab$var$GA_FID_KEY] = fid;
    // It should be the first config command called on this GA-ID
    // Initialize this GA-ID and set FID on it using the gtag config API.
    // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
    // `configProperties`.
    gtagCore("config" /* GtagCommand.CONFIG */ , dynamicConfig.measurementId, configProperties);
    // Detects if there is data that will be set on every event logged from the SDK.
    if ($590ede2df69f5cab$var$defaultEventParametersForInit) {
        gtagCore("set" /* GtagCommand.SET */ , $590ede2df69f5cab$var$defaultEventParametersForInit);
        $590ede2df69f5cab$var$_setDefaultEventParametersForInit(undefined);
    }
    return dynamicConfig.measurementId;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Analytics Service class.
 */ class $590ede2df69f5cab$var$AnalyticsService {
    constructor(app){
        this.app = app;
    }
    _delete() {
        delete $590ede2df69f5cab$var$initializationPromisesMap[this.app.options.appId];
        return Promise.resolve();
    }
}
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */ let $590ede2df69f5cab$var$initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */ let $590ede2df69f5cab$var$dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */ const $590ede2df69f5cab$var$measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */ let $590ede2df69f5cab$var$dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */ let $590ede2df69f5cab$var$gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */ let $590ede2df69f5cab$var$gtagCoreFunction;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */ let $590ede2df69f5cab$var$wrappedGtagFunction;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */ let $590ede2df69f5cab$var$globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */ function $590ede2df69f5cab$export$a5a6e0b888b2c992(options) {
    if ($590ede2df69f5cab$var$globalInitDone) throw $590ede2df69f5cab$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    if (options.dataLayerName) $590ede2df69f5cab$var$dataLayerName = options.dataLayerName;
    if (options.gtagName) $590ede2df69f5cab$var$gtagName = options.gtagName;
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */ function $590ede2df69f5cab$var$warnOnBrowserContextMismatch() {
    const mismatchedEnvMessages = [];
    if ((0, $9k0Bn.isBrowserExtension)()) mismatchedEnvMessages.push('This is a browser extension environment.');
    if (!(0, $9k0Bn.areCookiesEnabled)()) mismatchedEnvMessages.push('Cookies are not available.');
    if (mismatchedEnvMessages.length > 0) {
        const details = mismatchedEnvMessages.map((message, index)=>`(${index + 1}) ${message}`).join(' ');
        const err = $590ede2df69f5cab$var$ERROR_FACTORY.create("invalid-analytics-context" /* AnalyticsError.INVALID_ANALYTICS_CONTEXT */ , {
            errorInfo: details
        });
        $590ede2df69f5cab$var$logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */ function $590ede2df69f5cab$var$factory(app, installations, options) {
    $590ede2df69f5cab$var$warnOnBrowserContextMismatch();
    const appId = app.options.appId;
    if (!appId) throw $590ede2df69f5cab$var$ERROR_FACTORY.create("no-app-id" /* AnalyticsError.NO_APP_ID */ );
    if (!app.options.apiKey) {
        if (app.options.measurementId) $590ede2df69f5cab$var$logger.warn(`The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest` + ` measurement ID for this Firebase app. Falling back to the measurement ID ${app.options.measurementId}` + ` provided in the "measurementId" field in the local Firebase config.`);
        else throw $590ede2df69f5cab$var$ERROR_FACTORY.create("no-api-key" /* AnalyticsError.NO_API_KEY */ );
    }
    if ($590ede2df69f5cab$var$initializationPromisesMap[appId] != null) throw $590ede2df69f5cab$var$ERROR_FACTORY.create("already-exists" /* AnalyticsError.ALREADY_EXISTS */ , {
        id: appId
    });
    if (!$590ede2df69f5cab$var$globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        $590ede2df69f5cab$var$getOrCreateDataLayer($590ede2df69f5cab$var$dataLayerName);
        const { wrappedGtag: wrappedGtag, gtagCore: gtagCore } = $590ede2df69f5cab$var$wrapOrCreateGtag($590ede2df69f5cab$var$initializationPromisesMap, $590ede2df69f5cab$var$dynamicConfigPromisesList, $590ede2df69f5cab$var$measurementIdToAppId, $590ede2df69f5cab$var$dataLayerName, $590ede2df69f5cab$var$gtagName);
        $590ede2df69f5cab$var$wrappedGtagFunction = wrappedGtag;
        $590ede2df69f5cab$var$gtagCoreFunction = gtagCore;
        $590ede2df69f5cab$var$globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    $590ede2df69f5cab$var$initializationPromisesMap[appId] = $590ede2df69f5cab$var$_initializeAnalytics(app, $590ede2df69f5cab$var$dynamicConfigPromisesList, $590ede2df69f5cab$var$measurementIdToAppId, installations, $590ede2df69f5cab$var$gtagCoreFunction, $590ede2df69f5cab$var$dataLayerName, options);
    const analyticsInstance = new $590ede2df69f5cab$var$AnalyticsService(app);
    return analyticsInstance;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $590ede2df69f5cab$export$b0297573c90085aa(app = (0, $bVYHX.getApp)()) {
    app = (0, $9k0Bn.getModularInstance)(app);
    // Dependencies
    const analyticsProvider = (0, $bVYHX._getProvider)(app, $590ede2df69f5cab$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) return analyticsProvider.getImmediate();
    return $590ede2df69f5cab$export$e1ffb6ba450b0317(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ function $590ede2df69f5cab$export$e1ffb6ba450b0317(app, options = {}) {
    // Dependencies
    const analyticsProvider = (0, $bVYHX._getProvider)(app, $590ede2df69f5cab$var$ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        const existingInstance = analyticsProvider.getImmediate();
        if ((0, $9k0Bn.deepEqual)(options, analyticsProvider.getOptions())) return existingInstance;
        else throw $590ede2df69f5cab$var$ERROR_FACTORY.create("already-initialized" /* AnalyticsError.ALREADY_INITIALIZED */ );
    }
    const analyticsInstance = analyticsProvider.initialize({
        options: options
    });
    return analyticsInstance;
}
/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */ async function $590ede2df69f5cab$export$48c17662a6902497() {
    if ((0, $9k0Bn.isBrowserExtension)()) return false;
    if (!(0, $9k0Bn.areCookiesEnabled)()) return false;
    if (!(0, $9k0Bn.isIndexedDBAvailable)()) return false;
    try {
        const isDBOpenable = await (0, $9k0Bn.validateIndexedDBOpenable)();
        return isDBOpenable;
    } catch (error) {
        return false;
    }
}
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @deprecated Use {@link logEvent} with `eventName` as 'screen_view' and add relevant `eventParams`.
 * See {@link https://firebase.google.com/docs/analytics/screenviews | Track Screenviews}.
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */ function $590ede2df69f5cab$export$a364c5ef84862575(analyticsInstance, screenName, options) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    $590ede2df69f5cab$var$setCurrentScreen$1($590ede2df69f5cab$var$wrappedGtagFunction, $590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
}
/**
 * Retrieves a unique Google Analytics identifier for the web client.
 * See {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/config#client_id | client_id}.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */ async function $590ede2df69f5cab$export$108b704ce5c937fe(analyticsInstance) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    return $590ede2df69f5cab$var$internalGetGoogleAnalyticsClientId($590ede2df69f5cab$var$wrappedGtagFunction, $590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId]);
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */ function $590ede2df69f5cab$export$7f5abdb7f5093137(analyticsInstance, id, options) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    $590ede2df69f5cab$var$setUserId$1($590ede2df69f5cab$var$wrappedGtagFunction, $590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */ function $590ede2df69f5cab$export$d0e176862bf869b8(analyticsInstance, properties, options) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    $590ede2df69f5cab$var$setUserProperties$1($590ede2df69f5cab$var$wrappedGtagFunction, $590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */ function $590ede2df69f5cab$export$7d544a250c4ed423(analyticsInstance, enabled) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    $590ede2df69f5cab$var$setAnalyticsCollectionEnabled$1($590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
}
/**
 * Adds data that will be set on every event logged from the SDK, including automatic ones.
 * With gtag's "set" command, the values passed persist on the current page and are passed with
 * all subsequent events.
 * @public
 * @param customParams - Any custom params the user may pass to gtag.js.
 */ function $590ede2df69f5cab$export$9bde4a1551d6c3ba(customParams) {
    // Check if reference to existing gtag function on window object exists
    if ($590ede2df69f5cab$var$wrappedGtagFunction) $590ede2df69f5cab$var$wrappedGtagFunction("set" /* GtagCommand.SET */ , customParams);
    else $590ede2df69f5cab$var$_setDefaultEventParametersForInit(customParams);
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */ function $590ede2df69f5cab$export$5e9eec8001665ac5(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, $9k0Bn.getModularInstance)(analyticsInstance);
    $590ede2df69f5cab$var$logEvent$1($590ede2df69f5cab$var$wrappedGtagFunction, $590ede2df69f5cab$var$initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch((e)=>$590ede2df69f5cab$var$logger.error(e));
}
/**
 * Sets the applicable end user consent state for this web app across all gtag references once
 * Firebase Analytics is initialized.
 *
 * Use the {@link ConsentSettings} to specify individual consent type values. By default consent
 * types are set to "granted".
 * @public
 * @param consentSettings - Maps the applicable end user consent state for gtag.js.
 */ function $590ede2df69f5cab$export$ff06c4c0781050d7(consentSettings) {
    // Check if reference to existing gtag function on window object exists
    if ($590ede2df69f5cab$var$wrappedGtagFunction) $590ede2df69f5cab$var$wrappedGtagFunction("consent" /* GtagCommand.CONSENT */ , 'update', consentSettings);
    else $590ede2df69f5cab$var$_setConsentDefaultForInit(consentSettings);
}
const $590ede2df69f5cab$var$name = "@firebase/analytics";
const $590ede2df69f5cab$var$version = "0.10.19";
/**
 * The Firebase Analytics Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ function $590ede2df69f5cab$var$registerAnalytics() {
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)($590ede2df69f5cab$var$ANALYTICS_TYPE, (container, { options: analyticsOptions })=>{
        // getImmediate for FirebaseApp will always succeed
        const app = container.getProvider('app').getImmediate();
        const installations = container.getProvider('installations-internal').getImmediate();
        return $590ede2df69f5cab$var$factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)('analytics-internal', internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, $bVYHX.registerVersion)($590ede2df69f5cab$var$name, $590ede2df69f5cab$var$version);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $bVYHX.registerVersion)($590ede2df69f5cab$var$name, $590ede2df69f5cab$var$version, 'esm2020');
    function internalFactory(container) {
        try {
            const analytics = container.getProvider($590ede2df69f5cab$var$ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: (eventName, eventParams, options)=>$590ede2df69f5cab$export$5e9eec8001665ac5(analytics, eventName, eventParams, options),
                setUserProperties: (properties, options)=>$590ede2df69f5cab$export$d0e176862bf869b8(analytics, properties, options)
            };
        } catch (e) {
            throw $590ede2df69f5cab$var$ERROR_FACTORY.create("interop-component-reg-failed" /* AnalyticsError.INTEROP_COMPONENT_REG_FAILED */ , {
                reason: e
            });
        }
    }
}
$590ede2df69f5cab$var$registerAnalytics();

});
parcelRegister("ey9Ug", function(module, exports) {

var $bVYHX = parcelRequire("bVYHX");

var $aPEEV = parcelRequire("aPEEV");

var $9k0Bn = parcelRequire("9k0Bn");

var $cCiiD = parcelRequire("cCiiD");
const $a97bece361e5f0c6$var$name = "@firebase/installations";
const $a97bece361e5f0c6$var$version = "0.6.19";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$PENDING_TIMEOUT_MS = 10000;
const $a97bece361e5f0c6$var$PACKAGE_VERSION = `w:${$a97bece361e5f0c6$var$version}`;
const $a97bece361e5f0c6$var$INTERNAL_AUTH_VERSION = 'FIS_v2';
const $a97bece361e5f0c6$var$INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const $a97bece361e5f0c6$var$TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const $a97bece361e5f0c6$var$SERVICE = 'installations';
const $a97bece361e5f0c6$var$SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const $a97bece361e5f0c6$var$ERROR_FACTORY = new (0, $9k0Bn.ErrorFactory)($a97bece361e5f0c6$var$SERVICE, $a97bece361e5f0c6$var$SERVICE_NAME, $a97bece361e5f0c6$var$ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function $a97bece361e5f0c6$var$isServerError(error) {
    return error instanceof (0, $9k0Bn.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a97bece361e5f0c6$var$getInstallationsEndpoint({ projectId: projectId }) {
    return `${$a97bece361e5f0c6$var$INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function $a97bece361e5f0c6$var$extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: $a97bece361e5f0c6$var$getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function $a97bece361e5f0c6$var$getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return $a97bece361e5f0c6$var$ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName: requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function $a97bece361e5f0c6$var$getHeaders({ apiKey: apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function $a97bece361e5f0c6$var$getHeadersWithAuth(appConfig, { refreshToken: refreshToken }) {
    const headers = $a97bece361e5f0c6$var$getHeaders(appConfig);
    headers.append('Authorization', $a97bece361e5f0c6$var$getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function $a97bece361e5f0c6$var$retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function $a97bece361e5f0c6$var$getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function $a97bece361e5f0c6$var$getAuthorizationHeader(refreshToken) {
    return `${$a97bece361e5f0c6$var$INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a97bece361e5f0c6$var$createInstallationRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, { fid: fid }) {
    const endpoint = $a97bece361e5f0c6$var$getInstallationsEndpoint(appConfig);
    const headers = $a97bece361e5f0c6$var$getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid: fid,
        authVersion: $a97bece361e5f0c6$var$INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: $a97bece361e5f0c6$var$PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $a97bece361e5f0c6$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: $a97bece361e5f0c6$var$extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await $a97bece361e5f0c6$var$getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function $a97bece361e5f0c6$var$sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a97bece361e5f0c6$var$bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const $a97bece361e5f0c6$var$INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function $a97bece361e5f0c6$var$generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = $a97bece361e5f0c6$var$encode(fidByteArray);
        return $a97bece361e5f0c6$var$VALID_FID_PATTERN.test(fid) ? fid : $a97bece361e5f0c6$var$INVALID_FID;
    } catch  {
        // FID generation errored
        return $a97bece361e5f0c6$var$INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function $a97bece361e5f0c6$var$encode(fidByteArray) {
    const b64String = $a97bece361e5f0c6$var$bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function $a97bece361e5f0c6$var$getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function $a97bece361e5f0c6$var$fidChanged(appConfig, fid) {
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    $a97bece361e5f0c6$var$callFidChangeCallbacks(key, fid);
    $a97bece361e5f0c6$var$broadcastFidChange(key, fid);
}
function $a97bece361e5f0c6$var$addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    $a97bece361e5f0c6$var$getBroadcastChannel();
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    let callbackSet = $a97bece361e5f0c6$var$fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        $a97bece361e5f0c6$var$fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function $a97bece361e5f0c6$var$removeCallback(appConfig, callback) {
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    const callbackSet = $a97bece361e5f0c6$var$fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) $a97bece361e5f0c6$var$fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    $a97bece361e5f0c6$var$closeBroadcastChannel();
}
function $a97bece361e5f0c6$var$callFidChangeCallbacks(key, fid) {
    const callbacks = $a97bece361e5f0c6$var$fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function $a97bece361e5f0c6$var$broadcastFidChange(key, fid) {
    const channel = $a97bece361e5f0c6$var$getBroadcastChannel();
    if (channel) channel.postMessage({
        key: key,
        fid: fid
    });
    $a97bece361e5f0c6$var$closeBroadcastChannel();
}
let $a97bece361e5f0c6$var$broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function $a97bece361e5f0c6$var$getBroadcastChannel() {
    if (!$a97bece361e5f0c6$var$broadcastChannel && 'BroadcastChannel' in self) {
        $a97bece361e5f0c6$var$broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        $a97bece361e5f0c6$var$broadcastChannel.onmessage = (e)=>{
            $a97bece361e5f0c6$var$callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return $a97bece361e5f0c6$var$broadcastChannel;
}
function $a97bece361e5f0c6$var$closeBroadcastChannel() {
    if ($a97bece361e5f0c6$var$fidChangeCallbacks.size === 0 && $a97bece361e5f0c6$var$broadcastChannel) {
        $a97bece361e5f0c6$var$broadcastChannel.close();
        $a97bece361e5f0c6$var$broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$DATABASE_NAME = 'firebase-installations-database';
const $a97bece361e5f0c6$var$DATABASE_VERSION = 1;
const $a97bece361e5f0c6$var$OBJECT_STORE_NAME = 'firebase-installations-store';
let $a97bece361e5f0c6$var$dbPromise = null;
function $a97bece361e5f0c6$var$getDbPromise() {
    if (!$a97bece361e5f0c6$var$dbPromise) $a97bece361e5f0c6$var$dbPromise = (0, $cCiiD.openDB)($a97bece361e5f0c6$var$DATABASE_NAME, $a97bece361e5f0c6$var$DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($a97bece361e5f0c6$var$OBJECT_STORE_NAME);
            }
        }
    });
    return $a97bece361e5f0c6$var$dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function $a97bece361e5f0c6$var$set(appConfig, value) {
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    const db = await $a97bece361e5f0c6$var$getDbPromise();
    const tx = db.transaction($a97bece361e5f0c6$var$OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore($a97bece361e5f0c6$var$OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) $a97bece361e5f0c6$var$fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function $a97bece361e5f0c6$var$remove(appConfig) {
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    const db = await $a97bece361e5f0c6$var$getDbPromise();
    const tx = db.transaction($a97bece361e5f0c6$var$OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore($a97bece361e5f0c6$var$OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function $a97bece361e5f0c6$var$update(appConfig, updateFn) {
    const key = $a97bece361e5f0c6$var$getKey(appConfig);
    const db = await $a97bece361e5f0c6$var$getDbPromise();
    const tx = db.transaction($a97bece361e5f0c6$var$OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore($a97bece361e5f0c6$var$OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) $a97bece361e5f0c6$var$fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function $a97bece361e5f0c6$var$getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await $a97bece361e5f0c6$var$update(installations.appConfig, (oldEntry)=>{
        const installationEntry = $a97bece361e5f0c6$var$updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = $a97bece361e5f0c6$var$triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === $a97bece361e5f0c6$var$INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry: installationEntry,
        registrationPromise: registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function $a97bece361e5f0c6$var$updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: $a97bece361e5f0c6$var$generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return $a97bece361e5f0c6$var$clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function $a97bece361e5f0c6$var$triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject($a97bece361e5f0c6$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = $a97bece361e5f0c6$var$registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise: registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry: installationEntry,
        registrationPromise: $a97bece361e5f0c6$var$waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry: installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function $a97bece361e5f0c6$var$registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await $a97bece361e5f0c6$var$createInstallationRequest(installations, installationEntry);
        return $a97bece361e5f0c6$var$set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if ($a97bece361e5f0c6$var$isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await $a97bece361e5f0c6$var$remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await $a97bece361e5f0c6$var$set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function $a97bece361e5f0c6$var$waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $a97bece361e5f0c6$var$updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await $a97bece361e5f0c6$var$sleep(100);
        entry = await $a97bece361e5f0c6$var$updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $a97bece361e5f0c6$var$getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function $a97bece361e5f0c6$var$updateInstallationRequest(appConfig) {
    return $a97bece361e5f0c6$var$update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return $a97bece361e5f0c6$var$clearTimedOutRequest(oldEntry);
    });
}
function $a97bece361e5f0c6$var$clearTimedOutRequest(entry) {
    if ($a97bece361e5f0c6$var$hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function $a97bece361e5f0c6$var$hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + $a97bece361e5f0c6$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a97bece361e5f0c6$var$generateAuthTokenRequest({ appConfig: appConfig, heartbeatServiceProvider: heartbeatServiceProvider }, installationEntry) {
    const endpoint = $a97bece361e5f0c6$var$getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = $a97bece361e5f0c6$var$getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: $a97bece361e5f0c6$var$PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body)
    };
    const response = await $a97bece361e5f0c6$var$retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = $a97bece361e5f0c6$var$extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await $a97bece361e5f0c6$var$getErrorFromResponse('Generate Auth Token', response);
}
function $a97bece361e5f0c6$var$getGenerateAuthTokenEndpoint(appConfig, { fid: fid }) {
    return `${$a97bece361e5f0c6$var$getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function $a97bece361e5f0c6$var$refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await $a97bece361e5f0c6$var$update(installations.appConfig, (oldEntry)=>{
        if (!$a97bece361e5f0c6$var$isEntryRegistered(oldEntry)) throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && $a97bece361e5f0c6$var$isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = $a97bece361e5f0c6$var$waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = $a97bece361e5f0c6$var$makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = $a97bece361e5f0c6$var$fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function $a97bece361e5f0c6$var$waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await $a97bece361e5f0c6$var$updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await $a97bece361e5f0c6$var$sleep(100);
        entry = await $a97bece361e5f0c6$var$updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return $a97bece361e5f0c6$var$refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function $a97bece361e5f0c6$var$updateAuthTokenRequest(appConfig) {
    return $a97bece361e5f0c6$var$update(appConfig, (oldEntry)=>{
        if (!$a97bece361e5f0c6$var$isEntryRegistered(oldEntry)) throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if ($a97bece361e5f0c6$var$hasAuthTokenRequestTimedOut(oldAuthToken)) return {
            ...oldEntry,
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        };
        return oldEntry;
    });
}
async function $a97bece361e5f0c6$var$fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await $a97bece361e5f0c6$var$generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = {
            ...installationEntry,
            authToken: authToken
        };
        await $a97bece361e5f0c6$var$set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if ($a97bece361e5f0c6$var$isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await $a97bece361e5f0c6$var$remove(installations.appConfig);
        else {
            const updatedInstallationEntry = {
                ...installationEntry,
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            };
            await $a97bece361e5f0c6$var$set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function $a97bece361e5f0c6$var$isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function $a97bece361e5f0c6$var$isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !$a97bece361e5f0c6$var$isAuthTokenExpired(authToken);
}
function $a97bece361e5f0c6$var$isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + $a97bece361e5f0c6$var$TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function $a97bece361e5f0c6$var$makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return {
        ...oldEntry,
        authToken: inProgressAuthToken
    };
}
function $a97bece361e5f0c6$var$hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + $a97bece361e5f0c6$var$PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $a97bece361e5f0c6$export$218c8c3169c024d2(installations) {
    const installationsImpl = installations;
    const { installationEntry: installationEntry, registrationPromise: registrationPromise } = await $a97bece361e5f0c6$var$getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    $a97bece361e5f0c6$var$refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $a97bece361e5f0c6$export$257b2d10b709d8ef(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await $a97bece361e5f0c6$var$completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await $a97bece361e5f0c6$var$refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function $a97bece361e5f0c6$var$completeInstallationRegistration(installations) {
    const { registrationPromise: registrationPromise } = await $a97bece361e5f0c6$var$getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $a97bece361e5f0c6$var$deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = $a97bece361e5f0c6$var$getDeleteEndpoint(appConfig, installationEntry);
    const headers = $a97bece361e5f0c6$var$getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers: headers
    };
    const response = await $a97bece361e5f0c6$var$retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await $a97bece361e5f0c6$var$getErrorFromResponse('Delete Installation', response);
}
function $a97bece361e5f0c6$var$getDeleteEndpoint(appConfig, { fid: fid }) {
    return `${$a97bece361e5f0c6$var$getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function $a97bece361e5f0c6$export$5f6b87a08674814c(installations) {
    const { appConfig: appConfig } = installations;
    const entry = await $a97bece361e5f0c6$var$update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw $a97bece361e5f0c6$var$ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await $a97bece361e5f0c6$var$deleteInstallationRequest(appConfig, entry);
                await $a97bece361e5f0c6$var$remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function $a97bece361e5f0c6$export$ceb4c11381bc36e8(installations, callback) {
    const { appConfig: appConfig } = installations;
    $a97bece361e5f0c6$var$addCallback(appConfig, callback);
    return ()=>{
        $a97bece361e5f0c6$var$removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function $a97bece361e5f0c6$export$9bfc115e43431ff5(app = (0, $bVYHX.getApp)()) {
    const installationsImpl = (0, $bVYHX._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a97bece361e5f0c6$var$extractAppConfig(app) {
    if (!app || !app.options) throw $a97bece361e5f0c6$var$getMissingValueError('App Configuration');
    if (!app.name) throw $a97bece361e5f0c6$var$getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw $a97bece361e5f0c6$var$getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function $a97bece361e5f0c6$var$getMissingValueError(valueName) {
    return $a97bece361e5f0c6$var$ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName: valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a97bece361e5f0c6$var$INSTALLATIONS_NAME = 'installations';
const $a97bece361e5f0c6$var$INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const $a97bece361e5f0c6$var$publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = $a97bece361e5f0c6$var$extractAppConfig(app);
    const heartbeatServiceProvider = (0, $bVYHX._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const $a97bece361e5f0c6$var$internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, $bVYHX._getProvider)(app, $a97bece361e5f0c6$var$INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>$a97bece361e5f0c6$export$218c8c3169c024d2(installations),
        getToken: (forceRefresh)=>$a97bece361e5f0c6$export$257b2d10b709d8ef(installations, forceRefresh)
    };
    return installationsInternal;
};
function $a97bece361e5f0c6$var$registerInstallations() {
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)($a97bece361e5f0c6$var$INSTALLATIONS_NAME, $a97bece361e5f0c6$var$publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)($a97bece361e5f0c6$var$INSTALLATIONS_NAME_INTERNAL, $a97bece361e5f0c6$var$internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ $a97bece361e5f0c6$var$registerInstallations();
(0, $bVYHX.registerVersion)($a97bece361e5f0c6$var$name, $a97bece361e5f0c6$var$version);
// BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
(0, $bVYHX.registerVersion)($a97bece361e5f0c6$var$name, $a97bece361e5f0c6$var$version, 'esm2020');

});




parcelRegister("ftYLF", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return (parcelRequire("4GiHF")).a6; });
$parcel$export(module.exports, "getDoc", function () { return (parcelRequire("75ECW")).getDoc; });
$parcel$export(module.exports, "getFirestore", function () { return (parcelRequire("4GiHF")).aX; });
$parcel$export(module.exports, "serverTimestamp", function () { return (parcelRequire("4GiHF")).a$; });
$parcel$export(module.exports, "setDoc", function () { return (parcelRequire("75ECW")).setDoc; });
parcelRequire("75ECW");

});
parcelRegister("75ECW", function(module, exports) {

$parcel$export(module.exports, "getDoc", function () { return $529883be61c2f116$export$11eb3b5ef9574821; });
$parcel$export(module.exports, "setDoc", function () { return $529883be61c2f116$export$5ff77ddaff3c9e12; });
$parcel$export(module.exports, "doc", function () { return (parcelRequire("4GiHF")).a6; });
$parcel$export(module.exports, "getFirestore", function () { return (parcelRequire("4GiHF")).aX; });
$parcel$export(module.exports, "serverTimestamp", function () { return (parcelRequire("4GiHF")).a$; });

var $bVYHX = parcelRequire("bVYHX");

var $aPEEV = parcelRequire("aPEEV");

var $4GiHF = parcelRequire("4GiHF");

var $9k0Bn = parcelRequire("9k0Bn");
parcelRequire("3Hs2j");
parcelRequire("6mnY8");
parcelRequire("9Necc");
const $529883be61c2f116$var$Ut = "@firebase/firestore", $529883be61c2f116$var$Ht = "4.11.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $529883be61c2f116$var$__PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $529883be61c2f116$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $529883be61c2f116$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, $4GiHF.O)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $529883be61c2f116$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, $4GiHF.D)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $529883be61c2f116$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, $4GiHF.i)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $529883be61c2f116$var$QueryDocumentSnapshot$1 extends $529883be61c2f116$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $529883be61c2f116$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, $4GiHF.d)((0, $4GiHF.C).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $529883be61c2f116$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $529883be61c2f116$export$b0e86f2c7431df4e extends $529883be61c2f116$var$AppliableConstraint {
}
function $529883be61c2f116$export$2fa187e846a241c4(t, e, ...n) {
    let r = [];
    e instanceof $529883be61c2f116$var$AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $529883be61c2f116$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $529883be61c2f116$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $529883be61c2f116$export$f765fc5789dfd439 extends $529883be61c2f116$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $529883be61c2f116$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $529883be61c2f116$var$__PRIVATE_validateNewFieldFilter(t._query, e), new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.e)(t._query, e));
    }
    _parse(t) {
        const e = (0, $4GiHF.f)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s, a, o) {
            let i;
            if (s.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
                if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                    $529883be61c2f116$var$__PRIVATE_validateDisjunctiveFilterElements(o, a);
                    const e = [];
                    for (const n of o)e.push($529883be61c2f116$var$__PRIVATE_parseDocumentIdValue(r, t, n));
                    i = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else i = $529883be61c2f116$var$__PRIVATE_parseDocumentIdValue(r, t, o);
            } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || $529883be61c2f116$var$__PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, $4GiHF.g)(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
            const u = (0, $4GiHF.h).create(s, a, i);
            return u;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $529883be61c2f116$export$9c59b80dda569a6e(t, e, n) {
    const r = e, s = (0, $4GiHF.i)("where", t);
    return $529883be61c2f116$export$f765fc5789dfd439._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $529883be61c2f116$export$6bbc7aef0717f3d2 extends $529883be61c2f116$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $529883be61c2f116$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, $4GiHF.j).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)$529883be61c2f116$var$__PRIVATE_validateNewFieldFilter(n, t), n = (0, $4GiHF.e)(n, t);
        }(t._query, e), new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.e)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $529883be61c2f116$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$529883be61c2f116$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $529883be61c2f116$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $529883be61c2f116$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$529883be61c2f116$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $529883be61c2f116$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $529883be61c2f116$export$65a9ba8bbd6ed9e3 extends $529883be61c2f116$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $529883be61c2f116$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, $4GiHF.an)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.k)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $529883be61c2f116$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, r = (0, $4GiHF.i)("orderBy", t);
    return $529883be61c2f116$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $529883be61c2f116$export$49bb5356ca788047 extends $529883be61c2f116$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $529883be61c2f116$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.l)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $529883be61c2f116$export$ee37e834aaad6f7e(t) {
    return (0, $4GiHF.m)("limit", t), $529883be61c2f116$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $529883be61c2f116$export$f823b3589f69d3b8(t) {
    return (0, $4GiHF.m)("limitToLast", t), $529883be61c2f116$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $529883be61c2f116$export$d92e2830aca1d816 extends $529883be61c2f116$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $529883be61c2f116$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $529883be61c2f116$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.n)(t._query, e));
    }
}
function $529883be61c2f116$export$859941c5fc8eba6b(...t) {
    return $529883be61c2f116$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $529883be61c2f116$export$dd8dee5f7b804673(...t) {
    return $529883be61c2f116$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $529883be61c2f116$export$fd1782fd870d1e06 extends $529883be61c2f116$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $529883be61c2f116$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $529883be61c2f116$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $4GiHF.Q)(t.firestore, t.converter, (0, $4GiHF.o)(t._query, e));
    }
}
function $529883be61c2f116$export$57203950645b8b11(...t) {
    return $529883be61c2f116$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $529883be61c2f116$export$28ec54a8428bdb3f(...t) {
    return $529883be61c2f116$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $529883be61c2f116$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, $9k0Bn.getModularInstance)(n[0]), n[0] instanceof $529883be61c2f116$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s) {
        if (!r) throw new (0, $4GiHF.d)((0, $4GiHF.C).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const a = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, $4GiHF.q)(t))if (n.field.isKeyField()) a.push((0, $4GiHF.r)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, $4GiHF.s)(t)) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            a.push(t);
        }
        return new (0, $4GiHF.t)(a, s);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s = (0, $4GiHF.f)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (s.length > o.length) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const i = [];
            for(let a = 0; a < s.length; a++){
                const u = s[a];
                if (o[a].field.isKeyField()) {
                    if ("string" != typeof u) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof u}`);
                    if (!(0, $4GiHF.u)(t) && -1 !== u.indexOf("/")) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${u}' contains a slash.`);
                    const n = t.path.child((0, $4GiHF.R).fromString(u));
                    if (!(0, $4GiHF.v).isDocumentKey(n)) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s = new (0, $4GiHF.v)(n);
                    i.push((0, $4GiHF.r)(e, s));
                } else {
                    const t = (0, $4GiHF.g)(n, r, u);
                    i.push(t);
                }
            }
            return new (0, $4GiHF.t)(i, a);
        }(t._query, t.firestore._databaseId, s, e, n, r);
    }
}
function $529883be61c2f116$var$__PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, $9k0Bn.getModularInstance)(n))) {
        if ("" === n) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $4GiHF.u)(e) && -1 !== n.indexOf("/")) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, $4GiHF.R).fromString(n));
        if (!(0, $4GiHF.v).isDocumentKey(r)) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, $4GiHF.r)(t, new (0, $4GiHF.v)(r));
    }
    if (n instanceof (0, $4GiHF.D)) return (0, $4GiHF.r)(t, n._key);
    throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, $4GiHF.w)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $529883be61c2f116$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $529883be61c2f116$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $529883be61c2f116$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $529883be61c2f116$export$f765fc5789dfd439 || e instanceof $529883be61c2f116$export$6bbc7aef0717f3d2)) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function $529883be61c2f116$var$__PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class $529883be61c2f116$var$__PRIVATE_LiteUserDataWriter extends (0, $4GiHF.A) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, $4GiHF.B)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, $4GiHF.D)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function $529883be61c2f116$export$8a63f25cc62965f1(t) {
    return new $529883be61c2f116$export$fada2345be8928cf("sum", (0, $4GiHF.i)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function $529883be61c2f116$export$cc6710ee5f037d57(t) {
    return new $529883be61c2f116$export$fada2345be8928cf("avg", (0, $4GiHF.i)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $529883be61c2f116$export$85b9a36db797e02b() {
    return new $529883be61c2f116$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function $529883be61c2f116$export$31fa8ec66e0239ad(t, e) {
    return t instanceof $529883be61c2f116$export$fada2345be8928cf && e instanceof $529883be61c2f116$export$fada2345be8928cf && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $529883be61c2f116$export$104f59389a332076(t, e) {
    return (0, $4GiHF.x)(t.query, e.query) && (0, $9k0Bn.deepEqual)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $529883be61c2f116$export$b1de1b12889d0afb(t) {
    return $529883be61c2f116$export$a51511de2fae49b3(t, {
        count: $529883be61c2f116$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $529883be61c2f116$export$a51511de2fae49b3(t, e) {
    const n = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), r = (0, $4GiHF.z)(n), s = (0, $4GiHF.E)(e, (t, e)=>new (0, $4GiHF.ao)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, $4GiHF.G)(r, t._query, s).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, $4GiHF.H)(t), s = new $529883be61c2f116$export$40257fef64be808b(e, r, n);
            return s;
        })(n, t, e));
}
class $529883be61c2f116$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, $4GiHF.ap).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, $4GiHF.aq)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $529883be61c2f116$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $529883be61c2f116$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $529883be61c2f116$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $4GiHF.ar).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $529883be61c2f116$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, $4GiHF.aq)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $529883be61c2f116$export$574728f3be606189() {
    return new $529883be61c2f116$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $529883be61c2f116$export$2340f88905cc0c23(t) {
    return new $529883be61c2f116$var$__PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $529883be61c2f116$export$72ef71adb739a32c(t) {
    return new $529883be61c2f116$var$__PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $529883be61c2f116$export$51b321e43d5331d5(t) {
    return new $529883be61c2f116$var$__PRIVATE_PersistentLocalCacheImpl(t);
}
class $529883be61c2f116$var$__PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $4GiHF.ap).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $4GiHF.as)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $529883be61c2f116$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $4GiHF.ap).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $4GiHF.at)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function $529883be61c2f116$export$d5f96a3c009e86ac(t) {
    return new $529883be61c2f116$var$__PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $529883be61c2f116$export$57e9d290b0b4dc04() {
    return new $529883be61c2f116$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $529883be61c2f116$var$zt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $529883be61c2f116$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $529883be61c2f116$export$acab0e6ef25eb301 extends $529883be61c2f116$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, a){
        super(t, e, n, r, a), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $529883be61c2f116$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, $4GiHF.i)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $4GiHF.d)((0, $4GiHF.C).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = $529883be61c2f116$export$acab0e6ef25eb301._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function $529883be61c2f116$export$bbac1bdeb8972634(t, e, n) {
    if ((0, $4GiHF.I)(e, $529883be61c2f116$export$acab0e6ef25eb301._jsonSchema)) {
        if (e.bundle === $529883be61c2f116$var$zt) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $4GiHF.J)(t._databaseId), s = (0, $4GiHF.K)(e.bundle, r), a = s.t(), o = new (0, $4GiHF.L)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        // Ensure that we have the correct number of documents in the bundle.
        const i = o.documents;
        if (1 !== i.length) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${i.length} documents.`);
        // Build out the internal document data.
        const u = (0, $4GiHF.M)(r, i[0].document), c = new (0, $4GiHF.v)((0, $4GiHF.R).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $529883be61c2f116$export$acab0e6ef25eb301(t, new $529883be61c2f116$var$__PRIVATE_LiteUserDataWriter(t), c, u, new $529883be61c2f116$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $529883be61c2f116$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $529883be61c2f116$export$acab0e6ef25eb301._jsonSchema = {
    type: (0, $4GiHF.p)("string", $529883be61c2f116$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: (0, $4GiHF.p)("string", "DocumentSnapshot"),
    bundleName: (0, $4GiHF.p)("string"),
    bundle: (0, $4GiHF.p)("string")
};
class $529883be61c2f116$export$6d4d04e42af6b03c extends $529883be61c2f116$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $529883be61c2f116$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $529883be61c2f116$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $529883be61c2f116$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $529883be61c2f116$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    const r = new $529883be61c2f116$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $529883be61c2f116$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new $529883be61c2f116$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $529883be61c2f116$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, a = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), a = n.indexOf(e.doc.key)), {
                        type: $529883be61c2f116$var$__PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: a
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $4GiHF.d)((0, $4GiHF.C).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = $529883be61c2f116$export$8f21149d8133945c._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, $4GiHF.N).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function $529883be61c2f116$export$5bed7af38da9d026(t, e, n) {
    if ((0, $4GiHF.I)(e, $529883be61c2f116$export$8f21149d8133945c._jsonSchema)) {
        if (e.bundle === $529883be61c2f116$var$zt) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $4GiHF.J)(t._databaseId), s = (0, $4GiHF.K)(e.bundle, r), a = s.t(), o = new (0, $4GiHF.L)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        if (1 !== o.queries.length) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const i = (0, $4GiHF.P)(o.queries[0].bundledQuery), u = o.documents;
        // Construct the arrays of document data for the query.
        let c = new (0, $4GiHF.S);
        u.map((t)=>{
            const e = (0, $4GiHF.M)(r, t.document);
            c = c.add(e);
        });
        // Create a view snapshot of the query and documents.
        const l = (0, $4GiHF.V).fromInitialDocuments(i, c, (0, $4GiHF.T)(), /* fromCache= */ !1, /* hasCachedResults= */ !1), h = new (0, $4GiHF.Q)(t, n || null, i);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $529883be61c2f116$export$8f21149d8133945c(t, new $529883be61c2f116$var$__PRIVATE_LiteUserDataWriter(t), h, l);
    }
}
function $529883be61c2f116$var$__PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, $4GiHF.U)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $529883be61c2f116$export$f243a5d948512846(t, e) {
    return t instanceof $529883be61c2f116$export$acab0e6ef25eb301 && e instanceof $529883be61c2f116$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $529883be61c2f116$export$8f21149d8133945c && e instanceof $529883be61c2f116$export$8f21149d8133945c && t._firestore === e._firestore && (0, $4GiHF.x)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $529883be61c2f116$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $529883be61c2f116$export$8f21149d8133945c._jsonSchema = {
    type: (0, $4GiHF.p)("string", $529883be61c2f116$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: (0, $4GiHF.p)("string", "QuerySnapshot"),
    bundleName: (0, $4GiHF.p)("string"),
    bundle: (0, $4GiHF.p)("string")
};
const $529883be61c2f116$var$Yt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $529883be61c2f116$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = (0, $4GiHF.f)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore), s = $529883be61c2f116$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $4GiHF.W)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(a.toMutation(r._key, (0, $4GiHF.X).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $9k0Bn.getModularInstance)(e)) || e instanceof (0, $4GiHF.Y) ? (0, $4GiHF.Z)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, $4GiHF.$)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(a.toMutation(s._key, (0, $4GiHF.X).exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, $4GiHF.a0)(e._key, (0, $4GiHF.X).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, $4GiHF.d)((0, $4GiHF.C).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $529883be61c2f116$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $9k0Bn.getModularInstance)(t)).firestore !== e) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $529883be61c2f116$var$Transaction$1 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, $4GiHF.f)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore), n = new $529883be61c2f116$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, $4GiHF.U)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new $529883be61c2f116$var$DocumentSnapshot$1(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new $529883be61c2f116$var$DocumentSnapshot$1(this._firestore, n, e._key, null, e.converter);
            throw (0, $4GiHF.U)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore), s = $529883be61c2f116$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $4GiHF.W)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, a), this;
    }
    update(t, e, n, ...r) {
        const s = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $9k0Bn.getModularInstance)(e)) || e instanceof (0, $4GiHF.Y) ? (0, $4GiHF.Z)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, $4GiHF.$)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, a), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $529883be61c2f116$export$febc5573c75cefb0 extends $529883be61c2f116$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $529883be61c2f116$var$__PRIVATE_validateReference(t, this._firestore), n = new (0, $4GiHF.H)(this._firestore);
        return super.get(t).then((t)=>new $529883be61c2f116$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $529883be61c2f116$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $529883be61c2f116$export$3c54e006bf9c93b7(t, e, n) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.F));
    const r = {
        ...$529883be61c2f116$var$Yt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const s = (0, $4GiHF.z)(t);
    return (0, $4GiHF.a1)(s, (n)=>e(new $529883be61c2f116$export$febc5573c75cefb0(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $529883be61c2f116$export$11eb3b5ef9574821(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.D));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e);
    return (0, $4GiHF.a2)(n, t._key).then((n)=>$529883be61c2f116$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $529883be61c2f116$export$a58bd92642f7fb58(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.D));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e), r = new (0, $4GiHF.H)(e);
    return (0, $4GiHF.a3)(n, t._key).then((n)=>new $529883be61c2f116$export$acab0e6ef25eb301(e, r, t._key, n, new $529883be61c2f116$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $529883be61c2f116$export$35dd759aed9686b4(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.D));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e);
    return (0, $4GiHF.a2)(n, t._key, {
        source: "server"
    }).then((n)=>$529883be61c2f116$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $529883be61c2f116$export$81d3477bd73c86ef(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.Q));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e), r = new (0, $4GiHF.H)(e);
    return $529883be61c2f116$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, $4GiHF.a4)(n, t._query).then((n)=>new $529883be61c2f116$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $529883be61c2f116$export$3fd010f18eac1dd(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.Q));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e), r = new (0, $4GiHF.H)(e);
    return (0, $4GiHF.a5)(n, t._query).then((n)=>new $529883be61c2f116$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $529883be61c2f116$export$ec7d9e44f349c77b(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.Q));
    const e = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), n = (0, $4GiHF.z)(e), r = new (0, $4GiHF.H)(e);
    return (0, $4GiHF.a4)(n, t._query, {
        source: "server"
    }).then((n)=>new $529883be61c2f116$export$8f21149d8133945c(e, r, t, n));
}
function $529883be61c2f116$export$5ff77ddaff3c9e12(t, e, n) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.D));
    const r = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), s = $529883be61c2f116$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e, n), o = (0, $4GiHF.f)(r);
    return $529883be61c2f116$export$1945f8fec9dda613(r, [
        (0, $4GiHF.W)(o, "setDoc", t._key, s, null !== t.converter, n).toMutation(t._key, (0, $4GiHF.X).none())
    ]);
}
function $529883be61c2f116$export$22d1fdd1e73faff2(t, e, n, ...r) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.D));
    const s = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), o = (0, $4GiHF.f)(s);
    let i;
    i = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $9k0Bn.getModularInstance)(e)) || e instanceof (0, $4GiHF.Y) ? (0, $4GiHF.Z)(o, "updateDoc", t._key, e, n, r) : (0, $4GiHF.$)(o, "updateDoc", t._key, e);
    return $529883be61c2f116$export$1945f8fec9dda613(s, [
        i.toMutation(t._key, (0, $4GiHF.X).exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $529883be61c2f116$export$a4f20481fae8f78b(t) {
    return $529883be61c2f116$export$1945f8fec9dda613((0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), [
        new (0, $4GiHF.a0)(t._key, (0, $4GiHF.X).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $529883be61c2f116$export$a13890143fb1c2dd(t, e) {
    const n = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), r = (0, $4GiHF.a6)(t), s = $529883be61c2f116$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), o = (0, $4GiHF.f)(t.firestore);
    return $529883be61c2f116$export$1945f8fec9dda613(n, [
        (0, $4GiHF.W)(o, "addDoc", r._key, s, null !== t.converter, {}).toMutation(r._key, (0, $4GiHF.X).exists(!1))
    ]).then(()=>r);
}
function $529883be61c2f116$export$d36370812fb26935(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, $9k0Bn.getModularInstance)(t);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || $529883be61c2f116$var$__PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($529883be61c2f116$var$__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let o, i, u;
    if (t instanceof (0, $4GiHF.D)) i = (0, $4GiHF.y)(t.firestore, (0, $4GiHF.F)), u = (0, $4GiHF.a7)(t._key.path), o = {
        next: (n)=>{
            e[r] && e[r]($529883be61c2f116$var$__PRIVATE_convertToDocSnapshot(i, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, $4GiHF.y)(t, (0, $4GiHF.Q));
        i = (0, $4GiHF.y)(n.firestore, (0, $4GiHF.F)), u = n._query;
        const s = new (0, $4GiHF.H)(i);
        o = {
            next: (t)=>{
                e[r] && e[r](new $529883be61c2f116$export$8f21149d8133945c(i, s, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, $529883be61c2f116$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const c = (0, $4GiHF.z)(i);
    return (0, $4GiHF.a8)(c, u, s, o);
}
function $529883be61c2f116$export$a1ef90ed3b4a87fa(t, e, ...n) {
    const r = (0, $9k0Bn.getModularInstance)(t), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s.error) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, s.error);
    let a, o = 0;
    if ("object" != typeof n[o] || $529883be61c2f116$var$__PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $529883be61c2f116$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $4GiHF.a9)(t, e.bundle);
            return i.then(()=>(0, $4GiHF.aa)(t, e.bundleName)).then((t)=>{
                if (t && !o) s && t.withConverter(s), a = $529883be61c2f116$export$d36370812fb26935(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $529883be61c2f116$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $4GiHF.a9)(t, e.bundle);
            return i.then(()=>{
                if (!o) {
                    const o = new (0, $4GiHF.D)(t, s || null, (0, $4GiHF.v).fromPath(e.bundleName));
                    a = $529883be61c2f116$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, `unsupported bundle source: ${s.bundleSource}`);
}
function $529883be61c2f116$export$9dff4f5aba83e348(t, e) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.F));
    const n = (0, $4GiHF.z)(t), r = $529883be61c2f116$var$__PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, $4GiHF.ab)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $529883be61c2f116$export$1945f8fec9dda613(t, e) {
    const n = (0, $4GiHF.z)(t);
    return (0, $4GiHF.ac)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $529883be61c2f116$var$__PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, $4GiHF.H)(t);
    return new $529883be61c2f116$export$acab0e6ef25eb301(t, s, e._key, r, new $529883be61c2f116$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
function $529883be61c2f116$export$44cd1c9d57edd9b1(t) {
    return t = (0, $4GiHF.y)(t, (0, $4GiHF.F)), (0, $4GiHF.z)(t), new $529883be61c2f116$export$d94ed661b1cfd435(t, (e)=>$529883be61c2f116$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $529883be61c2f116$export$ff1663c0c1304f1a(t, e) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.F));
    const n = (0, $4GiHF.z)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $4GiHF.ad)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $529883be61c2f116$var$__PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $529883be61c2f116$var$__PRIVATE_tryGetString(e, "fieldPath"), n = (0, $4GiHF.ae)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, $4GiHF.af)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, $4GiHF.af)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, $4GiHF.af)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, $4GiHF.ag)((0, $4GiHF.ag).UNKNOWN_ID, e, r, (0, $4GiHF.ah).empty()));
        }
        return n;
    }(e);
    return (0, $4GiHF.ai)(n, r);
}
function $529883be61c2f116$var$__PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, $4GiHF.d)((0, $4GiHF.C).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $529883be61c2f116$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $529883be61c2f116$export$61c6347b57bdfa06(t) {
    t = (0, $4GiHF.y)(t, (0, $4GiHF.F));
    const e = $529883be61c2f116$var$Kt.get(t);
    if (e) return e;
    const n = (0, $4GiHF.z)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $529883be61c2f116$export$cf4db3c220e88bd8(t);
    return $529883be61c2f116$var$Kt.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $529883be61c2f116$export$9b2c0a7aacbcd151(t) {
    $529883be61c2f116$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $529883be61c2f116$export$5b460d5f48076743(t) {
    $529883be61c2f116$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $529883be61c2f116$export$72809fc2fc5083d5(t) {
    const e = (0, $4GiHF.z)(t._firestore);
    (0, $4GiHF.aj)(e).then((t)=>(0, $4GiHF.ak)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, $4GiHF.ad)("deleting all persistent cache indexes failed", t));
}
function $529883be61c2f116$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, $4GiHF.z)(t._firestore);
    (0, $4GiHF.al)(n, e).then((t)=>(0, $4GiHF.ak)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, $4GiHF.ad)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $529883be61c2f116$var$Kt = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $529883be61c2f116$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return $529883be61c2f116$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $529883be61c2f116$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.i = new Map;
    }
    static get instance() {
        return $529883be61c2f116$var$Xt || ($529883be61c2f116$var$Xt = new $529883be61c2f116$var$__PRIVATE_TestingHooksSpiImpl, (0, $4GiHF.am)($529883be61c2f116$var$Xt)), $529883be61c2f116$var$Xt;
    }
    u(t) {
        this.i.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.i;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let $529883be61c2f116$var$Xt = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(u, l = !0) {
    (0, $4GiHF._)((0, $bVYHX.SDK_VERSION)), (0, $bVYHX._registerComponent)(new (0, $aPEEV.Component)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), s = new (0, $4GiHF.F)(new (0, $4GiHF.a)(t.getProvider("auth-internal")), new (0, $4GiHF.b)(r, t.getProvider("app-check-internal")), (0, $4GiHF.c)(r, e), r);
        return n = {
            useFetchStreams: l,
            ...n
        }, s._setSettings(n), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $bVYHX.registerVersion)($529883be61c2f116$var$Ut, $529883be61c2f116$var$Ht, u), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $bVYHX.registerVersion)($529883be61c2f116$var$Ut, $529883be61c2f116$var$Ht, "esm2020");
}();

});
parcelRegister("4GiHF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $368997c7fea60e4e$export$71511d61b312f219; });
$parcel$export(module.exports, "ak", function () { return $368997c7fea60e4e$export$21579262ef46735b; });
$parcel$export(module.exports, "ad", function () { return $368997c7fea60e4e$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "U", function () { return $368997c7fea60e4e$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "C", function () { return $368997c7fea60e4e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "d", function () { return $368997c7fea60e4e$export$4368d992c4eafac0; });
$parcel$export(module.exports, "a", function () { return $368997c7fea60e4e$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $368997c7fea60e4e$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "N", function () { return $368997c7fea60e4e$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "R", function () { return $368997c7fea60e4e$export$db202ddc8be9136; });
$parcel$export(module.exports, "v", function () { return $368997c7fea60e4e$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $368997c7fea60e4e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "y", function () { return $368997c7fea60e4e$export$4a5767248b18ef41; });
$parcel$export(module.exports, "m", function () { return $368997c7fea60e4e$export$953cecd6e717a553; });
$parcel$export(module.exports, "p", function () { return $368997c7fea60e4e$export$ffb5f4729a158638; });
$parcel$export(module.exports, "I", function () { return $368997c7fea60e4e$export$9bb611d729802a56; });
$parcel$export(module.exports, "ag", function () { return $368997c7fea60e4e$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "af", function () { return $368997c7fea60e4e$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "ah", function () { return $368997c7fea60e4e$export$995eb9fca571757; });
$parcel$export(module.exports, "E", function () { return $368997c7fea60e4e$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "s", function () { return $368997c7fea60e4e$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $368997c7fea60e4e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "r", function () { return $368997c7fea60e4e$export$43caf9889c228507; });
$parcel$export(module.exports, "O", function () { return $368997c7fea60e4e$export$c4ce752e73470fba; });
$parcel$export(module.exports, "t", function () { return $368997c7fea60e4e$export$625550452a3fa3ec; });
$parcel$export(module.exports, "an", function () { return $368997c7fea60e4e$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "h", function () { return $368997c7fea60e4e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "j", function () { return $368997c7fea60e4e$export$35e795649ee09318; });
$parcel$export(module.exports, "a7", function () { return $368997c7fea60e4e$export$a93c5207d687da10; });
$parcel$export(module.exports, "u", function () { return $368997c7fea60e4e$export$3b14a55fb2447963; });
$parcel$export(module.exports, "q", function () { return $368997c7fea60e4e$export$9e5f44173e64f162; });
$parcel$export(module.exports, "e", function () { return $368997c7fea60e4e$export$f1e1789686576879; });
$parcel$export(module.exports, "k", function () { return $368997c7fea60e4e$export$342063e11d6c3cad; });
$parcel$export(module.exports, "l", function () { return $368997c7fea60e4e$export$882b5998b3b9117c; });
$parcel$export(module.exports, "n", function () { return $368997c7fea60e4e$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "o", function () { return $368997c7fea60e4e$export$ae1af26003f05816; });
$parcel$export(module.exports, "T", function () { return $368997c7fea60e4e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "X", function () { return $368997c7fea60e4e$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a0", function () { return $368997c7fea60e4e$export$34aec0b863436764; });
$parcel$export(module.exports, "ao", function () { return $368997c7fea60e4e$export$7a38258bbe170828; });
$parcel$export(module.exports, "am", function () { return $368997c7fea60e4e$export$1a82df3d29112e01; });
$parcel$export(module.exports, "M", function () { return $368997c7fea60e4e$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "P", function () { return $368997c7fea60e4e$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "J", function () { return $368997c7fea60e4e$export$b4171a6734a65d42; });
$parcel$export(module.exports, "S", function () { return $368997c7fea60e4e$export$25ce5a424b770e84; });
$parcel$export(module.exports, "V", function () { return $368997c7fea60e4e$export$e7c866399fa523f5; });
$parcel$export(module.exports, "L", function () { return $368997c7fea60e4e$export$61196ced6d74a310; });
$parcel$export(module.exports, "ar", function () { return $368997c7fea60e4e$export$d24c54395ce0c509; });
$parcel$export(module.exports, "aq", function () { return $368997c7fea60e4e$export$8a5498727ef6be21; });
$parcel$export(module.exports, "as", function () { return $368997c7fea60e4e$export$6554612db691658e; });
$parcel$export(module.exports, "at", function () { return $368997c7fea60e4e$export$493d36ec626b6698; });
$parcel$export(module.exports, "ap", function () { return $368997c7fea60e4e$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "a8", function () { return $368997c7fea60e4e$export$c3950d9923825c02; });
$parcel$export(module.exports, "a3", function () { return $368997c7fea60e4e$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a2", function () { return $368997c7fea60e4e$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "a5", function () { return $368997c7fea60e4e$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "a4", function () { return $368997c7fea60e4e$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "G", function () { return $368997c7fea60e4e$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ac", function () { return $368997c7fea60e4e$export$2219238a014317b0; });
$parcel$export(module.exports, "ab", function () { return $368997c7fea60e4e$export$555508cbc6add439; });
$parcel$export(module.exports, "a1", function () { return $368997c7fea60e4e$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "K", function () { return $368997c7fea60e4e$export$3466f893ebf79586; });
$parcel$export(module.exports, "ai", function () { return $368997c7fea60e4e$export$f38c853ae54ed474; });
$parcel$export(module.exports, "al", function () { return $368997c7fea60e4e$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "aj", function () { return $368997c7fea60e4e$export$3b513254972cfc9c; });
$parcel$export(module.exports, "Q", function () { return $368997c7fea60e4e$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "D", function () { return $368997c7fea60e4e$export$96f57966bedc81b4; });
$parcel$export(module.exports, "a6", function () { return $368997c7fea60e4e$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "x", function () { return $368997c7fea60e4e$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "F", function () { return $368997c7fea60e4e$export$d66501df72047452; });
$parcel$export(module.exports, "aX", function () { return $368997c7fea60e4e$export$1a8f5705751d8277; });
$parcel$export(module.exports, "z", function () { return $368997c7fea60e4e$export$df995fae86a55f06; });
$parcel$export(module.exports, "a9", function () { return $368997c7fea60e4e$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "aa", function () { return $368997c7fea60e4e$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "B", function () { return $368997c7fea60e4e$export$ef35774e6d314e91; });
$parcel$export(module.exports, "Y", function () { return $368997c7fea60e4e$export$8743009a87fcb00f; });
$parcel$export(module.exports, "f", function () { return $368997c7fea60e4e$export$2d1720544b23b823; });
$parcel$export(module.exports, "W", function () { return $368997c7fea60e4e$export$71cec2538cb2c617; });
$parcel$export(module.exports, "i", function () { return $368997c7fea60e4e$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "$", function () { return $368997c7fea60e4e$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "ae", function () { return $368997c7fea60e4e$export$f787f51d84a910ad; });
$parcel$export(module.exports, "Z", function () { return $368997c7fea60e4e$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "g", function () { return $368997c7fea60e4e$export$39b482c5e57630a8; });
$parcel$export(module.exports, "A", function () { return $368997c7fea60e4e$export$ebd11618f299a286; });
$parcel$export(module.exports, "H", function () { return $368997c7fea60e4e$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "a$", function () { return $368997c7fea60e4e$export$fef3dfd9bad05307; });

var $bVYHX = parcelRequire("bVYHX");

var $9k0Bn = parcelRequire("9k0Bn");

var $3Hs2j = parcelRequire("3Hs2j");

var $6mnY8 = parcelRequire("6mnY8");

var $9Necc = parcelRequire("9Necc");

var $ihoyg = parcelRequire("ihoyg");
var $368997c7fea60e4e$require$Buffer = $ihoyg.Buffer;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $368997c7fea60e4e$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $368997c7fea60e4e$var$User.UNAUTHENTICATED = new $368997c7fea60e4e$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$368997c7fea60e4e$var$User.GOOGLE_CREDENTIALS = new $368997c7fea60e4e$var$User("google-credentials-uid"), $368997c7fea60e4e$var$User.FIRST_PARTY = new $368997c7fea60e4e$var$User("first-party-uid"), $368997c7fea60e4e$var$User.MOCK_USER = new $368997c7fea60e4e$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $368997c7fea60e4e$var$S = "12.9.0";
function $368997c7fea60e4e$export$71511d61b312f219(e) {
    $368997c7fea60e4e$var$S = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$D = new (0, $6mnY8.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $368997c7fea60e4e$var$__PRIVATE_getLogLevel() {
    return $368997c7fea60e4e$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $368997c7fea60e4e$export$8c78c7c36408ea29(e) {
    $368997c7fea60e4e$var$D.setLogLevel(e);
}
function $368997c7fea60e4e$export$21579262ef46735b(e, ...t) {
    if ($368997c7fea60e4e$var$D.logLevel <= (0, $6mnY8.LogLevel).DEBUG) {
        const n = t.map($368997c7fea60e4e$var$__PRIVATE_argToString);
        $368997c7fea60e4e$var$D.debug(`Firestore (${$368997c7fea60e4e$var$S}): ${e}`, ...n);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_logError(e, ...t) {
    if ($368997c7fea60e4e$var$D.logLevel <= (0, $6mnY8.LogLevel).ERROR) {
        const n = t.map($368997c7fea60e4e$var$__PRIVATE_argToString);
        $368997c7fea60e4e$var$D.error(`Firestore (${$368997c7fea60e4e$var$S}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $368997c7fea60e4e$export$4c3d22f3d993c33f(e, ...t) {
    if ($368997c7fea60e4e$var$D.logLevel <= (0, $6mnY8.LogLevel).WARN) {
        const n = t.map($368997c7fea60e4e$var$__PRIVATE_argToString);
        $368997c7fea60e4e$var$D.warn(`Firestore (${$368997c7fea60e4e$var$S}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $368997c7fea60e4e$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $368997c7fea60e4e$export$3a6d5c9ae78a2c08(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $368997c7fea60e4e$var$__PRIVATE__fail(e, r, n);
}
function $368997c7fea60e4e$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$368997c7fea60e4e$var$S}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $368997c7fea60e4e$var$__PRIVATE_logError(r), new Error(r);
}
function $368997c7fea60e4e$export$c18d01048907ea92(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $368997c7fea60e4e$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $368997c7fea60e4e$export$53a70dd1ebbae346(e, t) {
    e || $368997c7fea60e4e$export$3a6d5c9ae78a2c08(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $368997c7fea60e4e$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$export$e7094788287c5e9b = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $368997c7fea60e4e$export$4368d992c4eafac0 extends (0, $9k0Bn.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $368997c7fea60e4e$export$158acd800e1ef08b {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($368997c7fea60e4e$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $368997c7fea60e4e$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $368997c7fea60e4e$export$407448d2b89b1813 {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $368997c7fea60e4e$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $368997c7fea60e4e$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $368997c7fea60e4e$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($368997c7fea60e4e$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $368997c7fea60e4e$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($368997c7fea60e4e$export$21579262ef46735b("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($368997c7fea60e4e$export$c18d01048907ea92("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $368997c7fea60e4e$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $368997c7fea60e4e$export$c18d01048907ea92(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $368997c7fea60e4e$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $368997c7fea60e4e$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n, this.type = "FirstParty", this.user = $368997c7fea60e4e$var$User.FIRST_PARTY, this.R = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ A() {
        return this.I ? this.I() : null;
    }
    get headers() {
        this.R.set("X-Goog-AuthUser", this.P);
        // Use array notation to prevent minification
        const e = this.A();
        return e && this.R.set("Authorization", e), this.T && this.R.set("X-Goog-Iam-Authorization-Token", this.T), this.R;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $368997c7fea60e4e$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.P = e, this.T = t, this.I = n;
    }
    getToken() {
        return Promise.resolve(new $368997c7fea60e4e$var$__PRIVATE_FirstPartyToken(this.P, this.T, this.I));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($368997c7fea60e4e$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $368997c7fea60e4e$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $368997c7fea60e4e$export$8b22cf2602fb60ce {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $bVYHX._isFirebaseServerApp)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $368997c7fea60e4e$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $368997c7fea60e4e$export$21579262ef46735b("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $368997c7fea60e4e$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $368997c7fea60e4e$export$21579262ef46735b("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $368997c7fea60e4e$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($368997c7fea60e4e$export$c18d01048907ea92("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $368997c7fea60e4e$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $368997c7fea60e4e$export$24baa2b76016ce0e {
    getToken() {
        return Promise.resolve(new $368997c7fea60e4e$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $368997c7fea60e4e$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $368997c7fea60e4e$export$a07804094c3ecf2d {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $368997c7fea60e4e$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $368997c7fea60e4e$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $368997c7fea60e4e$var$__PRIVATE_isSurrogate(n) === $368997c7fea60e4e$var$__PRIVATE_isSurrogate(i) ? $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n, i) : $368997c7fea60e4e$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $368997c7fea60e4e$var$v = 55296, $368997c7fea60e4e$var$F = 57343;
function $368997c7fea60e4e$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $368997c7fea60e4e$var$v && t <= $368997c7fea60e4e$var$F;
}
/** Helper to compare arrays using isEqual(). */ function $368997c7fea60e4e$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function $368997c7fea60e4e$export$7060da4b5db56fb9(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $368997c7fea60e4e$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$export$7a0bdf7d4a91ea88 = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $368997c7fea60e4e$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $368997c7fea60e4e$export$3a6d5c9ae78a2c08(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $368997c7fea60e4e$export$3a6d5c9ae78a2c08(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $368997c7fea60e4e$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $368997c7fea60e4e$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $368997c7fea60e4e$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $368997c7fea60e4e$var$BasePath.isNumericId(e), r = $368997c7fea60e4e$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $368997c7fea60e4e$var$BasePath.extractNumericId(e).compare($368997c7fea60e4e$var$BasePath.extractNumericId(t)) : $368997c7fea60e4e$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $3Hs2j.Integer).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $368997c7fea60e4e$export$db202ddc8be9136 extends $368997c7fea60e4e$var$BasePath {
    construct(e, t, n) {
        return new $368997c7fea60e4e$export$db202ddc8be9136(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $368997c7fea60e4e$export$db202ddc8be9136(t);
    }
    static emptyPath() {
        return new $368997c7fea60e4e$export$db202ddc8be9136([]);
    }
}
const $368997c7fea60e4e$var$x = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $368997c7fea60e4e$export$cf2f7c5792f80b46 extends $368997c7fea60e4e$var$BasePath {
    construct(e, t, n) {
        return new $368997c7fea60e4e$export$cf2f7c5792f80b46(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $368997c7fea60e4e$var$x.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $368997c7fea60e4e$export$cf2f7c5792f80b46.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $368997c7fea60e4e$export$7a0bdf7d4a91ea88;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $368997c7fea60e4e$export$cf2f7c5792f80b46([
            $368997c7fea60e4e$export$7a0bdf7d4a91ea88
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $368997c7fea60e4e$export$cf2f7c5792f80b46(t);
    }
    static emptyPath() {
        return new $368997c7fea60e4e$export$cf2f7c5792f80b46([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $368997c7fea60e4e$export$90a7f3efeed30595 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.fromString(e));
    }
    static fromName(e) {
        return new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.fromString(e).popFirst(5));
    }
    static empty() {
        return new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $368997c7fea60e4e$export$db202ddc8be9136.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $368997c7fea60e4e$export$db202ddc8be9136.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $368997c7fea60e4e$export$90a7f3efeed30595(new $368997c7fea60e4e$export$db202ddc8be9136(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $368997c7fea60e4e$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $368997c7fea60e4e$export$23ebac1979863676(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $368997c7fea60e4e$var$__PRIVATE_validateDocumentPath(e) {
    if (!$368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(e)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $368997c7fea60e4e$var$__PRIVATE_validateCollectionPath(e) {
    if ($368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(e)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $368997c7fea60e4e$export$7f557e5eb95176c2(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $368997c7fea60e4e$export$efccba1c4a2ef57b(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(12329, {
        type: typeof e
    });
}
function $368997c7fea60e4e$export$4a5767248b18ef41(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $368997c7fea60e4e$export$efccba1c4a2ef57b(e);
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $368997c7fea60e4e$export$953cecd6e717a553(e, t) {
    if (t <= 0) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $368997c7fea60e4e$export$ffb5f4729a158638(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $368997c7fea60e4e$export$9bb611d729802a56(e, t) {
    if (!$368997c7fea60e4e$export$7f557e5eb95176c2(e)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const o = e[r];
        if (i && typeof o !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && o !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $368997c7fea60e4e$var$O = -62135596800, $368997c7fea60e4e$var$N = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $368997c7fea60e4e$export$3d12bd131bb975d1 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $368997c7fea60e4e$export$3d12bd131bb975d1.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $368997c7fea60e4e$export$3d12bd131bb975d1.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $368997c7fea60e4e$var$N);
        return new $368997c7fea60e4e$export$3d12bd131bb975d1(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $368997c7fea60e4e$var$O) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $368997c7fea60e4e$var$N;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $368997c7fea60e4e$export$3d12bd131bb975d1._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($368997c7fea60e4e$export$9bb611d729802a56(e, $368997c7fea60e4e$export$3d12bd131bb975d1._jsonSchema)) return new $368997c7fea60e4e$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $368997c7fea60e4e$var$O;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$368997c7fea60e4e$export$3d12bd131bb975d1._jsonSchemaVersion = "firestore/timestamp/1.0", $368997c7fea60e4e$export$3d12bd131bb975d1._jsonSchema = {
    type: $368997c7fea60e4e$export$ffb5f4729a158638("string", $368997c7fea60e4e$export$3d12bd131bb975d1._jsonSchemaVersion),
    seconds: $368997c7fea60e4e$export$ffb5f4729a158638("number"),
    nanoseconds: $368997c7fea60e4e$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $368997c7fea60e4e$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $368997c7fea60e4e$var$SnapshotVersion(e);
    }
    static min() {
        return new $368997c7fea60e4e$var$SnapshotVersion(new $368997c7fea60e4e$export$3d12bd131bb975d1(0, 0));
    }
    static max() {
        return new $368997c7fea60e4e$var$SnapshotVersion(new $368997c7fea60e4e$export$3d12bd131bb975d1(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $368997c7fea60e4e$var$B = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $368997c7fea60e4e$export$ee7c8ad385a60b7b {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $368997c7fea60e4e$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $368997c7fea60e4e$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $368997c7fea60e4e$export$ee7c8ad385a60b7b.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $368997c7fea60e4e$export$c9170ad7d4cd7e57 {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $368997c7fea60e4e$export$cf2f7c5792f80b46.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $368997c7fea60e4e$export$995eb9fca571757 {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $368997c7fea60e4e$export$995eb9fca571757(0, $368997c7fea60e4e$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $368997c7fea60e4e$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $368997c7fea60e4e$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $368997c7fea60e4e$export$3d12bd131bb975d1(n + 1, 0) : new $368997c7fea60e4e$export$3d12bd131bb975d1(n, r));
    return new $368997c7fea60e4e$var$IndexOffset(i, $368997c7fea60e4e$export$90a7f3efeed30595.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $368997c7fea60e4e$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $368997c7fea60e4e$var$IndexOffset(e.readTime, e.key, $368997c7fea60e4e$var$B);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $368997c7fea60e4e$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $368997c7fea60e4e$var$IndexOffset($368997c7fea60e4e$var$SnapshotVersion.min(), $368997c7fea60e4e$export$90a7f3efeed30595.empty(), $368997c7fea60e4e$var$B);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $368997c7fea60e4e$var$IndexOffset($368997c7fea60e4e$var$SnapshotVersion.max(), $368997c7fea60e4e$export$90a7f3efeed30595.empty(), $368997c7fea60e4e$var$B);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$L = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $368997c7fea60e4e$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION || e.message !== $368997c7fea60e4e$var$L) throw e;
    $368997c7fea60e4e$export$21579262ef46735b("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $368997c7fea60e4e$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $368997c7fea60e4e$export$3a6d5c9ae78a2c08(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $368997c7fea60e4e$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $368997c7fea60e4e$var$PersistencePromise ? t : $368997c7fea60e4e$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $368997c7fea60e4e$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $368997c7fea60e4e$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $368997c7fea60e4e$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $368997c7fea60e4e$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $368997c7fea60e4e$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $368997c7fea60e4e$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $368997c7fea60e4e$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $368997c7fea60e4e$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $368997c7fea60e4e$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $368997c7fea60e4e$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $368997c7fea60e4e$var$k = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $368997c7fea60e4e$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $368997c7fea60e4e$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.S = new $368997c7fea60e4e$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.S.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.S.reject(new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.S.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $368997c7fea60e4e$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.S.reject(new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get D() {
        return this.S.promise;
    }
    abort(e) {
        e && this.S.reject(e), this.aborted || ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    C() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $368997c7fea60e4e$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $368997c7fea60e4e$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "Removing database:", e);
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest((0, $9k0Bn.getGlobal)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static v() {
        if (!(0, $9k0Bn.isIndexedDBAvailable)()) return !1;
        if ($368997c7fea60e4e$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $9k0Bn.getUA)(), t = $368997c7fea60e4e$var$__PRIVATE_SimpleDb.M(e), n = 0 < t && t < 10, r = $368997c7fea60e4e$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static O(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static M(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.B = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $368997c7fea60e4e$var$__PRIVATE_SimpleDb.M((0, $9k0Bn.getUA)()) && $368997c7fea60e4e$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async L(e) {
        return this.db || ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.k(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.K && (this.db.onversionchange = (e)=>this.K(e)), this.db;
    }
    q(e) {
        this.K = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.L(e);
                const t = $368997c7fea60e4e$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.C(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $368997c7fea60e4e$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.D, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $368997c7fea60e4e$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $368997c7fea60e4e$var$__PRIVATE_IterationController {
    constructor(e){
        this.U = e, this.$ = !1, this.W = null;
    }
    get isDone() {
        return this.$;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.U = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.$ = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest(this.U.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransactionError extends $368997c7fea60e4e$export$4368d992c4eafac0 {
    constructor(e, t){
        super($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $368997c7fea60e4e$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $368997c7fea60e4e$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "ADD", this.store.name, e, e);
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "DELETE", this.store.name, e);
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "COUNT", this.store.name);
        return $368997c7fea60e4e$var$__PRIVATE_wrapRequest(this.store.count());
    }
    H(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $368997c7fea60e4e$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Z(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $368997c7fea60e4e$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    X(e, t) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$k, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Y = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new $368997c7fea60e4e$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $368997c7fea60e4e$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new $368997c7fea60e4e$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $368997c7fea60e4e$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $368997c7fea60e4e$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $368997c7fea60e4e$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $368997c7fea60e4e$var$__PRIVATE_wrapRequest(e) {
    return new $368997c7fea60e4e$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $368997c7fea60e4e$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $368997c7fea60e4e$var$K = !1;
function $368997c7fea60e4e$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_SimpleDb.M((0, $9k0Bn.getUA)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $368997c7fea60e4e$export$4368d992c4eafac0("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $368997c7fea60e4e$var$K || ($368997c7fea60e4e$var$K = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $368997c7fea60e4e$var$q = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $368997c7fea60e4e$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$q, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$q, `Documents written: ${e}`);
            } catch (e) {
                $368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e) ? $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$q, "Ignoring IndexedDB error during index backfill: ", e) : await $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $368997c7fea60e4e$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $368997c7fea60e4e$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$q, `Processing collection: ${t}`), this.oe(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ oe(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this._e(r, n)).next((n)=>($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$q, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ _e(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $368997c7fea60e4e$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $368997c7fea60e4e$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $368997c7fea60e4e$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $368997c7fea60e4e$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
$368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $368997c7fea60e4e$var$U = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $368997c7fea60e4e$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function $368997c7fea60e4e$export$136fd86de524d3c2(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $368997c7fea60e4e$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$368997c7fea60e4e$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function $368997c7fea60e4e$export$39c1cc7c062529d4(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$$ = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $368997c7fea60e4e$var$__PRIVATE_encodeSeparator(t)), t = $368997c7fea60e4e$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $368997c7fea60e4e$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $368997c7fea60e4e$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $368997c7fea60e4e$var$$:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $368997c7fea60e4e$var$__PRIVATE_encodeSeparator(e) {
    return e + $368997c7fea60e4e$var$$ + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($368997c7fea60e4e$export$c18d01048907ea92(t >= 2, 64408, {
        path: e
    }), 2 === t) return $368997c7fea60e4e$export$c18d01048907ea92(e.charAt(0) === $368997c7fea60e4e$var$$ && "" === e.charAt(1), 56145, {
        path: e
    }), $368997c7fea60e4e$export$db202ddc8be9136.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($368997c7fea60e4e$var$$, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $368997c7fea60e4e$export$3a6d5c9ae78a2c08(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $368997c7fea60e4e$export$3a6d5c9ae78a2c08(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $368997c7fea60e4e$export$db202ddc8be9136(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$W = "remoteDocuments", $368997c7fea60e4e$var$Q = "owner", $368997c7fea60e4e$var$G = "owner", $368997c7fea60e4e$var$z = "mutationQueues", $368997c7fea60e4e$var$j = "userId", $368997c7fea60e4e$var$H = "mutations", $368997c7fea60e4e$var$J = "batchId", $368997c7fea60e4e$var$Z = "userMutationsIndex", $368997c7fea60e4e$var$X = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $368997c7fea60e4e$var$Y = {}, $368997c7fea60e4e$var$ee = "documentMutations", $368997c7fea60e4e$var$te = "remoteDocumentsV14", $368997c7fea60e4e$var$ne = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $368997c7fea60e4e$var$re = "documentKeyIndex", $368997c7fea60e4e$var$ie = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $368997c7fea60e4e$var$se = "collectionGroupIndex", $368997c7fea60e4e$var$oe = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $368997c7fea60e4e$var$_e = "remoteDocumentGlobal", $368997c7fea60e4e$var$ae = "remoteDocumentGlobalKey", $368997c7fea60e4e$var$ue = "targets", $368997c7fea60e4e$var$ce = "queryTargetsIndex", $368997c7fea60e4e$var$le = [
    "canonicalId",
    "targetId"
], $368997c7fea60e4e$var$he = "targetDocuments", $368997c7fea60e4e$var$Pe = [
    "targetId",
    "path"
], $368997c7fea60e4e$var$Te = "documentTargetsIndex", $368997c7fea60e4e$var$Ie = [
    "path",
    "targetId"
], $368997c7fea60e4e$var$Ee = "targetGlobalKey", $368997c7fea60e4e$var$Re = "targetGlobal", $368997c7fea60e4e$var$Ae = "collectionParents", $368997c7fea60e4e$var$Ve = [
    "collectionId",
    "parent"
], $368997c7fea60e4e$var$de = "clientMetadata", $368997c7fea60e4e$var$me = "clientId", $368997c7fea60e4e$var$fe = "bundles", $368997c7fea60e4e$var$ge = "bundleId", $368997c7fea60e4e$var$pe = "namedQueries", $368997c7fea60e4e$var$ye = "name", $368997c7fea60e4e$var$we = "indexConfiguration", $368997c7fea60e4e$var$be = "indexId", $368997c7fea60e4e$var$Se = "collectionGroupIndex", $368997c7fea60e4e$var$De = "collectionGroup", $368997c7fea60e4e$var$Ce = "indexState", $368997c7fea60e4e$var$ve = [
    "indexId",
    "uid"
], $368997c7fea60e4e$var$Fe = "sequenceNumberIndex", $368997c7fea60e4e$var$Me = [
    "uid",
    "sequenceNumber"
], $368997c7fea60e4e$var$xe = "indexEntries", $368997c7fea60e4e$var$Oe = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $368997c7fea60e4e$var$Ne = "documentKeyIndex", $368997c7fea60e4e$var$Be = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $368997c7fea60e4e$var$Le = "documentOverlays", $368997c7fea60e4e$var$ke = [
    "userId",
    "collectionPath",
    "documentId"
], $368997c7fea60e4e$var$Ke = "collectionPathOverlayIndex", $368997c7fea60e4e$var$qe = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $368997c7fea60e4e$var$Ue = "collectionGroupOverlayIndex", $368997c7fea60e4e$var$$e = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $368997c7fea60e4e$var$We = "globals", $368997c7fea60e4e$var$Qe = "name", $368997c7fea60e4e$var$Ge = [
    $368997c7fea60e4e$var$z,
    $368997c7fea60e4e$var$H,
    $368997c7fea60e4e$var$ee,
    $368997c7fea60e4e$var$W,
    $368997c7fea60e4e$var$ue,
    $368997c7fea60e4e$var$Q,
    $368997c7fea60e4e$var$Re,
    $368997c7fea60e4e$var$he,
    $368997c7fea60e4e$var$de,
    $368997c7fea60e4e$var$_e,
    $368997c7fea60e4e$var$Ae,
    $368997c7fea60e4e$var$fe,
    $368997c7fea60e4e$var$pe
], $368997c7fea60e4e$var$ze = [
    ...$368997c7fea60e4e$var$Ge,
    $368997c7fea60e4e$var$Le
], $368997c7fea60e4e$var$je = [
    $368997c7fea60e4e$var$z,
    $368997c7fea60e4e$var$H,
    $368997c7fea60e4e$var$ee,
    $368997c7fea60e4e$var$te,
    $368997c7fea60e4e$var$ue,
    $368997c7fea60e4e$var$Q,
    $368997c7fea60e4e$var$Re,
    $368997c7fea60e4e$var$he,
    $368997c7fea60e4e$var$de,
    $368997c7fea60e4e$var$_e,
    $368997c7fea60e4e$var$Ae,
    $368997c7fea60e4e$var$fe,
    $368997c7fea60e4e$var$pe,
    $368997c7fea60e4e$var$Le
], $368997c7fea60e4e$var$He = $368997c7fea60e4e$var$je, $368997c7fea60e4e$var$Je = [
    ...$368997c7fea60e4e$var$He,
    $368997c7fea60e4e$var$we,
    $368997c7fea60e4e$var$Ce,
    $368997c7fea60e4e$var$xe
], $368997c7fea60e4e$var$Ze = $368997c7fea60e4e$var$Je, $368997c7fea60e4e$var$Xe = [
    ...$368997c7fea60e4e$var$Je,
    $368997c7fea60e4e$var$We
], $368997c7fea60e4e$var$Ye = $368997c7fea60e4e$var$Xe;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransaction extends $368997c7fea60e4e$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_getStore(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return $368997c7fea60e4e$var$__PRIVATE_SimpleDb.O(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $368997c7fea60e4e$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $368997c7fea60e4e$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $368997c7fea60e4e$export$a9c23c6ac3fc3eca(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $368997c7fea60e4e$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $368997c7fea60e4e$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $368997c7fea60e4e$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $368997c7fea60e4e$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $368997c7fea60e4e$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $368997c7fea60e4e$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $368997c7fea60e4e$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $368997c7fea60e4e$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $368997c7fea60e4e$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $368997c7fea60e4e$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $368997c7fea60e4e$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $368997c7fea60e4e$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $368997c7fea60e4e$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $368997c7fea60e4e$var$LLRBNode.RED, this.left = null != r ? r : $368997c7fea60e4e$var$LLRBNode.EMPTY, this.right = null != i ? i : $368997c7fea60e4e$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $368997c7fea60e4e$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $368997c7fea60e4e$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $368997c7fea60e4e$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $368997c7fea60e4e$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $368997c7fea60e4e$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$368997c7fea60e4e$var$LLRBNode.EMPTY = null, $368997c7fea60e4e$var$LLRBNode.RED = !0, $368997c7fea60e4e$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$368997c7fea60e4e$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(57766);
    }
    get value() {
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(16141);
    }
    get color() {
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(16727);
    }
    get left() {
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(29726);
    }
    get right() {
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $368997c7fea60e4e$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $368997c7fea60e4e$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $368997c7fea60e4e$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $368997c7fea60e4e$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $368997c7fea60e4e$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $368997c7fea60e4e$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $368997c7fea60e4e$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $368997c7fea60e4e$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $368997c7fea60e4e$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $368997c7fea60e4e$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator);
    }
    static empty() {
        return new $368997c7fea60e4e$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $368997c7fea60e4e$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $368997c7fea60e4e$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $368997c7fea60e4e$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $368997c7fea60e4e$export$a05254e7c3aeba6e() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $368997c7fea60e4e$export$9d398bebfec1c039 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $368997c7fea60e4e$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $368997c7fea60e4e$export$9d398bebfec1c039(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $368997c7fea60e4e$export$9d398bebfec1c039(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING = new $368997c7fea60e4e$export$9d398bebfec1c039("");
const $368997c7fea60e4e$var$et = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($368997c7fea60e4e$export$c18d01048907ea92(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $368997c7fea60e4e$var$et.exec(e);
        if ($368997c7fea60e4e$export$c18d01048907ea92(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $368997c7fea60e4e$export$9d398bebfec1c039.fromBase64String(e) : $368997c7fea60e4e$export$9d398bebfec1c039.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $368997c7fea60e4e$var$tt = "server_timestamp", $368997c7fea60e4e$var$nt = "__type__", $368997c7fea60e4e$var$rt = "__previous_value__", $368997c7fea60e4e$var$it = "__local_write_time__";
function $368997c7fea60e4e$export$2408f22a0fab9ae5(e) {
    const t = (e?.mapValue?.fields || {})[$368997c7fea60e4e$var$nt]?.stringValue;
    return t === $368997c7fea60e4e$var$tt;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $368997c7fea60e4e$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$368997c7fea60e4e$var$rt];
    return $368997c7fea60e4e$export$2408f22a0fab9ae5(t) ? $368997c7fea60e4e$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$368997c7fea60e4e$var$it].timestampValue);
    return new $368997c7fea60e4e$export$3d12bd131bb975d1(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a, u, c){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c;
    }
}
/** The default database name for a project. */ const $368997c7fea60e4e$var$st = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $368997c7fea60e4e$export$890c4ad488842ce7 {
    constructor(e, t){
        this.projectId = e, this.database = t || $368997c7fea60e4e$var$st;
    }
    static empty() {
        return new $368997c7fea60e4e$export$890c4ad488842ce7("", "");
    }
    get isDefaultDatabase() {
        return this.database === $368997c7fea60e4e$var$st;
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$export$890c4ad488842ce7 && e.projectId === this.projectId && e.database === this.database;
    }
}
function $368997c7fea60e4e$export$db3b6bfb95261072(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new $368997c7fea60e4e$export$890c4ad488842ce7(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$ot = "__type__", $368997c7fea60e4e$var$_t = "__max__", $368997c7fea60e4e$var$at = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $368997c7fea60e4e$var$_t
            }
        }
    }
}, $368997c7fea60e4e$var$ut = "__vector__", $368997c7fea60e4e$var$ct = "value", $368997c7fea60e4e$var$lt = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $368997c7fea60e4e$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $368997c7fea60e4e$export$2408f22a0fab9ae5(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $368997c7fea60e4e$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $368997c7fea60e4e$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $368997c7fea60e4e$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $368997c7fea60e4e$var$__PRIVATE_typeOrder(e);
    if (n !== $368997c7fea60e4e$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(e).isEqual($368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($368997c7fea60e4e$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.integerValue) === $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $368997c7fea60e4e$var$__PRIVATE_isNegativeZero(n) === $368997c7fea60e4e$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $368997c7fea60e4e$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($368997c7fea60e4e$var$__PRIVATE_objectSize(n) !== $368997c7fea60e4e$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$368997c7fea60e4e$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(52216, {
                left: e
            });
    }
}
function $368997c7fea60e4e$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$368997c7fea60e4e$var$__PRIVATE_valueEquals(e, t));
}
function $368997c7fea60e4e$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $368997c7fea60e4e$var$__PRIVATE_typeOrder(e), r = $368997c7fea60e4e$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_compareTimestamps($368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(e), $368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e), r = $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator($368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.latitude), $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator($368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.longitude), $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$368997c7fea60e4e$var$ct]?.arrayValue, s = r[$368997c7fea60e4e$var$ct]?.arrayValue, o = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== o) return o;
                return $368997c7fea60e4e$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $368997c7fea60e4e$var$at.mapValue && t === $368997c7fea60e4e$var$at.mapValue) return 0;
                if (e === $368997c7fea60e4e$var$at.mapValue) return 1;
                if (t === $368997c7fea60e4e$var$at.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $368997c7fea60e4e$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $368997c7fea60e4e$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(23264, {
                he: n
            });
    }
}
function $368997c7fea60e4e$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e, t);
    const n = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e), r = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(t), i = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $368997c7fea60e4e$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $368997c7fea60e4e$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (t) return t;
    }
    return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $368997c7fea60e4e$var$canonicalId(e) {
    return $368997c7fea60e4e$var$__PRIVATE_canonifyValue(e);
}
function $368997c7fea60e4e$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $368997c7fea60e4e$export$90a7f3efeed30595.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $368997c7fea60e4e$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$368997c7fea60e4e$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(61005, {
        value: e
    });
}
function $368997c7fea60e4e$var$__PRIVATE_estimateByteSize(e) {
    switch($368997c7fea60e4e$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $368997c7fea60e4e$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $368997c7fea60e4e$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $368997c7fea60e4e$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $368997c7fea60e4e$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $368997c7fea60e4e$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(13486, {
                value: e
            });
    }
}
function $368997c7fea60e4e$export$43caf9889c228507(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $368997c7fea60e4e$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $368997c7fea60e4e$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $368997c7fea60e4e$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $368997c7fea60e4e$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $368997c7fea60e4e$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $368997c7fea60e4e$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$368997c7fea60e4e$var$ot]?.stringValue;
    return t === $368997c7fea60e4e$var$ut;
}
/** Creates a deep copy of `source`. */ function $368997c7fea60e4e$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $368997c7fea60e4e$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $368997c7fea60e4e$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $368997c7fea60e4e$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $368997c7fea60e4e$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $368997c7fea60e4e$var$_t;
}
const $368997c7fea60e4e$var$ht = {
    mapValue: {
        fields: {
            [$368997c7fea60e4e$var$ot]: {
                stringValue: $368997c7fea60e4e$var$ut
            },
            [$368997c7fea60e4e$var$ct]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $368997c7fea60e4e$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $368997c7fea60e4e$var$lt : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $368997c7fea60e4e$export$43caf9889c228507($368997c7fea60e4e$export$890c4ad488842ce7.empty(), $368997c7fea60e4e$export$90a7f3efeed30595.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $368997c7fea60e4e$var$__PRIVATE_isVectorValue(e) ? $368997c7fea60e4e$var$ht : {
        mapValue: {}
    } : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $368997c7fea60e4e$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $368997c7fea60e4e$export$43caf9889c228507($368997c7fea60e4e$export$890c4ad488842ce7.empty(), $368997c7fea60e4e$export$90a7f3efeed30595.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $368997c7fea60e4e$var$ht : "mapValue" in e ? $368997c7fea60e4e$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $368997c7fea60e4e$var$at : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(61959, {
        value: e
    });
}
function $368997c7fea60e4e$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $368997c7fea60e4e$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $368997c7fea60e4e$export$c4ce752e73470fba {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $368997c7fea60e4e$export$c4ce752e73470fba({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$368997c7fea60e4e$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $368997c7fea60e4e$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $368997c7fea60e4e$export$cf2f7c5792f80b46.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $368997c7fea60e4e$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $368997c7fea60e4e$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $368997c7fea60e4e$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $368997c7fea60e4e$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $368997c7fea60e4e$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $368997c7fea60e4e$export$c4ce752e73470fba($368997c7fea60e4e$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $368997c7fea60e4e$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $368997c7fea60e4e$var$forEach(e.fields, (e, n)=>{
        const r = new $368997c7fea60e4e$export$cf2f7c5792f80b46([
            e
        ]);
        if ($368997c7fea60e4e$var$__PRIVATE_isMapValue(n)) {
            const e = $368997c7fea60e4e$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $368997c7fea60e4e$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $368997c7fea60e4e$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $368997c7fea60e4e$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $368997c7fea60e4e$var$SnapshotVersion.min(), /* readTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), /* createTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), $368997c7fea60e4e$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $368997c7fea60e4e$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $368997c7fea60e4e$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), /* createTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), $368997c7fea60e4e$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $368997c7fea60e4e$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), /* createTime */ $368997c7fea60e4e$var$SnapshotVersion.min(), $368997c7fea60e4e$export$c4ce752e73470fba.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $368997c7fea60e4e$export$c4ce752e73470fba.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $368997c7fea60e4e$export$c4ce752e73470fba.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $368997c7fea60e4e$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $368997c7fea60e4e$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $368997c7fea60e4e$export$625550452a3fa3ec {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $368997c7fea60e4e$export$90a7f3efeed30595.comparator($368997c7fea60e4e$export$90a7f3efeed30595.fromName(o.referenceValue), n.key);
        else r = $368997c7fea60e4e$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $368997c7fea60e4e$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$368997c7fea60e4e$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $368997c7fea60e4e$export$306ddfe3a8403e2 {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$Filter {
}
class $368997c7fea60e4e$export$dda1d9f60106f0e9 extends $368997c7fea60e4e$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $368997c7fea60e4e$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $368997c7fea60e4e$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $368997c7fea60e4e$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $368997c7fea60e4e$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $368997c7fea60e4e$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $368997c7fea60e4e$export$dda1d9f60106f0e9(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $368997c7fea60e4e$var$__PRIVATE_KeyFieldInFilter(e, n) : new $368997c7fea60e4e$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($368997c7fea60e4e$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $368997c7fea60e4e$var$__PRIVATE_typeOrder(this.value) === $368997c7fea60e4e$var$__PRIVATE_typeOrder(t) && this.matchesComparison($368997c7fea60e4e$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $368997c7fea60e4e$export$35e795649ee09318 extends $368997c7fea60e4e$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Pe = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $368997c7fea60e4e$export$35e795649ee09318(e, t);
    }
    matches(e) {
        return $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Pe || (this.Pe = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Pe;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlat(e) && $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $368997c7fea60e4e$export$35e795649ee09318) return !1;
    return !0;
}
function $368997c7fea60e4e$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $368997c7fea60e4e$var$canonicalId(e.value);
    if ($368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 && e.op === t.op && e.field.isEqual(t.field) && $368997c7fea60e4e$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $368997c7fea60e4e$export$35e795649ee09318 ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $368997c7fea60e4e$export$35e795649ee09318 && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $368997c7fea60e4e$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $368997c7fea60e4e$export$3a6d5c9ae78a2c08(19439);
}
function $368997c7fea60e4e$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $368997c7fea60e4e$export$35e795649ee09318.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $368997c7fea60e4e$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$368997c7fea60e4e$var$canonicalId(e.value)}`;
    }(e) : e instanceof $368997c7fea60e4e$export$35e795649ee09318 ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($368997c7fea60e4e$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $368997c7fea60e4e$var$__PRIVATE_KeyFieldFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t, n){
        super(e, t, n), this.key = $368997c7fea60e4e$export$90a7f3efeed30595.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $368997c7fea60e4e$var$__PRIVATE_KeyFieldInFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $368997c7fea60e4e$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $368997c7fea60e4e$var$__PRIVATE_KeyFieldNotInFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $368997c7fea60e4e$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $368997c7fea60e4e$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$368997c7fea60e4e$export$90a7f3efeed30595.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $368997c7fea60e4e$var$__PRIVATE_ArrayContainsFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $368997c7fea60e4e$var$isArray(t) && $368997c7fea60e4e$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $368997c7fea60e4e$var$__PRIVATE_InFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $368997c7fea60e4e$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $368997c7fea60e4e$var$__PRIVATE_NotInFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($368997c7fea60e4e$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$368997c7fea60e4e$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $368997c7fea60e4e$var$__PRIVATE_ArrayContainsAnyFilter extends $368997c7fea60e4e$export$dda1d9f60106f0e9 {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$368997c7fea60e4e$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$368997c7fea60e4e$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $368997c7fea60e4e$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.Te = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $368997c7fea60e4e$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $368997c7fea60e4e$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $368997c7fea60e4e$var$__PRIVATE_canonifyTarget(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    if (null === t.Te) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$368997c7fea60e4e$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$368997c7fea60e4e$var$canonicalId(e)).join(",")), t.Te = e;
    }
    return t.Te;
}
function $368997c7fea60e4e$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$368997c7fea60e4e$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$368997c7fea60e4e$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$368997c7fea60e4e$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $368997c7fea60e4e$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $368997c7fea60e4e$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $368997c7fea60e4e$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $368997c7fea60e4e$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $368997c7fea60e4e$var$lt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $368997c7fea60e4e$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $368997c7fea60e4e$var$lt, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $368997c7fea60e4e$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $368997c7fea60e4e$var$lt;
        }
        $368997c7fea60e4e$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $368997c7fea60e4e$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $368997c7fea60e4e$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $368997c7fea60e4e$var$at, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $368997c7fea60e4e$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $368997c7fea60e4e$var$at, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $368997c7fea60e4e$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $368997c7fea60e4e$var$at;
        }
        $368997c7fea60e4e$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $368997c7fea60e4e$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $368997c7fea60e4e$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.Ee = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.Re = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $368997c7fea60e4e$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $368997c7fea60e4e$export$a93c5207d687da10(e) {
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $368997c7fea60e4e$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function $368997c7fea60e4e$export$51b138e5a065c2bb(e) {
    return $368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $368997c7fea60e4e$export$3b14a55fb2447963(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $368997c7fea60e4e$export$9e5f44173e64f162(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    if (null === t.Ie) {
        t.Ie = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.Ie.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.Ie.push(new $368997c7fea60e4e$export$306ddfe3a8403e2(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($368997c7fea60e4e$export$cf2f7c5792f80b46.keyField().canonicalString()) || t.Ie.push(new $368997c7fea60e4e$export$306ddfe3a8403e2($368997c7fea60e4e$export$cf2f7c5792f80b46.keyField(), n));
    }
    return t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $368997c7fea60e4e$var$__PRIVATE_queryToTarget(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return t.Ee || (t.Ee = $368997c7fea60e4e$var$__PRIVATE__queryToTarget(t, $368997c7fea60e4e$export$9e5f44173e64f162(e))), t.Ee;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $368997c7fea60e4e$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return t.Re || // Do not include implicit order-bys for aggregate queries.
    (t.Re = $368997c7fea60e4e$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.Re;
}
function $368997c7fea60e4e$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $368997c7fea60e4e$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $368997c7fea60e4e$export$306ddfe3a8403e2(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $368997c7fea60e4e$export$625550452a3fa3ec(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $368997c7fea60e4e$export$625550452a3fa3ec(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $368997c7fea60e4e$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $368997c7fea60e4e$export$f1e1789686576879(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $368997c7fea60e4e$export$342063e11d6c3cad(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function $368997c7fea60e4e$export$882b5998b3b9117c(e, t, n) {
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $368997c7fea60e4e$export$7ccc53e8f1e7dfc5(e, t) {
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function $368997c7fea60e4e$export$ae1af26003f05816(e, t) {
    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function $368997c7fea60e4e$var$__PRIVATE_queryEquals(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_targetEquals($368997c7fea60e4e$var$__PRIVATE_queryToTarget(e), $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $368997c7fea60e4e$var$__PRIVATE_canonifyQuery(e) {
    return `${$368997c7fea60e4e$var$__PRIVATE_canonifyTarget($368997c7fea60e4e$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$368997c7fea60e4e$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$368997c7fea60e4e$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($368997c7fea60e4e$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $368997c7fea60e4e$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $368997c7fea60e4e$export$9e5f44173e64f162(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $368997c7fea60e4e$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $368997c7fea60e4e$export$9e5f44173e64f162(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $368997c7fea60e4e$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $368997c7fea60e4e$export$9e5f44173e64f162(e), t)) return !1;
        return !0;
    }(e, t);
}
function $368997c7fea60e4e$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $368997c7fea60e4e$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $368997c7fea60e4e$export$9e5f44173e64f162(e)){
            const e = $368997c7fea60e4e$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $368997c7fea60e4e$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $368997c7fea60e4e$export$90a7f3efeed30595.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $368997c7fea60e4e$var$__PRIVATE_valueCompare(r, i) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $368997c7fea60e4e$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $368997c7fea60e4e$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $368997c7fea60e4e$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Pt = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
function $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap() {
    return $368997c7fea60e4e$var$Pt;
}
const $368997c7fea60e4e$var$Tt = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
function $368997c7fea60e4e$var$documentMap(...e) {
    let t = $368997c7fea60e4e$var$Tt;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $368997c7fea60e4e$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $368997c7fea60e4e$var$Tt;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $368997c7fea60e4e$var$__PRIVATE_newOverlayMap() {
    return $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap();
}
function $368997c7fea60e4e$var$__PRIVATE_newMutationMap() {
    return $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap();
}
function $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap() {
    return new $368997c7fea60e4e$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $368997c7fea60e4e$var$It = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
const $368997c7fea60e4e$var$Et = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
function $368997c7fea60e4e$export$971d5caa766a69d7(...e) {
    let t = $368997c7fea60e4e$var$Et;
    for (const n of e)t = t.add(n);
    return t;
}
const $368997c7fea60e4e$var$Rt = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
function $368997c7fea60e4e$var$__PRIVATE_targetIdSet() {
    return $368997c7fea60e4e$var$Rt;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $368997c7fea60e4e$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $368997c7fea60e4e$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $368997c7fea60e4e$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $368997c7fea60e4e$export$b4d5ecaefe2b27f3(e, t) {
    return $368997c7fea60e4e$var$isSafeInteger(t) ? $368997c7fea60e4e$var$__PRIVATE_toInteger(t) : $368997c7fea60e4e$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $368997c7fea60e4e$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $368997c7fea60e4e$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$368997c7fea60e4e$var$nt]: {
                    stringValue: $368997c7fea60e4e$var$tt
                },
                [$368997c7fea60e4e$var$it]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $368997c7fea60e4e$export$2408f22a0fab9ae5(t) && (t = $368997c7fea60e4e$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$368997c7fea60e4e$var$rt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $368997c7fea60e4e$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $368997c7fea60e4e$var$asNumber(n) + $368997c7fea60e4e$var$asNumber(e.Ae);
        return $368997c7fea60e4e$var$isInteger(n) && $368997c7fea60e4e$var$isInteger(e.Ae) ? $368997c7fea60e4e$var$__PRIVATE_toInteger(r) : $368997c7fea60e4e$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $368997c7fea60e4e$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $368997c7fea60e4e$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $368997c7fea60e4e$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform extends $368997c7fea60e4e$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation extends $368997c7fea60e4e$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$368997c7fea60e4e$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation extends $368997c7fea60e4e$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $368997c7fea60e4e$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$368997c7fea60e4e$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation extends $368997c7fea60e4e$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Ae = t;
    }
}
function $368997c7fea60e4e$var$asNumber(e) {
    return $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $368997c7fea60e4e$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $368997c7fea60e4e$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $368997c7fea60e4e$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_arrayEquals(e.elements, t.elements, $368997c7fea60e4e$var$__PRIVATE_valueEquals) : e instanceof $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation ? $368997c7fea60e4e$var$__PRIVATE_valueEquals(e.Ae, t.Ae) : e instanceof $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform && t instanceof $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $368997c7fea60e4e$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $368997c7fea60e4e$export$78acf4525d8a74c4 {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $368997c7fea60e4e$export$78acf4525d8a74c4;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $368997c7fea60e4e$export$78acf4525d8a74c4(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $368997c7fea60e4e$export$78acf4525d8a74c4(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $368997c7fea60e4e$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $368997c7fea60e4e$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $368997c7fea60e4e$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $368997c7fea60e4e$export$34aec0b863436764(e.key, $368997c7fea60e4e$export$78acf4525d8a74c4.none()) : new $368997c7fea60e4e$var$__PRIVATE_SetMutation(e.key, e.data, $368997c7fea60e4e$export$78acf4525d8a74c4.none());
    {
        const n = e.data, r = $368997c7fea60e4e$export$c4ce752e73470fba.empty();
        let i = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $368997c7fea60e4e$var$__PRIVATE_PatchMutation(e.key, r, new $368997c7fea60e4e$var$FieldMask(i.toArray()), $368997c7fea60e4e$export$78acf4525d8a74c4.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $368997c7fea60e4e$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $368997c7fea60e4e$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $368997c7fea60e4e$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$368997c7fea60e4e$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $368997c7fea60e4e$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($368997c7fea60e4e$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $368997c7fea60e4e$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$368997c7fea60e4e$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $368997c7fea60e4e$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $368997c7fea60e4e$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$368997c7fea60e4e$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $368997c7fea60e4e$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($368997c7fea60e4e$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($368997c7fea60e4e$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $368997c7fea60e4e$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $368997c7fea60e4e$export$c4ce752e73470fba.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $368997c7fea60e4e$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $368997c7fea60e4e$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$368997c7fea60e4e$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $368997c7fea60e4e$var$__PRIVATE_SetMutation extends $368997c7fea60e4e$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_PatchMutation extends $368997c7fea60e4e$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $368997c7fea60e4e$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $368997c7fea60e4e$export$c18d01048907ea92(e.length === n.length, 32656, {
        Ve: n.length,
        de: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $368997c7fea60e4e$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $368997c7fea60e4e$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $368997c7fea60e4e$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $368997c7fea60e4e$export$34aec0b863436764 extends $368997c7fea60e4e$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_VerifyMutation extends $368997c7fea60e4e$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $368997c7fea60e4e$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $368997c7fea60e4e$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $368997c7fea60e4e$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $368997c7fea60e4e$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($368997c7fea60e4e$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $368997c7fea60e4e$export$971d5caa766a69d7());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $368997c7fea60e4e$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$368997c7fea60e4e$var$__PRIVATE_mutationEquals(e, t)) && $368997c7fea60e4e$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$368997c7fea60e4e$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $368997c7fea60e4e$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $368997c7fea60e4e$export$c18d01048907ea92(e.mutations.length === n.length, 58842, {
            me: e.mutations.length,
            fe: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $368997c7fea60e4e$var$It;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $368997c7fea60e4e$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $368997c7fea60e4e$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $368997c7fea60e4e$export$7a38258bbe170828 {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $368997c7fea60e4e$var$At, $368997c7fea60e4e$var$Vt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $368997c7fea60e4e$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $368997c7fea60e4e$export$e7094788287c5e9b.OK:
            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(64938);
        case $368997c7fea60e4e$export$e7094788287c5e9b.CANCELLED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN:
        case $368997c7fea60e4e$export$e7094788287c5e9b.DEADLINE_EXCEEDED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.RESOURCE_EXHAUSTED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.INTERNAL:
        case $368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $368997c7fea60e4e$export$e7094788287c5e9b.UNAUTHENTICATED:
            return !1;
        case $368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT:
        case $368997c7fea60e4e$export$e7094788287c5e9b.NOT_FOUND:
        case $368997c7fea60e4e$export$e7094788287c5e9b.ALREADY_EXISTS:
        case $368997c7fea60e4e$export$e7094788287c5e9b.PERMISSION_DENIED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $368997c7fea60e4e$export$e7094788287c5e9b.ABORTED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.OUT_OF_RANGE:
        case $368997c7fea60e4e$export$e7094788287c5e9b.UNIMPLEMENTED:
        case $368997c7fea60e4e$export$e7094788287c5e9b.DATA_LOSS:
            return !0;
        default:
            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $368997c7fea60e4e$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $368997c7fea60e4e$var$__PRIVATE_logError("GRPC error has no .code"), $368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN;
    switch(e){
        case $368997c7fea60e4e$var$At.OK:
            return $368997c7fea60e4e$export$e7094788287c5e9b.OK;
        case $368997c7fea60e4e$var$At.CANCELLED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.CANCELLED;
        case $368997c7fea60e4e$var$At.UNKNOWN:
            return $368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN;
        case $368997c7fea60e4e$var$At.DEADLINE_EXCEEDED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.DEADLINE_EXCEEDED;
        case $368997c7fea60e4e$var$At.RESOURCE_EXHAUSTED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.RESOURCE_EXHAUSTED;
        case $368997c7fea60e4e$var$At.INTERNAL:
            return $368997c7fea60e4e$export$e7094788287c5e9b.INTERNAL;
        case $368997c7fea60e4e$var$At.UNAVAILABLE:
            return $368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE;
        case $368997c7fea60e4e$var$At.UNAUTHENTICATED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.UNAUTHENTICATED;
        case $368997c7fea60e4e$var$At.INVALID_ARGUMENT:
            return $368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT;
        case $368997c7fea60e4e$var$At.NOT_FOUND:
            return $368997c7fea60e4e$export$e7094788287c5e9b.NOT_FOUND;
        case $368997c7fea60e4e$var$At.ALREADY_EXISTS:
            return $368997c7fea60e4e$export$e7094788287c5e9b.ALREADY_EXISTS;
        case $368997c7fea60e4e$var$At.PERMISSION_DENIED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.PERMISSION_DENIED;
        case $368997c7fea60e4e$var$At.FAILED_PRECONDITION:
            return $368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION;
        case $368997c7fea60e4e$var$At.ABORTED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.ABORTED;
        case $368997c7fea60e4e$var$At.OUT_OF_RANGE:
            return $368997c7fea60e4e$export$e7094788287c5e9b.OUT_OF_RANGE;
        case $368997c7fea60e4e$var$At.UNIMPLEMENTED:
            return $368997c7fea60e4e$export$e7094788287c5e9b.UNIMPLEMENTED;
        case $368997c7fea60e4e$var$At.DATA_LOSS:
            return $368997c7fea60e4e$export$e7094788287c5e9b.DATA_LOSS;
        default:
            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($368997c7fea60e4e$var$Vt = $368997c7fea60e4e$var$At || ($368997c7fea60e4e$var$At = {}))[$368997c7fea60e4e$var$Vt.OK = 0] = "OK", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.CANCELLED = 1] = "CANCELLED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.UNKNOWN = 2] = "UNKNOWN", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.NOT_FOUND = 5] = "NOT_FOUND", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.ABORTED = 10] = "ABORTED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.INTERNAL = 13] = "INTERNAL", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.UNAVAILABLE = 14] = "UNAVAILABLE", $368997c7fea60e4e$var$Vt[$368997c7fea60e4e$var$Vt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $368997c7fea60e4e$var$dt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function $368997c7fea60e4e$export$1a82df3d29112e01(e) {
    if ($368997c7fea60e4e$var$dt) throw new Error("a TestingHooksSpi instance is already set");
    $368997c7fea60e4e$var$dt = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $368997c7fea60e4e$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$mt = new (0, $3Hs2j.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $368997c7fea60e4e$var$__PRIVATE_getMd5HashValue(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $3Hs2j.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $368997c7fea60e4e$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $3Hs2j.Integer)([
            n,
            r
        ], 0),
        new (0, $3Hs2j.Integer)([
            i,
            s
        ], 0)
    ];
}
class $368997c7fea60e4e$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $368997c7fea60e4e$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $368997c7fea60e4e$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $368997c7fea60e4e$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $368997c7fea60e4e$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.pe = (0, $3Hs2j.Integer).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    ye(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $3Hs2j.Integer).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($368997c7fea60e4e$var$mt) && (r = new (0, $3Hs2j.Integer)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.pe).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    we(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = $368997c7fea60e4e$var$__PRIVATE_getMd5HashValue(e), [n, r] = $368997c7fea60e4e$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            if (!this.we(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $368997c7fea60e4e$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = $368997c7fea60e4e$var$__PRIVATE_getMd5HashValue(e), [n, r] = $368997c7fea60e4e$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.ye(n, r, e);
            this.be(t);
        }
    }
    be(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $368997c7fea60e4e$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $368997c7fea60e4e$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $368997c7fea60e4e$var$RemoteEvent($368997c7fea60e4e$var$SnapshotVersion.min(), r, new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), $368997c7fea60e4e$export$971d5caa766a69d7());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $368997c7fea60e4e$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $368997c7fea60e4e$var$TargetChange(n, t, $368997c7fea60e4e$export$971d5caa766a69d7(), $368997c7fea60e4e$export$971d5caa766a69d7(), $368997c7fea60e4e$export$971d5caa766a69d7());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $368997c7fea60e4e$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.Ce = t;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $368997c7fea60e4e$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ve = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = $368997c7fea60e4e$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Me = $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, this.xe = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Oe = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xe;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Me;
    }
    /** Whether this target has pending target adds or target removes. */ get Ne() {
        return 0 !== this.ve;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Oe;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Le(e) {
        e.approximateByteSize() > 0 && (this.Oe = !0, this.Me = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = $368997c7fea60e4e$export$971d5caa766a69d7(), t = $368997c7fea60e4e$export$971d5caa766a69d7(), n = $368997c7fea60e4e$export$971d5caa766a69d7();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $368997c7fea60e4e$export$3a6d5c9ae78a2c08(38017, {
                        changeType: i
                    });
            }
        }), new $368997c7fea60e4e$var$TargetChange(this.Me, this.xe, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ke() {
        this.Oe = !1, this.Fe = $368997c7fea60e4e$var$__PRIVATE_snapshotChangesMap();
    }
    qe(e, t) {
        this.Oe = !0, this.Fe = this.Fe.insert(e, t);
    }
    Ue(e) {
        this.Oe = !0, this.Fe = this.Fe.remove(e);
    }
    $e() {
        this.ve += 1;
    }
    We() {
        this.ve -= 1, $368997c7fea60e4e$export$c18d01048907ea92(this.ve >= 0, 3241, {
            ve: this.ve
        });
    }
    Qe() {
        this.Oe = !0, this.xe = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $368997c7fea60e4e$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.Ge = e, /** The internal state of all tracked targets. */ this.ze = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.je = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), this.He = $368997c7fea60e4e$var$__PRIVATE_documentTargetMap(), /** A mapping of document keys to their set of target IDs. */ this.Je = $368997c7fea60e4e$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ze = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Xe(e) {
        for (const t of e.Se)e.De && e.De.isFoundDocument() ? this.Ye(t, e.De) : this.et(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.et(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ tt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.nt(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.rt(t) && n.Le(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ke(), n.Le(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.We(), n.Ne || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.rt(t) && (n.Qe(), n.Le(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.rt(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.it(t), n.Le(e.resumeToken));
                    break;
                default:
                    $368997c7fea60e4e$export$3a6d5c9ae78a2c08(56790, {
                        state: e.state
                    });
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.ze.forEach((e, n)=>{
            this.rt(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ st(e) {
        const t = e.targetId, n = e.Ce.count, r = this.ot(t);
        if (r) {
            const i = r.target;
            if ($368997c7fea60e4e$var$__PRIVATE_targetIsDocumentTarget(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $368997c7fea60e4e$export$90a7f3efeed30595(i.path);
                    this.et(t, e, $368997c7fea60e4e$var$MutableDocument.newNoDocument(e, $368997c7fea60e4e$var$SnapshotVersion.min()));
                } else $368997c7fea60e4e$export$c18d01048907ea92(1 === n, 20013, {
                    expectedCount: n
                });
            } else {
                const r = this._t(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.ut(e), i = n ? this.ct(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.it(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ze = this.Ze.insert(t, e);
                    }
                    $368997c7fea60e4e$var$dt?.lt(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, o = t.unchangedNames;
                        o && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: o?.hashCount ?? 0,
                            bitmapLength: o?.bits?.bitmap?.length ?? 0,
                            padding: o?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.Ce, this.Ge.ht(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ ut(e) {
        const t = e.Ce.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, o;
        try {
            s = $368997c7fea60e4e$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $368997c7fea60e4e$var$__PRIVATE_Base64DecodeError) return $368997c7fea60e4e$export$4c3d22f3d993c33f("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            o = new $368997c7fea60e4e$var$BloomFilter(s, r, i);
        } catch (e) {
            return $368997c7fea60e4e$export$4c3d22f3d993c33f(e instanceof $368997c7fea60e4e$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === o.ge ? null : o;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ ct(e, t, n) {
        return t.Ce.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.Ge.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.Ge.ht(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.et(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Tt(e) {
        const t = new Map;
        this.ze.forEach((n, r)=>{
            const i = this.ot(r);
            if (i) {
                if (n.current && $368997c7fea60e4e$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $368997c7fea60e4e$export$90a7f3efeed30595(i.target.path);
                    this.It(t).has(r) || this.Et(r, t) || this.et(r, t, $368997c7fea60e4e$var$MutableDocument.newNoDocument(t, e));
                }
                n.Be && (t.set(r, n.ke()), n.Ke());
            }
        });
        let n = $368997c7fea60e4e$export$971d5caa766a69d7();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Je.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ot(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.je.forEach((t, n)=>n.setReadTime(e));
        const r = new $368997c7fea60e4e$var$RemoteEvent(e, t, this.Ze, this.je, n);
        return this.je = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), this.He = $368997c7fea60e4e$var$__PRIVATE_documentTargetMap(), this.Je = $368997c7fea60e4e$var$__PRIVATE_documentTargetMap(), this.Ze = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ye(e, t) {
        if (!this.rt(e)) return;
        const n = this.Et(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.nt(e).qe(t.key, n), this.je = this.je.insert(t.key, t), this.He = this.He.insert(t.key, this.It(t.key).add(e)), this.Je = this.Je.insert(t.key, this.Rt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    et(e, t, n) {
        if (!this.rt(e)) return;
        const r = this.nt(e);
        this.Et(e, t) ? r.qe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ue(t), this.Je = this.Je.insert(t, this.Rt(t).delete(e)), this.Je = this.Je.insert(t, this.Rt(t).add(e)), n && (this.je = this.je.insert(t, n));
    }
    removeTarget(e) {
        this.ze.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ _t(e) {
        const t = this.nt(e).ke();
        return this.Ge.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ $e(e) {
        this.nt(e).$e();
    }
    nt(e) {
        let t = this.ze.get(e);
        return t || (t = new $368997c7fea60e4e$var$__PRIVATE_TargetState, this.ze.set(e, t)), t;
    }
    Rt(e) {
        let t = this.Je.get(e);
        return t || (t = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    It(e) {
        let t = this.He.get(e);
        return t || (t = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), this.He = this.He.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ rt(e) {
        const t = null !== this.ot(e);
        return t || $368997c7fea60e4e$export$21579262ef46735b("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ot(e) {
        const t = this.ze.get(e);
        return t && t.Ne ? null : this.Ge.At(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ it(e) {
        this.ze.set(e, new $368997c7fea60e4e$var$__PRIVATE_TargetState);
        this.Ge.getRemoteKeysForTarget(e).forEach((t)=>{
            this.et(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ Et(e, t) {
        return this.Ge.getRemoteKeysForTarget(e).has(t);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_documentTargetMap() {
    return new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
}
function $368997c7fea60e4e$var$__PRIVATE_snapshotChangesMap() {
    return new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
}
const $368997c7fea60e4e$var$ft = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $368997c7fea60e4e$var$gt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $368997c7fea60e4e$var$pt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $368997c7fea60e4e$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $368997c7fea60e4e$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $368997c7fea60e4e$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ /**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $368997c7fea60e4e$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $368997c7fea60e4e$var$__PRIVATE_toVersion(e, t) {
    return $368997c7fea60e4e$var$toTimestamp(e, t.toTimestamp());
}
function $368997c7fea60e4e$var$__PRIVATE_fromVersion(e) {
    return $368997c7fea60e4e$export$c18d01048907ea92(!!e, 49232), $368997c7fea60e4e$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e);
        return new $368997c7fea60e4e$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }(e));
}
function $368997c7fea60e4e$var$__PRIVATE_toResourceName(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $368997c7fea60e4e$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $368997c7fea60e4e$export$db202ddc8be9136([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $368997c7fea60e4e$var$__PRIVATE_fromResourceName(e) {
    const t = $368997c7fea60e4e$export$db202ddc8be9136.fromString(e);
    return $368997c7fea60e4e$export$c18d01048907ea92($368997c7fea60e4e$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $368997c7fea60e4e$var$__PRIVATE_toName(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $368997c7fea60e4e$var$fromName(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $368997c7fea60e4e$var$__PRIVATE_toQueryPath(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $368997c7fea60e4e$var$__PRIVATE_fromQueryPath(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $368997c7fea60e4e$export$db202ddc8be9136.emptyPath() : $368997c7fea60e4e$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $368997c7fea60e4e$export$db202ddc8be9136([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $368997c7fea60e4e$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $368997c7fea60e4e$export$c18d01048907ea92(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $368997c7fea60e4e$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $368997c7fea60e4e$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $368997c7fea60e4e$var$__PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? $368997c7fea60e4e$var$fromName(e, n.name) : void 0, r.fields = new $368997c7fea60e4e$export$c4ce752e73470fba({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function $368997c7fea60e4e$export$3a1a48c8f6ef640e(e, t, n) {
    const r = $368997c7fea60e4e$var$fromName(e, t.name), i = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.createTime) : $368997c7fea60e4e$var$SnapshotVersion.min(), o = new $368997c7fea60e4e$export$c4ce752e73470fba({
        mapValue: {
            fields: t.fields
        }
    }), _ = $368997c7fea60e4e$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $368997c7fea60e4e$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $368997c7fea60e4e$var$fromName(e, t.found.name), r = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.found.createTime) : $368997c7fea60e4e$var$SnapshotVersion.min(), s = new $368997c7fea60e4e$export$c4ce752e73470fba({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $368997c7fea60e4e$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(!!t.missing, 3894), $368997c7fea60e4e$export$c18d01048907ea92(!!t.readTime, 22933);
        const n = $368997c7fea60e4e$var$fromName(e, t.missing), r = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.readTime);
        return $368997c7fea60e4e$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(7234, {
        result: t
    });
}
function $368997c7fea60e4e$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($368997c7fea60e4e$export$c18d01048907ea92(void 0 === t || "string" == typeof t, 58123), $368997c7fea60e4e$export$9d398bebfec1c039.fromBase64String(t || "")) : ($368997c7fea60e4e$export$c18d01048907ea92(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $368997c7fea60e4e$require$Buffer || t instanceof Uint8Array, 16193), $368997c7fea60e4e$export$9d398bebfec1c039.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN : $368997c7fea60e4e$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $368997c7fea60e4e$export$4368d992c4eafac0(t, e.message || "");
        }(o);
        n = new $368997c7fea60e4e$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $368997c7fea60e4e$var$fromName(e, r.document.name), s = $368997c7fea60e4e$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(r.document.createTime) : $368997c7fea60e4e$var$SnapshotVersion.min(), _ = new $368997c7fea60e4e$export$c4ce752e73470fba({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $368997c7fea60e4e$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $368997c7fea60e4e$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $368997c7fea60e4e$var$fromName(e, r.document), s = r.readTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(r.readTime) : $368997c7fea60e4e$var$SnapshotVersion.min(), o = $368997c7fea60e4e$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $368997c7fea60e4e$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $368997c7fea60e4e$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $368997c7fea60e4e$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(11601, {
            Vt: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $368997c7fea60e4e$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $368997c7fea60e4e$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $368997c7fea60e4e$var$toMutation(e, t) {
    let n;
    if (t instanceof $368997c7fea60e4e$var$__PRIVATE_SetMutation) n = {
        update: $368997c7fea60e4e$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $368997c7fea60e4e$export$34aec0b863436764) n = {
        delete: $368997c7fea60e4e$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $368997c7fea60e4e$var$__PRIVATE_PatchMutation) n = {
        update: $368997c7fea60e4e$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $368997c7fea60e4e$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $368997c7fea60e4e$var$__PRIVATE_VerifyMutation)) return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(16599, {
            dt: t.type
        });
        n = {
            verify: $368997c7fea60e4e$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Ae
            };
            throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $368997c7fea60e4e$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(27497);
    }(e, t.precondition)), n;
}
function $368997c7fea60e4e$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $368997c7fea60e4e$export$78acf4525d8a74c4.updateTime($368997c7fea60e4e$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $368997c7fea60e4e$export$78acf4525d8a74c4.exists(e.exists) : $368997c7fea60e4e$export$78acf4525d8a74c4.none();
    }(t.currentDocument) : $368997c7fea60e4e$export$78acf4525d8a74c4.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $368997c7fea60e4e$export$c18d01048907ea92("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(16584, {
                proto: t
            });
            const r = $368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(t.fieldPath);
            return new $368997c7fea60e4e$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $368997c7fea60e4e$var$fromName(e, t.update.name), s = new $368997c7fea60e4e$export$c4ce752e73470fba({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $368997c7fea60e4e$var$FieldMask(t.map((e)=>$368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(e)));
            }(t.updateMask);
            return new $368997c7fea60e4e$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $368997c7fea60e4e$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $368997c7fea60e4e$var$fromName(e, t.delete);
        return new $368997c7fea60e4e$export$34aec0b863436764(r, n);
    }
    if (t.verify) {
        const r = $368997c7fea60e4e$var$fromName(e, t.verify);
        return new $368997c7fea60e4e$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(1463, {
        proto: t
    });
}
function $368997c7fea60e4e$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($368997c7fea60e4e$export$c18d01048907ea92(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(e.updateTime) : $368997c7fea60e4e$var$__PRIVATE_fromVersion(t);
            return n.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t)), new $368997c7fea60e4e$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $368997c7fea60e4e$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $368997c7fea60e4e$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $368997c7fea60e4e$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $368997c7fea60e4e$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $368997c7fea60e4e$var$__PRIVATE_toFilter($368997c7fea60e4e$export$35e795649ee09318.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const o = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $368997c7fea60e4e$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    o && (n.structuredQuery.orderBy = o);
    const _ = $368997c7fea60e4e$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== _ && (n.structuredQuery.limit = _), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        ft: n,
        parent: i
    };
}
function $368997c7fea60e4e$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { ft: i, parent: s } = $368997c7fea60e4e$var$__PRIVATE_toQueryTarget(e, t), o = {}, _ = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        o[t] = e.alias, "count" === e.aggregateType ? _.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? _.push({
            alias: t,
            avg: {
                field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && _.push({
            alias: t,
            sum: {
                field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: _,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        gt: o,
        parent: s
    };
}
function $368997c7fea60e4e$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $368997c7fea60e4e$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $368997c7fea60e4e$export$c18d01048907ea92(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_fromFilter(e);
        if (t instanceof $368997c7fea60e4e$export$35e795649ee09318 && $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $368997c7fea60e4e$export$306ddfe3a8403e2($368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $368997c7fea60e4e$export$625550452a3fa3ec(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $368997c7fea60e4e$export$625550452a3fa3ec(n, t);
    }(n.endAt)), $368997c7fea60e4e$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $368997c7fea60e4e$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $368997c7fea60e4e$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $368997c7fea60e4e$export$dda1d9f60106f0e9.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $368997c7fea60e4e$export$dda1d9f60106f0e9.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $368997c7fea60e4e$export$dda1d9f60106f0e9.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $368997c7fea60e4e$export$dda1d9f60106f0e9.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(61313);
            default:
                return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $368997c7fea60e4e$export$dda1d9f60106f0e9.create($368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(58110);
                default:
                    return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $368997c7fea60e4e$export$35e795649ee09318.create(e.compositeFilter.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(30097, {
        filter: e
    });
}
function $368997c7fea60e4e$var$__PRIVATE_toDirection(e) {
    return $368997c7fea60e4e$var$ft[e];
}
function $368997c7fea60e4e$var$__PRIVATE_toOperatorName(e) {
    return $368997c7fea60e4e$var$gt[e];
}
function $368997c7fea60e4e$var$__PRIVATE_toCompositeOperatorName(e) {
    return $368997c7fea60e4e$var$pt[e];
}
function $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $368997c7fea60e4e$var$__PRIVATE_fromFieldPathReference(e) {
    return $368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(e.fieldPath);
}
function $368997c7fea60e4e$var$__PRIVATE_toFilter(e) {
    return e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($368997c7fea60e4e$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($368997c7fea60e4e$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($368997c7fea60e4e$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($368997c7fea60e4e$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $368997c7fea60e4e$var$__PRIVATE_toFieldPathReference(e.field),
                op: $368997c7fea60e4e$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $368997c7fea60e4e$export$35e795649ee09318 ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$368997c7fea60e4e$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $368997c7fea60e4e$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(54877, {
        filter: e
    });
}
function $368997c7fea60e4e$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $368997c7fea60e4e$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function $368997c7fea60e4e$var$__PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function $368997c7fea60e4e$export$62d08d6fa708df47(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function $368997c7fea60e4e$export$ad4aebacdcaf47f8(e) {
    return {
        stringValue: e
    };
}
function $368997c7fea60e4e$export$5521614468b862fb(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $368997c7fea60e4e$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $368997c7fea60e4e$var$SnapshotVersion.min(), s = $368997c7fea60e4e$var$SnapshotVersion.min(), o = $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $368997c7fea60e4e$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $368997c7fea60e4e$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $368997c7fea60e4e$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $368997c7fea60e4e$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $368997c7fea60e4e$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.yt = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $368997c7fea60e4e$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $368997c7fea60e4e$export$3a1a48c8f6ef640e(e.yt, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(t.noDocument.path), r = $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $368997c7fea60e4e$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(56709);
        {
            const e = $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(t.unknownDocument.path), r = $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $368997c7fea60e4e$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $368997c7fea60e4e$export$3d12bd131bb975d1(e[0], e[1]);
        return $368997c7fea60e4e$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $368997c7fea60e4e$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $368997c7fea60e4e$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $368997c7fea60e4e$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $368997c7fea60e4e$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $368997c7fea60e4e$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.yt, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $368997c7fea60e4e$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $368997c7fea60e4e$export$3d12bd131bb975d1(e.seconds, e.nanoseconds);
    return $368997c7fea60e4e$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$368997c7fea60e4e$var$__PRIVATE_fromMutation(e.yt, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$368997c7fea60e4e$var$__PRIVATE_fromMutation(e.yt, t)), i = $368997c7fea60e4e$export$3d12bd131bb975d1.fromMillis(t.localWriteTimeMs);
    return new $368997c7fea60e4e$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $368997c7fea60e4e$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $368997c7fea60e4e$export$c18d01048907ea92(1 === t, 1966, {
            count: t
        }), $368997c7fea60e4e$var$__PRIVATE_queryToTarget($368997c7fea60e4e$export$a93c5207d687da10($368997c7fea60e4e$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $368997c7fea60e4e$var$__PRIVATE_queryToTarget($368997c7fea60e4e$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $368997c7fea60e4e$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $368997c7fea60e4e$export$9d398bebfec1c039.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $368997c7fea60e4e$var$__PRIVATE_toDbTarget(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $368997c7fea60e4e$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $368997c7fea60e4e$var$__PRIVATE_toDocumentsTarget(e.yt, t.target) : $368997c7fea60e4e$var$__PRIVATE_toQueryTarget(e.yt, t.target).ft;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $368997c7fea60e4e$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $368997c7fea60e4e$export$56c0d5a1e737357d(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $368997c7fea60e4e$export$882b5998b3b9117c(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $368997c7fea60e4e$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $368997c7fea60e4e$var$Overlay(t.largestBatchId, $368997c7fea60e4e$var$__PRIVATE_fromMutation(e.yt, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $368997c7fea60e4e$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $368997c7fea60e4e$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp($368997c7fea60e4e$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $368997c7fea60e4e$export$56c0d5a1e737357d(e.bundledQuery),
                    readTime: $368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $368997c7fea60e4e$var$__PRIVATE_toDbTimestamp($368997c7fea60e4e$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_bundlesStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$fe);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_namedQueriesStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$pe);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static wt(e, t) {
        const n = t.uid || "";
        return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e).get($368997c7fea60e4e$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $368997c7fea60e4e$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap();
        return $368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $368997c7fea60e4e$var$Overlay(t, i);
            r.push(this.bt(e, s));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e).X($368997c7fea60e4e$var$Ke, r));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap(), i = $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e).H($368997c7fea60e4e$var$Ke, s).next((e)=>{
            for (const t of e){
                const e = $368997c7fea60e4e$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e).ee({
            index: $368997c7fea60e4e$var$Ue,
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $368997c7fea60e4e$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    bt(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $368997c7fea60e4e$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $368997c7fea60e4e$var$toMutation(e.yt, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_documentOverlayStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$Le);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbGlobalsCache {
    St(e) {
        return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$We);
    }
    getSessionToken(e) {
        return this.St(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $368997c7fea60e4e$export$9d398bebfec1c039.fromUint8Array(t) : $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.St(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Dt(e, t) {
        this.Ct(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.vt();
    }
    Ct(e, t) {
        if ("nullValue" in e) this.Ft(t, 5);
        else if ("booleanValue" in e) this.Ft(t, 10), t.Mt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Ft(t, 15), t.Mt($368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Ft(t, 13) : (this.Ft(t, 15), $368997c7fea60e4e$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.Mt(0) : t.Mt(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.Ft(t, 20), "string" == typeof n && (n = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(n)), t.xt(`${n.seconds || ""}`), t.Mt(n.nanos || 0);
        } else if ("stringValue" in e) this.Ot(e.stringValue, t), this.Nt(t);
        else if ("bytesValue" in e) this.Ft(t, 30), t.Bt($368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Nt(t);
        else if ("referenceValue" in e) this.Lt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Ft(t, 45), t.Mt(n.latitude || 0), t.Mt(n.longitude || 0);
        } else "mapValue" in e ? $368997c7fea60e4e$var$__PRIVATE_isMaxValue(e) ? this.Ft(t, Number.MAX_SAFE_INTEGER) : $368997c7fea60e4e$var$__PRIVATE_isVectorValue(e) ? this.kt(e.mapValue, t) : (this.Kt(e.mapValue, t), this.Nt(t)) : "arrayValue" in e ? (this.qt(e.arrayValue, t), this.Nt(t)) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(19022, {
            Ut: e
        });
    }
    Ot(e, t) {
        this.Ft(t, 25), this.$t(e, t);
    }
    $t(e, t) {
        t.xt(e);
    }
    Kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 55);
        for (const e of Object.keys(n))this.Ot(e, t), this.Ct(n[e], t);
    }
    kt(e, t) {
        const n = e.fields || {};
        this.Ft(t, 53);
        // Vectors sort first by length
        const r = $368997c7fea60e4e$var$ct, i = n[r].arrayValue?.values?.length || 0;
        this.Ft(t, 15), t.Mt($368997c7fea60e4e$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.Ot(r, t), this.Ct(n[r], t);
    }
    qt(e, t) {
        const n = e.values || [];
        this.Ft(t, 50);
        for (const e of n)this.Ct(e, t);
    }
    Lt(e, t) {
        this.Ft(t, 37);
        $368997c7fea60e4e$export$90a7f3efeed30595.fromName(e).path.forEach((e)=>{
            this.Ft(t, 60), this.$t(e, t);
        });
    }
    Ft(e, t) {
        e.Mt(t);
    }
    Nt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.Mt(2);
    }
}
$368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt = new $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $368997c7fea60e4e$var$yt = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $368997c7fea60e4e$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $368997c7fea60e4e$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $368997c7fea60e4e$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $368997c7fea60e4e$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Qt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Gt(n.value), n = t.next();
        this.zt();
    }
    jt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ht(n.value), n = t.next();
        this.Jt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Zt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Gt(e);
            else if (e < 2048) this.Gt(960 | e >>> 6), this.Gt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Gt(480 | e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Gt(240 | e >>> 18), this.Gt(128 | 63 & e >>> 12), this.Gt(128 | 63 & e >>> 6), this.Gt(128 | 63 & e);
            }
        }
        this.zt();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Xt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ht(e);
            else if (e < 2048) this.Ht(960 | e >>> 6), this.Ht(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ht(480 | e >>> 12), this.Ht(128 | 63 & e >>> 6), this.Ht(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ht(240 | e >>> 18), this.Ht(128 | 63 & e >>> 12), this.Ht(128 | 63 & e >>> 6), this.Ht(128 | 63 & e);
            }
        }
        this.Jt();
    }
    Yt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $368997c7fea60e4e$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    nn(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.en(e), n = $368997c7fea60e4e$var$__PRIVATE_unsignedNumLength(t);
        this.tn(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ rn() {
        this.sn($368997c7fea60e4e$var$yt), this.sn(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ _n() {
        this.an($368997c7fea60e4e$var$yt), this.an(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.tn(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ un() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ en(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Gt(e) {
        const t = 255 & e;
        0 === t ? (this.sn(0), this.sn(255)) : t === $368997c7fea60e4e$var$yt ? (this.sn($368997c7fea60e4e$var$yt), this.sn(0)) : this.sn(t);
    }
    /** Writes a single byte descending to the buffer.  */ Ht(e) {
        const t = 255 & e;
        0 === t ? (this.an(0), this.an(255)) : t === $368997c7fea60e4e$var$yt ? (this.an($368997c7fea60e4e$var$yt), this.an(0)) : this.an(e);
    }
    zt() {
        this.sn(0), this.sn(1);
    }
    Jt() {
        this.an(0), this.an(1);
    }
    sn(e) {
        this.tn(1), this.buffer[this.position++] = e;
    }
    an(e) {
        this.tn(1), this.buffer[this.position++] = ~e;
    }
    tn(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.Qt(e);
    }
    xt(e) {
        this.cn.Zt(e);
    }
    Mt(e) {
        this.cn.Yt(e);
    }
    vt() {
        this.cn.rn();
    }
}
class $368997c7fea60e4e$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.cn = e;
    }
    Bt(e) {
        this.cn.jt(e);
    }
    xt(e) {
        this.cn.Xt(e);
    }
    Mt(e) {
        this.cn.nn(e);
    }
    vt() {
        this.cn._n();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.cn = new $368997c7fea60e4e$var$__PRIVATE_OrderedCodeWriter, this.ascending = new $368997c7fea60e4e$var$__PRIVATE_AscendingIndexByteEncoder(this.cn), this.descending = new $368997c7fea60e4e$var$__PRIVATE_DescendingIndexByteEncoder(this.cn);
    }
    seed(e) {
        this.cn.seed(e);
    }
    ln(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    un() {
        return this.cn.un();
    }
    reset() {
        this.cn.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $368997c7fea60e4e$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.hn = e, this.Pn = t, this.Tn = n, this.In = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ En() {
        const e = this.In.length, t = 0 === e || 255 === this.In[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.In, 0), t !== e ? n.set([
            0
        ], this.In.length) : ++n[n.length - 1], new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(this.hn, this.Pn, this.Tn, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Rn(e, t, n) {
        return {
            indexId: this.hn,
            uid: e,
            arrayValue: $368997c7fea60e4e$var$__PRIVATE_encodeKeySafeBytes(this.Tn),
            directionalValue: $368997c7fea60e4e$var$__PRIVATE_encodeKeySafeBytes(this.In),
            orderedDocumentKey: $368997c7fea60e4e$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    An(e, t, n) {
        const r = this.Rn(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.hn - t.hn;
    return 0 !== n ? n : (n = $368997c7fea60e4e$var$__PRIVATE_compareByteArrays(e.Tn, t.Tn), 0 !== n ? n : (n = $368997c7fea60e4e$var$__PRIVATE_compareByteArrays(e.In, t.In), 0 !== n ? n : $368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.Pn, t.Pn)));
}
function $368997c7fea60e4e$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $368997c7fea60e4e$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $9k0Bn.isSafariOrWebkit)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $368997c7fea60e4e$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $368997c7fea60e4e$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.Vn = new $368997c7fea60e4e$var$SortedSet((e, t)=>$368997c7fea60e4e$export$cf2f7c5792f80b46.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.dn = e.orderBy, this.mn = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Vn = this.Vn.add(e) : this.mn.push(e);
        }
    }
    get fn() {
        return this.Vn.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ gn(e) {
        if ($368997c7fea60e4e$export$c18d01048907ea92(e.collectionGroup === this.collectionId, 49279), this.fn) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.pn(t)) return !1;
        const n = $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.pn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.Vn.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.Vn.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.yn(e, t) || !this.wn(this.dn[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.dn.length || !this.wn(this.dn[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ bn() {
        if (this.fn) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator);
        const t = [];
        for (const n of this.mn){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $368997c7fea60e4e$export$c9170ad7d4cd7e57(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $368997c7fea60e4e$export$c9170ad7d4cd7e57(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.dn)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $368997c7fea60e4e$export$c9170ad7d4cd7e57(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $368997c7fea60e4e$export$ee7c8ad385a60b7b($368997c7fea60e4e$export$ee7c8ad385a60b7b.UNKNOWN_ID, this.collectionId, t, $368997c7fea60e4e$export$995eb9fca571757.empty());
    }
    pn(e) {
        for (const t of this.mn)if (this.yn(t, e)) return !0;
        return !1;
    }
    yn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    wn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $368997c7fea60e4e$var$__PRIVATE_computeInExpansion(e) {
    if ($368997c7fea60e4e$export$c18d01048907ea92(e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 || e instanceof $368997c7fea60e4e$export$35e795649ee09318, 20012), e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9) {
        if (e instanceof $368997c7fea60e4e$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$368997c7fea60e4e$export$dda1d9f60106f0e9.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $368997c7fea60e4e$export$35e795649ee09318.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_computeInExpansion(e));
    return $368997c7fea60e4e$export$35e795649ee09318.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function $368997c7fea60e4e$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $368997c7fea60e4e$var$__PRIVATE_computeDistributedNormalForm($368997c7fea60e4e$var$__PRIVATE_computeInExpansion(e));
    return $368997c7fea60e4e$export$c18d01048907ea92($368997c7fea60e4e$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $368997c7fea60e4e$var$__PRIVATE_isSingleFieldFilter(t) || $368997c7fea60e4e$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $368997c7fea60e4e$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $368997c7fea60e4e$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $368997c7fea60e4e$export$35e795649ee09318 && $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $368997c7fea60e4e$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $368997c7fea60e4e$var$__PRIVATE_isSingleFieldFilter(e) || $368997c7fea60e4e$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $368997c7fea60e4e$export$35e795649ee09318 && $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$368997c7fea60e4e$var$__PRIVATE_isSingleFieldFilter(t) && !$368997c7fea60e4e$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $368997c7fea60e4e$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($368997c7fea60e4e$export$c18d01048907ea92(e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 || e instanceof $368997c7fea60e4e$export$35e795649ee09318, 34018), e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9) return e;
    if (1 === e.filters.length) return $368997c7fea60e4e$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $368997c7fea60e4e$export$35e795649ee09318.create(t, e.op);
    return n = $368997c7fea60e4e$var$__PRIVATE_applyAssociation(n), $368997c7fea60e4e$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($368997c7fea60e4e$export$c18d01048907ea92(n instanceof $368997c7fea60e4e$export$35e795649ee09318, 64498), $368997c7fea60e4e$export$c18d01048907ea92($368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $368997c7fea60e4e$export$c18d01048907ea92(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$368997c7fea60e4e$var$__PRIVATE_applyDistribution(e, t)));
}
function $368997c7fea60e4e$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $368997c7fea60e4e$export$c18d01048907ea92(e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 || e instanceof $368997c7fea60e4e$export$35e795649ee09318, 38388), $368997c7fea60e4e$export$c18d01048907ea92(t instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 || t instanceof $368997c7fea60e4e$export$35e795649ee09318, 25473), // FieldFilter FieldFilter
    n = e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? t instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $368997c7fea60e4e$export$35e795649ee09318.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $368997c7fea60e4e$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? $368997c7fea60e4e$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($368997c7fea60e4e$export$c18d01048907ea92(e.filters.length > 0 && t.filters.length > 0, 48005), $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(e) && $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(t)) return $368997c7fea60e4e$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $368997c7fea60e4e$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$368997c7fea60e4e$var$__PRIVATE_applyDistribution(e, r));
        return $368997c7fea60e4e$export$35e795649ee09318.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $368997c7fea60e4e$var$__PRIVATE_applyAssociation(n);
}
function $368997c7fea60e4e$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($368997c7fea60e4e$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $368997c7fea60e4e$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$368997c7fea60e4e$var$__PRIVATE_applyDistribution(e, t));
        return $368997c7fea60e4e$export$35e795649ee09318.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $368997c7fea60e4e$var$__PRIVATE_applyAssociation(e) {
    if ($368997c7fea60e4e$export$c18d01048907ea92(e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 || e instanceof $368997c7fea60e4e$export$35e795649ee09318, 11850), e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $368997c7fea60e4e$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($368997c7fea60e4e$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$368997c7fea60e4e$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 ? r.push(t) : t instanceof $368997c7fea60e4e$export$35e795649ee09318 && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $368997c7fea60e4e$export$35e795649ee09318.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Sn = new $368997c7fea60e4e$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Sn.add(t), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.Sn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve($368997c7fea60e4e$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve($368997c7fea60e4e$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$db202ddc8be9136.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$db202ddc8be9136.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$wt = "IndexedDbIndexManager", $368997c7fea60e4e$var$bt = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Dn = new $368997c7fea60e4e$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Cn = new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyTarget(e), (e, t)=>$368997c7fea60e4e$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Dn.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Dn.add(t);
            });
            const i = {
                collectionId: n,
                parent: $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(r)
            };
            return $368997c7fea60e4e$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $368997c7fea60e4e$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $368997c7fea60e4e$var$__PRIVATE_collectionParentsStore(e).H(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($368997c7fea60e4e$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e), r = $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e), i = $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e), n = $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e), r = $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e);
        return t.X().next(()=>n.X()).next(()=>r.X());
    }
    createTargetIndexes(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.forEach(this.vn(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $368997c7fea60e4e$var$__PRIVATE_TargetIndexMatcher(t).bn();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $368997c7fea60e4e$var$PersistencePromise.forEach(this.vn(t), (t)=>this.Fn(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $368997c7fea60e4e$export$971d5caa766a69d7();
                const r = [];
                return $368997c7fea60e4e$var$PersistencePromise.forEach(i, (i, s)=>{
                    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$wt, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$368997c7fea60e4e$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $368997c7fea60e4e$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $368997c7fea60e4e$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $368997c7fea60e4e$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $368997c7fea60e4e$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $368997c7fea60e4e$export$625550452a3fa3ec(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $368997c7fea60e4e$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $368997c7fea60e4e$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $368997c7fea60e4e$export$625550452a3fa3ec(n, r);
                    }(s, i), c = this.Mn(i, s, a), l = this.Mn(i, s, u), h = this.xn(i, s, _), P = this.On(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $368997c7fea60e4e$var$PersistencePromise.forEach(P, (i)=>n.Z(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $368997c7fea60e4e$var$PersistencePromise.resolve(null);
        });
    }
    vn(e) {
        let t = this.Cn.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $368997c7fea60e4e$var$__PRIVATE_getDnfTerms($368997c7fea60e4e$export$35e795649ee09318.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$368997c7fea60e4e$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Cn.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ On(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Nn(t[c / a]) : $368997c7fea60e4e$var$bt, l = this.Bn(e, _, n[c % a], r), h = this.Ln(e, _, i[c % a], s), P = o.map((t)=>this.Bn(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ Bn(e, t, n, r) {
        const i = new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(e, $368997c7fea60e4e$export$90a7f3efeed30595.empty(), t, n);
        return r ? i : i.En();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ Ln(e, t, n, r) {
        const i = new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(e, $368997c7fea60e4e$export$90a7f3efeed30595.empty(), t, n);
        return r ? i.En() : i;
    }
    Fn(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.gn(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.vn(t);
        return $368997c7fea60e4e$var$PersistencePromise.forEach(r, (t)=>this.Fn(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$export$cf2f7c5792f80b46.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ kn(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder;
        for (const r of $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.ln(r.kind);
            $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, i);
        }
        return n.un();
    }
    /** Encodes a single value to the ascending index format. */ Nn(e) {
        const t = new $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder;
        return $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t.ln(0 /* IndexKind.ASCENDING */ )), t.un();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ Kn(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder;
        return $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt($368997c7fea60e4e$export$43caf9889c228507(this.databaseId, t), n.ln(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.un();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ xn(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.qn(t, s.fieldPath) && $368997c7fea60e4e$var$isArray(e)) r = this.Un(r, s, e);
            else {
                const t = n.ln(s.kind);
                $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, t);
            }
        }
        return this.$n(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ Mn(e, t, n) {
        return this.xn(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ $n(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].un();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Un(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $368997c7fea60e4e$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.un()), $368997c7fea60e4e$var$__PRIVATE_FirestoreIndexValueWriter.Wt.Dt(e, r.ln(t.kind)), i.push(r);
        }
        return i;
    }
    qn(e, t) {
        return !!e.filters.find((e)=>e instanceof $368997c7fea60e4e$export$dda1d9f60106f0e9 && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e), r = $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e);
        return (t ? n.H($368997c7fea60e4e$var$Se, IDBKeyRange.bound(t, t)) : n.H()).next((e)=>{
            const t = [];
            return $368997c7fea60e4e$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $368997c7fea60e4e$export$995eb9fca571757(t.sequenceNumber, new $368997c7fea60e4e$var$IndexOffset($368997c7fea60e4e$var$__PRIVATE_fromDbTimestamp(t.readTime), new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $368997c7fea60e4e$export$995eb9fca571757.empty(), r = e.fields.map(([e, t])=>new $368997c7fea60e4e$export$c9170ad7d4cd7e57($368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(e), t));
                        return new $368997c7fea60e4e$export$ee7c8ad385a60b7b(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e), i = $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e);
        return this.Wn(e).next((e)=>r.H($368997c7fea60e4e$var$Se, IDBKeyRange.bound(t, t)).next((t)=>$368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>i.put($368997c7fea60e4e$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $368997c7fea60e4e$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $368997c7fea60e4e$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $368997c7fea60e4e$var$PersistencePromise.forEach(i, (n)=>this.Qn(e, t, n).next((t)=>{
                        const i = this.Gn(r, n);
                        return t.isEqual(i) ? $368997c7fea60e4e$var$PersistencePromise.resolve() : this.zn(e, r, n, t, i);
                    }))));
        });
    }
    jn(e, t, n, r) {
        return $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e).put(r.Rn(this.uid, this.Kn(n, t.key), t.key));
    }
    Hn(e, t, n, r) {
        return $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e).delete(r.An(this.uid, this.Kn(n, t.key), t.key));
    }
    Qn(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e);
        let i = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_indexEntryComparator);
        return r.ee({
            index: $368997c7fea60e4e$var$Ne,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $368997c7fea60e4e$var$__PRIVATE_encodeKeySafeBytes(this.Kn(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(n.indexId, t, $368997c7fea60e4e$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $368997c7fea60e4e$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Gn(e, t) {
        let n = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_indexEntryComparator);
        const r = this.kn(t, e);
        if (null == r) return n;
        const i = $368997c7fea60e4e$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($368997c7fea60e4e$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Nn(i), r));
        } else n = n.add(new $368997c7fea60e4e$var$__PRIVATE_IndexEntry(t.indexId, e.key, $368997c7fea60e4e$var$bt, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ zn(e, t, n, r, i) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$wt, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(s), a = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(s)) : (_ = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(s), a = $368997c7fea60e4e$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.jn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Hn(e, t, n, r));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(s);
    }
    Wn(e) {
        let t = 1;
        return $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e).ee({
            index: $368997c7fea60e4e$var$Fe,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(i, e), s = $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.En();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.En());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Jn(r[e], r[e + 1])) return [];
            const t = r[e].An(this.uid, $368997c7fea60e4e$var$bt, $368997c7fea60e4e$export$90a7f3efeed30595.empty()), n = r[e + 1].An(this.uid, $368997c7fea60e4e$var$bt, $368997c7fea60e4e$export$90a7f3efeed30595.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Jn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $368997c7fea60e4e$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($368997c7fea60e4e$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.mapArray(this.vn(t), (t)=>this.Fn(e, t).next((e)=>e || $368997c7fea60e4e$export$3a6d5c9ae78a2c08(44426))).next($368997c7fea60e4e$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $368997c7fea60e4e$var$__PRIVATE_collectionParentsStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$Ae);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_indexEntriesStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$xe);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_indexConfigurationStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$we);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_indexStateStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$Ce);
}
function $368997c7fea60e4e$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $368997c7fea60e4e$export$c18d01048907ea92(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $368997c7fea60e4e$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $368997c7fea60e4e$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$St = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $368997c7fea60e4e$var$Dt = 41943040;
class $368997c7fea60e4e$var$LruParams {
    static withCacheSize(e) {
        return new $368997c7fea60e4e$var$LruParams(e, $368997c7fea60e4e$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $368997c7fea60e4e$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $368997c7fea60e4e$var$removeMutationBatch(e, t, n) {
    const r = e.store($368997c7fea60e4e$var$H), i = e.store($368997c7fea60e4e$var$ee), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.ee({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $368997c7fea60e4e$export$c18d01048907ea92(1 === _, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $368997c7fea60e4e$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $368997c7fea60e4e$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $368997c7fea60e4e$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $368997c7fea60e4e$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $368997c7fea60e4e$var$LruParams.DEFAULT = new $368997c7fea60e4e$var$LruParams($368997c7fea60e4e$var$Dt, $368997c7fea60e4e$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $368997c7fea60e4e$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $368997c7fea60e4e$var$LruParams.DISABLED = new $368997c7fea60e4e$var$LruParams(-1, 0, 0);
class $368997c7fea60e4e$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Zn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static wt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $368997c7fea60e4e$export$c18d01048907ea92("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).ee({
            index: $368997c7fea60e4e$var$Z,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e), s = $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $368997c7fea60e4e$export$c18d01048907ea92("number" == typeof o, 49019);
            const _ = new $368997c7fea60e4e$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$368997c7fea60e4e$var$toMutation(e.yt, t)), i = n.mutations.map((t)=>$368997c7fea60e4e$var$toMutation(e.yt, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $368997c7fea60e4e$var$SortedSet((e, t)=>$368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $368997c7fea60e4e$var$Y));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.Zn[o] = _.keys();
            }), $368997c7fea60e4e$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($368997c7fea60e4e$export$c18d01048907ea92(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Xn(e, t) {
        return this.Zn[t] ? $368997c7fea60e4e$var$PersistencePromise.resolve(this.Zn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.Zn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).ee({
            index: $368997c7fea60e4e$var$Z,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($368997c7fea60e4e$export$c18d01048907ea92(t.batchId >= n, 47524, {
                Yn: n
            }), i = $368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $368997c7fea60e4e$var$U;
        return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).ee({
            index: $368997c7fea60e4e$var$Z,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $368997c7fea60e4e$var$U
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).H($368997c7fea60e4e$var$Z, t).next((e)=>e.map((e)=>$368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(61480, {
                    er: n,
                    batchId: a
                });
                $368997c7fea60e4e$export$c18d01048907ea92(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(r).next(()=>this.tr(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
        return $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.tr(e, o));
    }
    tr(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($368997c7fea60e4e$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(35274, {
                    batchId: t
                });
                $368997c7fea60e4e$export$c18d01048907ea92(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $368997c7fea60e4e$var$removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.nr(t.batchId);
            }), $368997c7fea60e4e$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    nr(e) {
        delete this.Zn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $368997c7fea60e4e$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $368997c7fea60e4e$export$c18d01048907ea92(0 === r.length, 56720, {
                    rr: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ ir(e) {
        return $368997c7fea60e4e$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $368997c7fea60e4e$var$U,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e).ee({
        range: s,
        Y: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationsStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$H);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_documentMutationsStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$ee);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_mutationQueuesStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$z);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.sr = e;
    }
    next() {
        return this.sr += 2, this.sr;
    }
    static _r() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator(0);
    }
    static ar() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.ur(e).next((t)=>{
            const n = new $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.cr(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.ur(e).next((e)=>$368997c7fea60e4e$var$SnapshotVersion.fromTimestamp(new $368997c7fea60e4e$export$3d12bd131bb975d1(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.ur(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.ur(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.cr(e, r)));
    }
    addTargetData(e, t) {
        return this.lr(e, t).next(()=>this.ur(e).next((n)=>(n.targetCount += 1, this.hr(t, n), this.cr(e, n))));
    }
    updateTargetData(e, t) {
        return this.lr(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$368997c7fea60e4e$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.ur(e)).next((t)=>($368997c7fea60e4e$export$c18d01048907ea92(t.targetCount > 0, 8065), t.targetCount -= 1, this.cr(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $368997c7fea60e4e$var$__PRIVATE_targetsStore(e).ee((s, o)=>{
            const _ = $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    ur(e) {
        return $368997c7fea60e4e$var$__PRIVATE_globalTargetStore(e).get($368997c7fea60e4e$var$Ee).next((e)=>($368997c7fea60e4e$export$c18d01048907ea92(null !== e, 2888), e));
    }
    cr(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_globalTargetStore(e).put($368997c7fea60e4e$var$Ee, t);
    }
    lr(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_targetsStore(e).put($368997c7fea60e4e$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ hr(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.ur(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $368997c7fea60e4e$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $368997c7fea60e4e$var$__PRIVATE_targetsStore(e).ee({
            range: r,
            index: $368997c7fea60e4e$var$ce
        }, (e, n, r)=>{
            const s = $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $368997c7fea60e4e$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e);
        return $368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>{
            const i = $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t.path);
            return $368997c7fea60e4e$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e);
        let i = $368997c7fea60e4e$export$971d5caa766a69d7();
        return r.ee({
            range: n,
            Y: !0
        }, (e, t, n)=>{
            const r = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(e[1]), s = new $368997c7fea60e4e$export$90a7f3efeed30595(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $368997c7fea60e4e$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e).ee({
            index: $368997c7fea60e4e$var$Te,
            Y: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    At(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_targetsStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$ue);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_globalTargetStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$Re);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$he);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Ct = "LruGarbageCollector", $368997c7fea60e4e$var$vt = 1048576;
function $368997c7fea60e4e$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $368997c7fea60e4e$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.Pr = e, this.buffer = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_bufferEntryComparator), this.Tr = 0;
    }
    Ir() {
        return ++this.Tr;
    }
    Er(e) {
        const t = [
            e,
            this.Ir()
        ];
        if (this.buffer.size < this.Pr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $368997c7fea60e4e$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $368997c7fea60e4e$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Rr = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Ar(6e4);
    }
    stop() {
        this.Rr && (this.Rr.cancel(), this.Rr = null);
    }
    get started() {
        return null !== this.Rr;
    }
    Ar(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ct, `Garbage collection scheduled in ${e}ms`), this.Rr = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Rr = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e) ? $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ct, "Ignoring IndexedDB error during garbage collection: ", e) : await $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Ar(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $368997c7fea60e4e$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Vr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Vr.dr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $368997c7fea60e4e$var$PersistencePromise.resolve($368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce);
        const n = new $368997c7fea60e4e$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Vr.forEachTarget(e, (e)=>n.Er(e.sequenceNumber)).next(()=>this.Vr.mr(e, (e)=>n.Er(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Vr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Vr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($368997c7fea60e4e$export$21579262ef46735b("LruGarbageCollector", "Garbage collection skipped; disabled"), $368997c7fea60e4e$var$PersistencePromise.resolve($368997c7fea60e4e$var$St)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($368997c7fea60e4e$export$21579262ef46735b("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $368997c7fea60e4e$var$St) : this.gr(e, t));
    }
    getCacheSize(e) {
        return this.Vr.getCacheSize(e);
    }
    gr(e, t) {
        let n, r, i, s, o, _, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($368997c7fea60e4e$export$21579262ef46735b("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, _ = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), $368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG) $368997c7fea60e4e$export$21579262ef46735b("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (_ - o) + "ms\n" + `\tRemoved ${e} documents in ` + (a - _) + "ms\n" + `Total Duration: ${a - u}ms`);
            return $368997c7fea60e4e$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $368997c7fea60e4e$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $368997c7fea60e4e$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $368997c7fea60e4e$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    mr(e, t) {
        return this.yr(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $368997c7fea60e4e$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $368997c7fea60e4e$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ wr(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $368997c7fea60e4e$var$__PRIVATE_mutationQueuesStore(e).te((r)=>$368997c7fea60e4e$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $368997c7fea60e4e$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.yr(e, (s, o)=>{
            if (o <= t) {
                const t = this.wr(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $368997c7fea60e4e$var$SnapshotVersion.min()), $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ yr(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e);
        let r, i = $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce;
        return n.ee({
            index: $368997c7fea60e4e$var$Te
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce && t(new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce && t(new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_writeSentinelKey(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $368997c7fea60e4e$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $368997c7fea60e4e$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $368997c7fea60e4e$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $368997c7fea60e4e$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.br(e, n)));
    }
    getEntry(e, t) {
        let n = $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(t);
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $368997c7fea60e4e$var$re,
            range: IDBKeyRange.only($368997c7fea60e4e$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.Sr(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Dr(e, t) {
        let n = {
            size: 0,
            document: $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(t)
        };
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $368997c7fea60e4e$var$re,
            range: IDBKeyRange.only($368997c7fea60e4e$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.Sr(t, r),
                size: $368997c7fea60e4e$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        return this.Cr(e, t, (e, t)=>{
            const r = this.Sr(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ vr(e, t) {
        let n = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), r = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
        return this.Cr(e, t, (e, t)=>{
            const i = this.Sr(e, t);
            n = n.insert(e, i), r = r.insert(e, $368997c7fea60e4e$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Fr: r
            }));
    }
    Cr(e, t, n) {
        if (t.isEmpty()) return $368997c7fea60e4e$var$PersistencePromise.resolve();
        let r = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($368997c7fea60e4e$var$__PRIVATE_dbKey(r.first()), $368997c7fea60e4e$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $368997c7fea60e4e$var$re,
            range: i
        }, (e, t, r)=>{
            const i = $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $368997c7fea60e4e$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.j($368997c7fea60e4e$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = t.path, o = [
            s.popLast().toArray(),
            s.lastSegment(),
            $368997c7fea60e4e$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).H(IDBKeyRange.bound(o, _, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.Sr($368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($368997c7fea60e4e$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        const s = $368997c7fea60e4e$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $368997c7fea60e4e$var$__PRIVATE_dbCollectionGroupKey(t, $368997c7fea60e4e$var$IndexOffset.max());
        return $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $368997c7fea60e4e$var$se,
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.Sr($368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $368997c7fea60e4e$var$__PRIVATE_documentGlobalStore(e).get($368997c7fea60e4e$var$ae).next((e)=>($368997c7fea60e4e$export$c18d01048907ea92(!!e, 20021), e));
    }
    br(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_documentGlobalStore(e).put($368997c7fea60e4e$var$ae, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ Sr(e, t) {
        if (t) {
            const e = $368997c7fea60e4e$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()))) return e;
        }
        return $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $368997c7fea60e4e$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $368997c7fea60e4e$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.Mr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.Or = new $368997c7fea60e4e$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $368997c7fea60e4e$var$SortedSet((e, t)=>$368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this.Or.get(i);
            if (t.push(this.Mr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $368997c7fea60e4e$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $368997c7fea60e4e$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.Mr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $368997c7fea60e4e$var$__PRIVATE_toDbRemoteDocument(this.Mr.serializer, s.convertToNoDocument($368997c7fea60e4e$var$SnapshotVersion.min()));
                t.push(this.Mr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.Mr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.Mr.updateMetadata(e, n)), $368997c7fea60e4e$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.Mr.Dr(e, t).next((e)=>(this.Or.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.Mr.vr(e, t).next(({ documents: e, Fr: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.Or.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $368997c7fea60e4e$var$__PRIVATE_documentGlobalStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$_e);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_remoteDocumentsStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$te);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $368997c7fea60e4e$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $368997c7fea60e4e$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $368997c7fea60e4e$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $368997c7fea60e4e$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $368997c7fea60e4e$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $368997c7fea60e4e$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $368997c7fea60e4e$var$FieldMask.empty(), $368997c7fea60e4e$export$3d12bd131bb975d1.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $368997c7fea60e4e$export$971d5caa766a69d7()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $368997c7fea60e4e$export$971d5caa766a69d7()) {
        const r = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $368997c7fea60e4e$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $368997c7fea60e4e$export$971d5caa766a69d7()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        const s = $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $368997c7fea60e4e$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $368997c7fea60e4e$export$3d12bd131bb975d1.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $368997c7fea60e4e$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>o.set(e, new $368997c7fea60e4e$var$OverlayedDocument(t, s.get(e) ?? null))), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $368997c7fea60e4e$var$SortedMap((e, t)=>e - t), i = $368997c7fea60e4e$export$971d5caa766a69d7();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $368997c7fea60e4e$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $368997c7fea60e4e$export$971d5caa766a69d7()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $368997c7fea60e4e$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $368997c7fea60e4e$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $368997c7fea60e4e$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return $368997c7fea60e4e$export$51b138e5a065c2bb(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $368997c7fea60e4e$export$3b14a55fb2447963(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $368997c7fea60e4e$var$PersistencePromise.resolve($368997c7fea60e4e$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = $368997c7fea60e4e$var$B, _ = i;
            return s.next((t)=>$368997c7fea60e4e$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $368997c7fea60e4e$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $368997c7fea60e4e$export$971d5caa766a69d7())).next((e)=>({
                        batchId: o,
                        changes: $368997c7fea60e4e$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $368997c7fea60e4e$export$90a7f3efeed30595(t)).next((e)=>{
            let t = $368997c7fea60e4e$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $368997c7fea60e4e$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((o)=>$368997c7fea60e4e$var$PersistencePromise.forEach(o, (o)=>{
                const _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, o.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, _, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            i.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $368997c7fea60e4e$var$documentMap();
            return e.forEach((e, r)=>{
                const s = i.get(e);
                void 0 !== s && $368997c7fea60e4e$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $368997c7fea60e4e$var$FieldMask.empty(), $368997c7fea60e4e$export$3d12bd131bb975d1.now()), // Finally, insert the documents that still match the query
                $368997c7fea60e4e$var$__PRIVATE_queryMatches(t, r) && (n = n.insert(e, r));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Nr = new Map, this.Br = new Map;
    }
    getBundleMetadata(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.Nr.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Nr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $368997c7fea60e4e$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.Br.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Br.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $368997c7fea60e4e$export$56c0d5a1e737357d(e.bundledQuery),
                readTime: $368997c7fea60e4e$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator), this.Lr = new Map;
    }
    getOverlay(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap();
        return $368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.bt(e, t, r);
        }), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Lr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Lr.delete(n)), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $368997c7fea60e4e$export$90a7f3efeed30595(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $368997c7fea60e4e$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $368997c7fea60e4e$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $368997c7fea60e4e$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $368997c7fea60e4e$var$PersistencePromise.resolve(o);
    }
    bt(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Lr.get(r.largestBatchId).delete(n.key);
            this.Lr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $368997c7fea60e4e$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Lr.get(t);
        void 0 === i && (i = $368997c7fea60e4e$export$971d5caa766a69d7(), this.Lr.set(t, i)), this.Lr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $368997c7fea60e4e$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.kr = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_DocReference.Kr), // A set of outstanding references to a document sorted by target id.
        this.qr = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_DocReference.Ur);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.kr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_DocReference(e, t);
        this.kr = this.kr.add(n), this.qr = this.qr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ $r(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Wr(new $368997c7fea60e4e$var$__PRIVATE_DocReference(e, t));
    }
    Qr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Gr(e) {
        const t = new $368997c7fea60e4e$export$90a7f3efeed30595(new $368997c7fea60e4e$export$db202ddc8be9136([])), n = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, e), r = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Wr(e), i.push(e.key);
        }), i;
    }
    zr() {
        this.kr.forEach((e)=>this.Wr(e));
    }
    Wr(e) {
        this.kr = this.kr.delete(e), this.qr = this.qr.delete(e);
    }
    jr(e) {
        const t = new $368997c7fea60e4e$export$90a7f3efeed30595(new $368997c7fea60e4e$export$db202ddc8be9136([])), n = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, e), r = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, e + 1);
        let i = $368997c7fea60e4e$export$971d5caa766a69d7();
        return this.qr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $368997c7fea60e4e$var$__PRIVATE_DocReference(e, 0), n = this.kr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $368997c7fea60e4e$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.Hr = t;
    }
    /** Compare by key then by ID */ static Kr(e, t) {
        return $368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.key, t.key) || $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr);
    }
    /** Compare by ID then by key */ static Ur(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(e.Hr, t.Hr) || $368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.Yn = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Jr = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_DocReference.Kr);
    }
    checkEmpty(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.Yn;
        this.Yn++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $368997c7fea60e4e$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.Jr = this.Jr.add(new $368997c7fea60e4e$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $368997c7fea60e4e$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.Zr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.Xr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $368997c7fea60e4e$var$U : this.Yn - 1);
    }
    getAllMutationBatches(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, 0), r = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.Jr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.Zr(e.Hr);
            i.push(t);
        }), $368997c7fea60e4e$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $368997c7fea60e4e$var$__PRIVATE_DocReference(e, 0), r = new $368997c7fea60e4e$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.Jr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.Hr);
            });
        }), $368997c7fea60e4e$var$PersistencePromise.resolve(this.Yr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $368997c7fea60e4e$export$90a7f3efeed30595.isDocumentKey(i) || (i = i.child(""));
        const s = new $368997c7fea60e4e$var$__PRIVATE_DocReference(new $368997c7fea60e4e$export$90a7f3efeed30595(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_primitiveComparator);
        return this.Jr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.Hr)), !0);
        }, s), $368997c7fea60e4e$var$PersistencePromise.resolve(this.Yr(o));
    }
    Yr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.Zr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(0 === this.ei(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.Jr;
        return $368997c7fea60e4e$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $368997c7fea60e4e$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.Jr = n;
        });
    }
    nr(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_DocReference(t, 0), r = this.Jr.firstAfterOrEqual(n);
        return $368997c7fea60e4e$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ ei(e, t) {
        return this.Xr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ Xr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ Zr(e) {
        const t = this.Xr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.ti = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.ti(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $368997c7fea60e4e$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $368997c7fea60e4e$var$MutableDocument.newInvalidDocument(e));
        }), $368997c7fea60e4e$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $368997c7fea60e4e$export$90a7f3efeed30595(s.child("__id-9223372036854775808__")), _ = this.docs.getIteratorFrom(o);
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $368997c7fea60e4e$var$__PRIVATE_indexOffsetComparator($368997c7fea60e4e$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $368997c7fea60e4e$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $368997c7fea60e4e$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $368997c7fea60e4e$export$3a6d5c9ae78a2c08(9500);
    }
    ni(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $368997c7fea60e4e$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $368997c7fea60e4e$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.Mr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.Mr.addEntry(e, r)) : this.Mr.removeEntry(n);
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.Mr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.Mr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.ri = new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyTarget(e), $368997c7fea60e4e$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $368997c7fea60e4e$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.ii = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.si = new $368997c7fea60e4e$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.oi = $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator._r();
    }
    forEachTarget(e, t) {
        return this.ri.forEach((e, n)=>t(n)), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.ii);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.oi.next(), $368997c7fea60e4e$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.ii && (this.ii = t), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    lr(e) {
        this.ri.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.oi = new $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.ii && (this.ii = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.lr(t), this.targetCount += 1, $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.lr(t), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.ri.delete(t.target), this.si.Gr(t.targetId), this.targetCount -= 1, $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.ri.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.ri.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.ri.get(t) || null;
        return $368997c7fea60e4e$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.si.$r(t, n), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.si.Qr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $368997c7fea60e4e$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.si.Gr(t), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.si.jr(t);
        return $368997c7fea60e4e$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve(this.si.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this._i = {}, this.overlays = {}, this.ai = new $368997c7fea60e4e$var$__PRIVATE_ListenSequence(0), this.ui = !1, this.ui = !0, this.ci = new $368997c7fea60e4e$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.li = new $368997c7fea60e4e$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $368997c7fea60e4e$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $368997c7fea60e4e$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.hi(e)), this.serializer = new $368997c7fea60e4e$var$__PRIVATE_LocalSerializer(t), this.Pi = new $368997c7fea60e4e$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.ui = !1, Promise.resolve();
    }
    get started() {
        return this.ui;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $368997c7fea60e4e$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this._i[e.toKey()];
        return n || (n = new $368997c7fea60e4e$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this._i[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $368997c7fea60e4e$export$21579262ef46735b("MemoryPersistence", "Starting transaction:", e);
        const r = new $368997c7fea60e4e$var$__PRIVATE_MemoryTransaction(this.ai.next());
        return this.referenceDelegate.Ti(), n(r).next((e)=>this.referenceDelegate.Ii(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ei(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.or(Object.values(this._i).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $368997c7fea60e4e$var$__PRIVATE_MemoryTransaction extends $368997c7fea60e4e$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Ri = new $368997c7fea60e4e$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Ai = null;
    }
    static Vi(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get di() {
        if (this.Ai) return this.Ai;
        throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(60996);
    }
    addReference(e, t, n) {
        return this.Ri.addReference(n, t), this.di.delete(n.toString()), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Ri.removeReference(n, t), this.di.add(n.toString()), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.di.add(t.toString()), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Ri.Gr(t.targetId).forEach((e)=>this.di.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.di.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Ti() {
        this.Ai = new Set;
    }
    Ii(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $368997c7fea60e4e$var$PersistencePromise.forEach(this.di, (n)=>{
            const r = $368997c7fea60e4e$export$90a7f3efeed30595.fromPath(n);
            return this.mi(e, r).next((e)=>{
                e || t.removeEntry(r, $368997c7fea60e4e$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Ai = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.mi(e, t).next((e)=>{
            e ? this.di.delete(t.toString()) : this.di.add(t.toString());
        });
    }
    hi(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    mi(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.or([
            ()=>$368997c7fea60e4e$var$PersistencePromise.resolve(this.Ri.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ei(e, t)
        ]);
    }
}
class $368997c7fea60e4e$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.fi = new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $368997c7fea60e4e$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static Vi(e, t) {
        return new $368997c7fea60e4e$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Ti() {}
    Ii(e) {
        return $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    dr(e) {
        const t = this.pr(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    pr(e) {
        let t = 0;
        return this.mr(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    mr(e, t) {
        return $368997c7fea60e4e$var$PersistencePromise.forEach(this.fi, (n, r)=>this.wr(e, n, r).next((e)=>e ? $368997c7fea60e4e$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.ni(e, (r)=>this.wr(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $368997c7fea60e4e$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.fi.set(n, e.currentSequenceNumber), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.fi.set(t, e.currentSequenceNumber), $368997c7fea60e4e$var$PersistencePromise.resolve();
    }
    hi(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $368997c7fea60e4e$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    wr(e, t, n) {
        return $368997c7fea60e4e$var$PersistencePromise.or([
            ()=>this.persistence.Ei(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.fi.get(t);
                return $368997c7fea60e4e$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $368997c7fea60e4e$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ k(e, t, n, r) {
        const i = new $368997c7fea60e4e$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($368997c7fea60e4e$var$Q);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($368997c7fea60e4e$var$z, {
                keyPath: $368997c7fea60e4e$var$j
            });
            const t = e.createObjectStore($368997c7fea60e4e$var$H, {
                keyPath: $368997c7fea60e4e$var$J,
                autoIncrement: !0
            });
            t.createIndex($368997c7fea60e4e$var$Z, $368997c7fea60e4e$var$X, {
                unique: !0
            }), e.createObjectStore($368997c7fea60e4e$var$ee);
        }(e), $368997c7fea60e4e$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($368997c7fea60e4e$var$W);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $368997c7fea60e4e$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($368997c7fea60e4e$var$he), e.deleteObjectStore($368997c7fea60e4e$var$ue), e.deleteObjectStore($368997c7fea60e4e$var$Re);
        }(e), $368997c7fea60e4e$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($368997c7fea60e4e$var$Re), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $368997c7fea60e4e$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($368997c7fea60e4e$var$Ee, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($368997c7fea60e4e$var$H);
                return n.H().next((n)=>{
                    e.deleteObjectStore($368997c7fea60e4e$var$H);
                    e.createObjectStore($368997c7fea60e4e$var$H, {
                        keyPath: $368997c7fea60e4e$var$J,
                        autoIncrement: !0
                    }).createIndex($368997c7fea60e4e$var$Z, $368997c7fea60e4e$var$X, {
                        unique: !0
                    });
                    const r = t.store($368997c7fea60e4e$var$H), i = n.map((e)=>r.put(e));
                    return $368997c7fea60e4e$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($368997c7fea60e4e$var$de, {
                    keyPath: $368997c7fea60e4e$var$me
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.gi(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($368997c7fea60e4e$var$_e);
            })(e), this.pi(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.yi(i))), n < 8 && r >= 8 && (s = s.next(()=>this.wi(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.bi(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($368997c7fea60e4e$var$fe, {
                    keyPath: $368997c7fea60e4e$var$ge
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($368997c7fea60e4e$var$pe, {
                    keyPath: $368997c7fea60e4e$var$ye
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($368997c7fea60e4e$var$Le, {
                    keyPath: $368997c7fea60e4e$var$ke
                });
                t.createIndex($368997c7fea60e4e$var$Ke, $368997c7fea60e4e$var$qe, {
                    unique: !1
                }), t.createIndex($368997c7fea60e4e$var$Ue, $368997c7fea60e4e$var$$e, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($368997c7fea60e4e$var$te, {
                    keyPath: $368997c7fea60e4e$var$ne
                });
                t.createIndex($368997c7fea60e4e$var$re, $368997c7fea60e4e$var$ie), t.createIndex($368997c7fea60e4e$var$se, $368997c7fea60e4e$var$oe);
            })(e)).next(()=>this.Si(e, i)).next(()=>e.deleteObjectStore($368997c7fea60e4e$var$W))), n < 14 && r >= 14 && (s = s.next(()=>this.Di(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($368997c7fea60e4e$var$we, {
                    keyPath: $368997c7fea60e4e$var$be,
                    autoIncrement: !0
                });
                t.createIndex($368997c7fea60e4e$var$Se, $368997c7fea60e4e$var$De, {
                    unique: !1
                });
                const n = e.createObjectStore($368997c7fea60e4e$var$Ce, {
                    keyPath: $368997c7fea60e4e$var$ve
                });
                n.createIndex($368997c7fea60e4e$var$Fe, $368997c7fea60e4e$var$Me, {
                    unique: !1
                });
                const r = e.createObjectStore($368997c7fea60e4e$var$xe, {
                    keyPath: $368997c7fea60e4e$var$Oe
                });
                r.createIndex($368997c7fea60e4e$var$Ne, $368997c7fea60e4e$var$Be, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($368997c7fea60e4e$var$Ce).clear();
        }).next(()=>{
            t.objectStore($368997c7fea60e4e$var$xe).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($368997c7fea60e4e$var$We, {
                    keyPath: $368997c7fea60e4e$var$Qe
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $9k0Bn.isSafariOrWebkit)() && (s = s.next(()=>{
            t.objectStore($368997c7fea60e4e$var$Ce).clear();
        }).next(()=>{
            t.objectStore($368997c7fea60e4e$var$xe).clear();
        })), s;
    }
    pi(e) {
        let t = 0;
        return e.store($368997c7fea60e4e$var$W).ee((e, n)=>{
            t += $368997c7fea60e4e$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($368997c7fea60e4e$var$_e).put($368997c7fea60e4e$var$ae, n);
        });
    }
    gi(e) {
        const t = e.store($368997c7fea60e4e$var$z), n = e.store($368997c7fea60e4e$var$H);
        return t.H().next((t)=>$368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $368997c7fea60e4e$var$U
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.H($368997c7fea60e4e$var$Z, r).next((n)=>$368997c7fea60e4e$var$PersistencePromise.forEach(n, (n)=>{
                        $368997c7fea60e4e$export$c18d01048907ea92(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $368997c7fea60e4e$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ yi(e) {
        const t = e.store($368997c7fea60e4e$var$he), n = e.store($368997c7fea60e4e$var$W);
        return e.store($368997c7fea60e4e$var$Re).get($368997c7fea60e4e$var$Ee).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new $368997c7fea60e4e$export$db202ddc8be9136(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $368997c7fea60e4e$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(r));
        });
    }
    wi(e, t) {
        // Create the index.
        e.createObjectStore($368997c7fea60e4e$var$Ae, {
            keyPath: $368997c7fea60e4e$var$Ve
        });
        const n = t.store($368997c7fea60e4e$var$Ae), r = new $368997c7fea60e4e$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $368997c7fea60e4e$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($368997c7fea60e4e$var$W).ee({
            Y: !0
        }, (e, t)=>{
            const n = new $368997c7fea60e4e$export$db202ddc8be9136(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($368997c7fea60e4e$var$ee).ee({
                Y: !0
            }, ([e, t, n], r)=>{
                const i = $368997c7fea60e4e$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    bi(e) {
        const t = e.store($368997c7fea60e4e$var$ue);
        return t.ee((e, n)=>{
            const r = $368997c7fea60e4e$var$__PRIVATE_fromDbTarget(n), i = $368997c7fea60e4e$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    Si(e, t) {
        const n = t.store($368997c7fea60e4e$var$W), r = [];
        return n.ee((e, n)=>{
            const i = t.store($368997c7fea60e4e$var$te), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.fromString(e.document.name).popFirst(5)) : e.noDocument ? $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(e.noDocument.path) : e.unknownDocument ? $368997c7fea60e4e$export$90a7f3efeed30595.fromSegments(e.unknownDocument.path) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(36783);
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(r));
    }
    Di(e, t) {
        const n = t.store($368997c7fea60e4e$var$H), r = $368997c7fea60e4e$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $368997c7fea60e4e$var$__PRIVATE_MemoryPersistence($368997c7fea60e4e$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer.yt);
        return n.H().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $368997c7fea60e4e$export$971d5caa766a69d7();
                $368997c7fea60e4e$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $368997c7fea60e4e$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $368997c7fea60e4e$var$User(n), o = $368997c7fea60e4e$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, s), _ = i.getIndexManager(s), a = $368997c7fea60e4e$var$__PRIVATE_IndexedDbMutationQueue.wt(s, this.serializer, _, i.referenceDelegate);
                return new $368997c7fea60e4e$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransaction(t, $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function $368997c7fea60e4e$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($368997c7fea60e4e$var$he, {
        keyPath: $368997c7fea60e4e$var$Pe
    }).createIndex($368997c7fea60e4e$var$Te, $368997c7fea60e4e$var$Ie, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($368997c7fea60e4e$var$ue, {
        keyPath: "targetId"
    }).createIndex($368997c7fea60e4e$var$ce, $368997c7fea60e4e$var$le, {
        unique: !0
    }), e.createObjectStore($368997c7fea60e4e$var$Re);
}
const $368997c7fea60e4e$var$Ft = "IndexedDbPersistence", $368997c7fea60e4e$var$Mt = 18e5, $368997c7fea60e4e$var$xt = 5e3, $368997c7fea60e4e$var$Ot = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $368997c7fea60e4e$var$Nt = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $368997c7fea60e4e$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Ci = i, this.window = s, this.document = o, this.Fi = a, this.Mi = u, this.xi = c, this.ai = null, this.ui = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.Oi = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.Ni = null, /** The client metadata refresh task. */ this.Bi = null, /** The last time we garbage collected the client metadata object store. */ this.Li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.ki = (e)=>Promise.resolve(), !$368997c7fea60e4e$var$__PRIVATE_IndexedDbPersistence.v()) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ki = t + $368997c7fea60e4e$var$Nt, this.serializer = new $368997c7fea60e4e$var$__PRIVATE_LocalSerializer(_), this.qi = new $368997c7fea60e4e$var$__PRIVATE_SimpleDb(this.Ki, this.xi, new $368997c7fea60e4e$var$__PRIVATE_SchemaConverter(this.serializer)), this.ci = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbGlobalsCache, this.li = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $368997c7fea60e4e$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Pi = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ui = this.window.localStorage : (this.Ui = null, !1 === u && $368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ft, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.$i().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, $368997c7fea60e4e$var$Ot);
            return this.Wi(), this.Qi(), this.Gi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.li.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.ai = new $368997c7fea60e4e$var$__PRIVATE_ListenSequence(e, this.Fi);
        }).then(()=>{
            this.ui = !0;
        }).catch((e)=>(this.qi && this.qi.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ zi(e) {
        return this.ki = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.qi.q(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Ci.enqueueAndForget(async ()=>{
            this.started && await this.$i();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ $i() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$368997c7fea60e4e$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.ji(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)));
                });
            }).next(()=>this.Hi(e)).next((t)=>this.isPrimary && !t ? this.Ji(e).next(()=>!1) : !!t && this.Zi(e).next(()=>!0))).catch((e)=>{
            if ($368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Ci.enqueueRetryable(()=>this.ki(e)), this.isPrimary = e;
        });
    }
    ji(e) {
        return $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e).get($368997c7fea60e4e$var$G).next((e)=>$368997c7fea60e4e$var$PersistencePromise.resolve(this.Xi(e)));
    }
    Yi(e) {
        return $368997c7fea60e4e$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async es() {
        if (this.isPrimary && !this.ts(this.Li, $368997c7fea60e4e$var$Mt)) {
            this.Li = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$de);
                return t.H().next((e)=>{
                    const n = this.ns(e, $368997c7fea60e4e$var$Mt), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $368997c7fea60e4e$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ui) for (const t of e)this.Ui.removeItem(this.rs(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Gi() {
        this.Bi = this.Ci.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.$i().then(()=>this.es()).then(()=>this.Gi()));
    }
    /** Checks whether `client` is the local client. */ Xi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Hi(e) {
        if (this.Mi) return $368997c7fea60e4e$var$PersistencePromise.resolve(!0);
        return $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e).get($368997c7fea60e4e$var$G).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.ts(t.leaseTimestampMs, $368997c7fea60e4e$var$xt) && !this.ss(t.ownerId)) {
                if (this.Xi(t) && this.networkEnabled) return !0;
                if (!this.Xi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, $368997c7fea60e4e$var$Ot);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $368997c7fea60e4e$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>void 0 === this.ns(e, $368997c7fea60e4e$var$xt).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.ui = !1, this._s(), this.Bi && (this.Bi.cancel(), this.Bi = null), this.us(), this.cs(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.qi.runTransaction("shutdown", "readwrite", [
            $368997c7fea60e4e$var$Q,
            $368997c7fea60e4e$var$de
        ], (e)=>{
            const t = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransaction(e, $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce);
            return this.Ji(t).next(()=>this.Yi(t));
        }), this.qi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.ls();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ ns(e, t) {
        return e.filter((e)=>this.ts(e.updateTimeMs, t) && !this.ss(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ hs() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$368997c7fea60e4e$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>this.ns(e, $368997c7fea60e4e$var$Mt).map((e)=>e.clientId)));
    }
    get started() {
        return this.ui;
    }
    getGlobalsCache() {
        return this.ci;
    }
    getMutationQueue(e, t) {
        return $368997c7fea60e4e$var$__PRIVATE_IndexedDbMutationQueue.wt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.li;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.yt.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $368997c7fea60e4e$var$__PRIVATE_IndexedDbDocumentOverlayCache.wt(this.serializer, e);
    }
    getBundleCache() {
        return this.Pi;
    }
    runTransaction(e, t, n) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $368997c7fea60e4e$var$Ye : 17 === e ? $368997c7fea60e4e$var$Xe : 16 === e ? $368997c7fea60e4e$var$Ze : 15 === e ? $368997c7fea60e4e$var$Je : 14 === e ? $368997c7fea60e4e$var$He : 13 === e ? $368997c7fea60e4e$var$je : 12 === e ? $368997c7fea60e4e$var$ze : 11 === e ? $368997c7fea60e4e$var$Ge : void $368997c7fea60e4e$export$3a6d5c9ae78a2c08(60245);
        }(this.xi);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.qi.runTransaction(e, r, i, (r)=>(s = new $368997c7fea60e4e$var$__PRIVATE_IndexedDbTransaction(r, this.ai ? this.ai.next() : $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.ji(s).next((e)=>!!e || this.Hi(s)).next((t)=>{
                if (!t) throw $368997c7fea60e4e$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Ci.enqueueRetryable(()=>this.ki(!1)), new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, $368997c7fea60e4e$var$L);
                return n(s);
            }).next((e)=>this.Zi(s).next(()=>e)) : this.Ps(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Ps(e) {
        return $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e).get($368997c7fea60e4e$var$G).next((e)=>{
            if (null !== e && this.ts(e.leaseTimestampMs, $368997c7fea60e4e$var$xt) && !this.ss(e.ownerId) && !this.Xi(e) && !(this.Mi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, $368997c7fea60e4e$var$Ot);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ Zi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e).put($368997c7fea60e4e$var$G, t);
    }
    static v() {
        return $368997c7fea60e4e$var$__PRIVATE_SimpleDb.v();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Ji(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e);
        return t.get($368997c7fea60e4e$var$G).next((e)=>this.Xi(e) ? ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, "Releasing primary lease."), t.delete($368997c7fea60e4e$var$G)) : $368997c7fea60e4e$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ ts(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($368997c7fea60e4e$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    Wi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ni = ()=>{
            this.Ci.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.$i()));
        }, this.document.addEventListener("visibilitychange", this.Ni), this.inForeground = "visible" === this.document.visibilityState);
    }
    us() {
        this.Ni && (this.document.removeEventListener("visibilitychange", this.Ni), this.Ni = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Qi() {
        "function" == typeof this.window?.addEventListener && (this.Oi = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this._s();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $9k0Bn.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Ci.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Ci.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.Oi));
    }
    cs() {
        this.Oi && (this.window.removeEventListener("pagehide", this.Oi), this.Oi = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ ss(e) {
        try {
            const t = null !== this.Ui?.getItem(this.rs(e));
            return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ft, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ft, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ _s() {
        if (this.Ui) try {
            this.Ui.setItem(this.rs(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $368997c7fea60e4e$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ ls() {
        if (this.Ui) try {
            this.Ui.removeItem(this.rs(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    rs(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_primaryClientStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$Q);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $368997c7fea60e4e$var$__PRIVATE_clientMetadataStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_getStore(e, $368997c7fea60e4e$var$de);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $368997c7fea60e4e$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $368997c7fea60e4e$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Ts = n, this.Is = r;
    }
    static Es(e, t) {
        let n = $368997c7fea60e4e$export$971d5caa766a69d7(), r = $368997c7fea60e4e$export$971d5caa766a69d7();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $368997c7fea60e4e$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $368997c7fea60e4e$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $368997c7fea60e4e$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Rs = !1, this.As = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Vs = 100, this.ds = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $9k0Bn.isSafari)() ? 8 : $368997c7fea60e4e$var$__PRIVATE_getAndroidVersion((0, $9k0Bn.getUA)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.fs = e, this.indexManager = t, this.Rs = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.gs(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.ps(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $368997c7fea60e4e$var$QueryContext;
            return this.ys(e, t, n).next((r)=>{
                if (i.result = r, this.As) return this.ws(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    ws(e, t, n, r) {
        return n.documentReadCount < this.Vs ? ($368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG && $368997c7fea60e4e$export$21579262ef46735b("QueryEngine", "SDK will not create cache indexes for query:", $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Vs, "documents"), $368997c7fea60e4e$var$PersistencePromise.resolve()) : ($368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG && $368997c7fea60e4e$export$21579262ef46735b("QueryEngine", "Query:", $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.ds * r ? ($368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG && $368997c7fea60e4e$export$21579262ef46735b("QueryEngine", "The SDK decides to create cache indexes for query:", $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t))) : $368997c7fea60e4e$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ gs(e, t) {
        if ($368997c7fea60e4e$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $368997c7fea60e4e$var$PersistencePromise.resolve(null);
        let n = $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $368997c7fea60e4e$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ ), n = $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $368997c7fea60e4e$export$971d5caa766a69d7(...r);
                return this.fs.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.bs(t, r);
                        return this.Ss(t, s, i, n.readTime) ? this.gs(e, $368997c7fea60e4e$export$882b5998b3b9117c(t, null, "F" /* LimitType.First */ )) : this.Ds(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ ps(e, t, n, r) {
        return $368997c7fea60e4e$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()) ? $368997c7fea60e4e$var$PersistencePromise.resolve(null) : this.fs.getDocuments(e, n).next((i)=>{
            const s = this.bs(t, i);
            return this.Ss(t, s, n, r) ? $368997c7fea60e4e$var$PersistencePromise.resolve(null) : ($368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG && $368997c7fea60e4e$export$21579262ef46735b("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t)), this.Ds(e, s, t, $368997c7fea60e4e$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $368997c7fea60e4e$var$B)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ bs(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $368997c7fea60e4e$var$SortedSet($368997c7fea60e4e$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $368997c7fea60e4e$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Ss(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    ys(e, t, n) {
        return $368997c7fea60e4e$var$__PRIVATE_getLogLevel() <= (0, $6mnY8.LogLevel).DEBUG && $368997c7fea60e4e$export$21579262ef46735b("QueryEngine", "Using full collection scan to execute query:", $368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t)), this.fs.getDocumentsMatchingQuery(e, t, $368997c7fea60e4e$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Ds(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.fs.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Bt = "LocalStore", $368997c7fea60e4e$var$Lt = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $368997c7fea60e4e$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Cs = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.vs = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Fs = new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyTarget(e), $368997c7fea60e4e$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Ms = new Map, this.xs = e.getRemoteDocumentCache(), this.li = e.getTargetCache(), this.Pi = e.getBundleCache(), this.Os(n);
    }
    Os(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $368997c7fea60e4e$var$LocalDocumentsView(this.xs, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.xs.setIndexManager(this.indexManager), this.Cs.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.vs));
    }
}
function $368997c7fea60e4e$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $368997c7fea60e4e$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $368997c7fea60e4e$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Os(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $368997c7fea60e4e$export$971d5caa766a69d7();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    Ns: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $368997c7fea60e4e$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $368997c7fea60e4e$export$c18d01048907ea92(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $368997c7fea60e4e$export$971d5caa766a69d7();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.li.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.vs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.xs.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.vs;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.li.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.li.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, $368997c7fea60e4e$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($368997c7fea60e4e$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $368997c7fea60e4e$var$Lt) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && o.push(n.li.updateTargetData(e, u));
        });
        let _ = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), a = $368997c7fea60e4e$export$971d5caa766a69d7();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($368997c7fea60e4e$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.Bs, a = e.Ls;
        })), !r.isEqual($368997c7fea60e4e$var$SnapshotVersion.min())) {
            const t = n.li.getLastRemoteSnapshotVersion(e).next((t)=>n.li.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $368997c7fea60e4e$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.vs = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $368997c7fea60e4e$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $368997c7fea60e4e$export$971d5caa766a69d7(), i = $368997c7fea60e4e$export$971d5caa766a69d7();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Bt, "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            Bs: r,
            Ls: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $368997c7fea60e4e$var$U), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.li.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $368997c7fea60e4e$var$PersistencePromise.resolve(r)) : n.li.allocateTargetId(e).next((i)=>(r = new $368997c7fea60e4e$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.li.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.vs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.vs = n.vs.insert(e.targetId, e), n.Fs.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = r.vs.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Bt, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.vs = r.vs.remove(t), r.Fs.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $368997c7fea60e4e$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    let i = $368997c7fea60e4e$var$SnapshotVersion.min(), s = $368997c7fea60e4e$export$971d5caa766a69d7();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = r.Fs.get(n);
            return void 0 !== i ? $368997c7fea60e4e$var$PersistencePromise.resolve(r.vs.get(i)) : r.li.getTargetData(t, n);
        })(r, e, $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.li.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Cs.getDocumentsMatchingQuery(e, t, n ? i : $368997c7fea60e4e$var$SnapshotVersion.min(), n ? s : $368997c7fea60e4e$export$971d5caa766a69d7())).next((e)=>($368997c7fea60e4e$var$__PRIVATE_setMaxReadTime(r, $368997c7fea60e4e$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                ks: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $368997c7fea60e4e$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = $368997c7fea60e4e$var$__PRIVATE_debugCast(n.li), i = n.vs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.At(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $368997c7fea60e4e$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = n.Ms.get(t) || $368997c7fea60e4e$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.xs.getAllFromCollectionGroup(e, t, $368997c7fea60e4e$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $368997c7fea60e4e$var$B), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($368997c7fea60e4e$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $368997c7fea60e4e$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Ms.get(t) || $368997c7fea60e4e$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Ms.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $368997c7fea60e4e$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    let s = $368997c7fea60e4e$export$971d5caa766a69d7(), o = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Ks(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.qs(e);
        r.setReadTime(t.Us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.xs.newChangeBuffer({
        trackRemovals: !0
    }), a = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $368997c7fea60e4e$var$__PRIVATE_queryToTarget($368997c7fea60e4e$export$a93c5207d687da10($368997c7fea60e4e$export$db202ddc8be9136.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$368997c7fea60e4e$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.li.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.li.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.Bs, t.Ls)).next(()=>t.Bs)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $368997c7fea60e4e$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $368997c7fea60e4e$export$971d5caa766a69d7()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(e, $368997c7fea60e4e$var$__PRIVATE_queryToTarget($368997c7fea60e4e$export$56c0d5a1e737357d(t.bundledQuery))), i = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Pi.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, s);
        return i.vs = i.vs.insert(o.targetId, o), i.li.updateTargetData(e, o).next(()=>i.li.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.li.addMatchingKeys(e, n, r.targetId)).next(()=>i.Pi.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $368997c7fea60e4e$var$kt = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $368997c7fea60e4e$var$createWebStorageClientStateKey(e, t) {
    return `${$368997c7fea60e4e$var$kt}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $368997c7fea60e4e$var$Kt = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $368997c7fea60e4e$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$368997c7fea60e4e$var$Kt}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $368997c7fea60e4e$var$qt = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $368997c7fea60e4e$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$368997c7fea60e4e$var$qt}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Ut = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $368997c7fea60e4e$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $368997c7fea60e4e$export$4368d992c4eafac0(r.error.code, r.error.message))), s ? new $368997c7fea60e4e$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ut, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $368997c7fea60e4e$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $368997c7fea60e4e$export$4368d992c4eafac0(n.error.code, n.error.message))), i ? new $368997c7fea60e4e$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ut, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    Ws() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $368997c7fea60e4e$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $368997c7fea60e4e$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $368997c7fea60e4e$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $368997c7fea60e4e$var$__PRIVATE_RemoteClientState(e, i) : ($368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ut, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $368997c7fea60e4e$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static $s(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $368997c7fea60e4e$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ut, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $368997c7fea60e4e$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $368997c7fea60e4e$var$__PRIVATE_targetIdSet();
    }
    Qs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Gs(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ Ws() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $368997c7fea60e4e$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Ci = t, this.persistenceKey = n, this.zs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.js = this.Hs.bind(this), this.Js = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.Zs = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Xs = $368997c7fea60e4e$var$createWebStorageClientStateKey(this.persistenceKey, this.zs), this.Ys = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.Js = this.Js.insert(this.zs, new $368997c7fea60e4e$var$__PRIVATE_LocalClientState), this.eo = new RegExp(`^${$368997c7fea60e4e$var$kt}_${s}_([^_]*)$`), this.no = new RegExp(`^${$368997c7fea60e4e$var$Kt}_${s}_(\\d+)(?:_(.*))?$`), this.ro = new RegExp(`^${$368997c7fea60e4e$var$qt}_${s}_(\\d+)$`), this.io = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.so = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.js);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static v(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.hs();
        for (const t of e){
            if (t === this.zs) continue;
            const e = this.getItem($368997c7fea60e4e$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $368997c7fea60e4e$var$__PRIVATE_RemoteClientState.$s(t, e);
                n && (this.Js = this.Js.insert(n.clientId, n));
            }
        }
        this.oo();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.io);
        if (t) {
            const e = this._o(t);
            e && this.ao(e);
        }
        for (const e of this.Zs)this.Hs(e);
        this.Zs = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Ys, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.uo(this.Js);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.Js.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.co(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.co(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.lo(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($368997c7fea60e4e$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $368997c7fea60e4e$var$__PRIVATE_QueryTargetMetadata.$s(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ho.Qs(e), this.oo(), n;
    }
    removeLocalQueryTarget(e) {
        this.ho.Gs(e), this.oo();
    }
    isLocalQueryTarget(e) {
        return this.ho.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($368997c7fea60e4e$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.Po(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.lo(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.To(e);
    }
    notifyBundleLoaded(e) {
        this.Io(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.js), this.removeItem(this.Xs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ut, "READ", e, t), t;
    }
    setItem(e, t) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ut, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ut, "REMOVE", e), this.storage.removeItem(e);
    }
    Hs(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ut, "EVENT", t.key, t.newValue), t.key === this.Xs) return void $368997c7fea60e4e$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Ci.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.eo.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Eo(t.key);
                                return this.Ro(e, null);
                            }
                            {
                                const e = this.Ao(t.key, t.newValue);
                                if (e) return this.Ro(e.clientId, e);
                            }
                        } else if (this.no.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Vo(t.key, t.newValue);
                                if (e) return this.mo(e);
                            }
                        } else if (this.ro.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.fo(t.key, t.newValue);
                                if (e) return this.po(e);
                            }
                        } else if (t.key === this.io) {
                            if (null !== t.newValue) {
                                const e = this._o(t.newValue);
                                if (e) return this.ao(e);
                            }
                        } else if (t.key === this.Ys) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $368997c7fea60e4e$export$c18d01048907ea92("number" == typeof n, 30636, {
                                        yo: e
                                    }), t = n;
                                } catch (e) {
                                    $368997c7fea60e4e$var$__PRIVATE_logError($368997c7fea60e4e$var$Ut, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this.so) {
                            const e = this.wo(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.bo(e)));
                        }
                    }
                } else this.Zs.push(t);
            });
        }
    }
    get ho() {
        return this.Js.get(this.zs);
    }
    oo() {
        this.setItem(this.Xs, this.ho.Ws());
    }
    co(e, t, n) {
        const r = new $368997c7fea60e4e$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $368997c7fea60e4e$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.Ws());
    }
    lo(e) {
        const t = $368997c7fea60e4e$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    To(e) {
        const t = {
            clientId: this.zs,
            onlineState: e
        };
        this.storage.setItem(this.io, JSON.stringify(t));
    }
    Po(e, t, n) {
        const r = $368997c7fea60e4e$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $368997c7fea60e4e$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.Ws());
    }
    Io(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.so, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Eo(e) {
        const t = this.eo.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Ao(e, t) {
        const n = this.Eo(e);
        return $368997c7fea60e4e$var$__PRIVATE_RemoteClientState.$s(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Vo(e, t) {
        const n = this.no.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $368997c7fea60e4e$var$__PRIVATE_MutationMetadata.$s(new $368997c7fea60e4e$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ fo(e, t) {
        const n = this.ro.exec(e), r = Number(n[1]);
        return $368997c7fea60e4e$var$__PRIVATE_QueryTargetMetadata.$s(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ _o(e) {
        return $368997c7fea60e4e$var$__PRIVATE_SharedOnlineState.$s(e);
    }
    wo(e) {
        return JSON.parse(e);
    }
    async mo(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.So(e.batchId, e.state, e.error);
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ut, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    po(e) {
        return this.syncEngine.Do(e.targetId, e.state, e.error);
    }
    Ro(e, t) {
        const n = t ? this.Js.insert(e, t) : this.Js.remove(e), r = this.uo(this.Js), i = this.uo(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.Co(s, o).then(()=>{
            this.Js = n;
        });
    }
    ao(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.Js.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    uo(e) {
        let t = $368997c7fea60e4e$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.vo = new $368997c7fea60e4e$var$__PRIVATE_LocalClientState, this.Fo = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.vo.Qs(e), this.Fo[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Fo[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.vo.Gs(e);
    }
    isLocalQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Fo[e];
    }
    getAllActiveQueryTargets() {
        return this.vo.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.vo.activeTargetIds.has(e);
    }
    start() {
        return this.vo = new $368997c7fea60e4e$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_NoopConnectivityMonitor {
    Mo(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $368997c7fea60e4e$var$$t = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $368997c7fea60e4e$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.xo = ()=>this.Oo(), this.No = ()=>this.Bo(), this.Lo = [], this.ko();
    }
    Mo(e) {
        this.Lo.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.xo), window.removeEventListener("offline", this.No);
    }
    ko() {
        window.addEventListener("online", this.xo), window.addEventListener("offline", this.No);
    }
    Oo() {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$$t, "Network connectivity changed: AVAILABLE");
        for (const e of this.Lo)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    Bo() {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$$t, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Lo)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static v() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $368997c7fea60e4e$var$Wt = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $368997c7fea60e4e$var$__PRIVATE_generateUniqueDebugId() {
    return null === $368997c7fea60e4e$var$Wt ? $368997c7fea60e4e$var$Wt = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $368997c7fea60e4e$var$Wt++, "0x" + $368997c7fea60e4e$var$Wt.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Qt = "RestConnection", $368997c7fea60e4e$var$Gt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $368997c7fea60e4e$var$__PRIVATE_RestConnection {
    get Ko() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.qo = t + "://" + e.host, this.Uo = `projects/${n}/databases/${r}`, this.$o = this.databaseId.database === $368997c7fea60e4e$var$st ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Wo(e, t, n, r, i) {
        const s = $368997c7fea60e4e$var$__PRIVATE_generateUniqueDebugId(), o = this.Qo(e, t.toUriEncodedString());
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Qt, `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Uo,
            "x-goog-request-params": this.$o
        };
        this.Go(_, r, i);
        const { host: a } = new URL(o), c = (0, $9k0Bn.isCloudWorkstation)(a);
        return this.zo(e, o, _, n, c).then((t)=>($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Qt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $368997c7fea60e4e$export$4c3d22f3d993c33f($368997c7fea60e4e$var$Qt, `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    jo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Wo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Go(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $368997c7fea60e4e$var$S;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Qo(e, t) {
        const n = $368997c7fea60e4e$var$Gt[e];
        let r = `${this.qo}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $368997c7fea60e4e$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Ho = e.Ho, this.Jo = e.Jo;
    }
    Zo(e) {
        this.Xo = e;
    }
    Yo(e) {
        this.e_ = e;
    }
    t_(e) {
        this.n_ = e;
    }
    onMessage(e) {
        this.r_ = e;
    }
    close() {
        this.Jo();
    }
    send(e) {
        this.Ho(e);
    }
    i_() {
        this.Xo();
    }
    s_() {
        this.e_();
    }
    o_(e) {
        this.n_(e);
    }
    __(e) {
        this.r_(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$zt = "WebChannelConnection", $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class $368997c7fea60e4e$var$__PRIVATE_WebChannelConnection extends $368997c7fea60e4e$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.a_ = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static u_() {
        if (!$368997c7fea60e4e$var$__PRIVATE_WebChannelConnection.c_) {
            const e = (0, $9Necc.getStatEventTarget)();
            $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen(e, (0, $9Necc.Event).STAT_EVENT, (e)=>{
                e.stat === (0, $9Necc.Stat).PROXY ? $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $9Necc.Stat).NOPROXY && $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, "STAT_EVENT: detected no buffering proxy");
            }), $368997c7fea60e4e$var$__PRIVATE_WebChannelConnection.c_ = !0;
        }
    }
    zo(e, t, n, r, i) {
        const s = $368997c7fea60e4e$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, o)=>{
            const _ = new (0, $9Necc.XhrIo);
            _.setWithCredentials(!0), _.listenOnce((0, $9Necc.EventType).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $9Necc.ErrorCode).NO_ERROR:
                            const t = _.getResponseJson();
                            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $9Necc.ErrorCode).TIMEOUT:
                            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' ${s} timed out`), o(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $9Necc.ErrorCode).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' ${s} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($368997c7fea60e4e$export$e7094788287c5e9b).indexOf(t) >= 0 ? t : $368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN;
                                    }(t.status);
                                    o(new $368997c7fea60e4e$export$4368d992c4eafac0(e, t.message));
                                } else o(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $368997c7fea60e4e$export$3a6d5c9ae78a2c08(9055, {
                                l_: e,
                                streamId: s,
                                h_: _.getLastErrorCode(),
                                P_: _.getLastError()
                            });
                    }
                } finally{
                    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' ${s} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    T_(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.qo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = this.createWebChannelTransport(), o = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, _ = this.longPollingOptions.timeoutSeconds;
        void 0 !== _ && (o.longPollingTimeout = Math.round(1e3 * _)), this.useFetchStreams && (o.useFetchStreams = !0), this.Go(o.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        o.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `Creating RPC '${e}' stream ${r}: ${a}`, o);
        const u = s.createWebChannel(a, o);
        this.I_(u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let c = !1, l = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const h = new $368997c7fea60e4e$var$__PRIVATE_StreamBridge({
            Ho: (t)=>{
                l ? $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (c || ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `Opening RPC '${e}' stream ${r} transport.`), u.open(), c = !0), $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
            },
            Jo: ()=>u.close()
        });
        return $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen(u, (0, $9Necc.WebChannel).EventType.OPEN, ()=>{
            l || ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} transport opened.`), h.i_());
        }), $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen(u, (0, $9Necc.WebChannel).EventType.CLOSE, ()=>{
            l || (l = !0, $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} transport closed`), h.o_(), this.E_(u));
        }), $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen(u, (0, $9Necc.WebChannel).EventType.ERROR, (t)=>{
            l || (l = !0, $368997c7fea60e4e$export$4c3d22f3d993c33f($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), h.o_(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, "The operation could not be completed")));
        }), $368997c7fea60e4e$var$__PRIVATE_unguardedEventListen(u, (0, $9Necc.WebChannel).EventType.MESSAGE, (t)=>{
            if (!l) {
                const n = t.data[0];
                $368997c7fea60e4e$export$c18d01048907ea92(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $368997c7fea60e4e$var$At[e];
                        if (void 0 !== t) return $368997c7fea60e4e$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && $368997c7fea60e4e$export$4c3d22f3d993c33f(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = $368997c7fea60e4e$export$e7094788287c5e9b.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    l = !0, h.o_(new $368997c7fea60e4e$export$4368d992c4eafac0(n, i)), u.close();
                } else $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$zt, `RPC '${e}' stream ${r} received:`, n), h.__(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        $368997c7fea60e4e$var$__PRIVATE_WebChannelConnection.u_(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            h.s_();
        }, 0), h;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.a_.forEach((e)=>e.close()), this.a_ = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ I_(e) {
        this.a_.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ E_(e) {
        this.a_ = this.a_.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ Go(e, t, n) {
        super.Go(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, $9Necc.createWebChannelTransport)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function $368997c7fea60e4e$var$__PRIVATE_newConnection(e) {
    return new $368997c7fea60e4e$var$__PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $368997c7fea60e4e$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $368997c7fea60e4e$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $368997c7fea60e4e$export$b4171a6734a65d42(e) {
    return new $368997c7fea60e4e$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $368997c7fea60e4e$var$__PRIVATE_WebChannelConnection.c_ = !1;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $368997c7fea60e4e$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Ci = e, this.timerId = t, this.R_ = n, this.A_ = r, this.V_ = i, this.d_ = 0, this.m_ = null, /** The last backoff attempt, as epoch milliseconds. */ this.f_ = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.d_ = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ g_() {
        this.d_ = this.V_;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ p_(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.d_ + this.y_()), n = Math.max(0, Date.now() - this.f_), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $368997c7fea60e4e$export$21579262ef46735b("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.d_} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.m_ = this.Ci.enqueueAfterDelay(this.timerId, r, ()=>(this.f_ = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.d_ *= this.A_, this.d_ < this.R_ && (this.d_ = this.R_), this.d_ > this.V_ && (this.d_ = this.V_);
    }
    w_() {
        null !== this.m_ && (this.m_.skipDelay(), this.m_ = null);
    }
    cancel() {
        null !== this.m_ && (this.m_.cancel(), this.m_ = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ y_() {
        return (Math.random() - .5) * this.d_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$jt = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $368997c7fea60e4e$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.Ci = e, this.b_ = n, this.S_ = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.D_ = 0, this.C_ = null, this.v_ = null, this.stream = null, /**
         * Count of response messages received.
         */ this.F_ = 0, this.M_ = new $368997c7fea60e4e$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ x_() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.O_();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ O_() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.F_ = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.N_();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.x_() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ B_() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.M_.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ L_() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.O_() && null === this.C_ && (this.C_ = this.Ci.enqueueAfterDelay(this.b_, 6e4, ()=>this.k_()));
    }
    /** Sends a message to the underlying stream. */ K_(e) {
        this.q_(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async k_() {
        if (this.O_()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ q_() {
        this.C_ && (this.C_.cancel(), this.C_ = null);
    }
    /** Cancels the health check delayed operation. */ U_() {
        this.v_ && (this.v_.cancel(), this.v_ = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.q_(), this.U_(), this.M_.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.D_++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.M_.reset() : t && t.code === $368997c7fea60e4e$export$e7094788287c5e9b.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($368997c7fea60e4e$var$__PRIVATE_logError(t.toString()), $368997c7fea60e4e$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.M_.g_()) : t && t.code === $368997c7fea60e4e$export$e7094788287c5e9b.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.W_(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.t_(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ W_() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.Q_(this.D_), t = this.D_;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.D_ === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.G_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.z_(e);
            });
        });
    }
    G_(e, t) {
        const n = this.Q_(this.D_);
        this.stream = this.j_(e, t), this.stream.Zo(()=>{
            n(()=>this.listener.Zo());
        }), this.stream.Yo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.v_ = this.Ci.enqueueAfterDelay(this.S_, 1e4, ()=>(this.O_() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.Yo()));
        }), this.stream.t_((e)=>{
            n(()=>this.z_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.F_ ? this.H_(e) : this.onNext(e));
        });
    }
    N_() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.M_.p_(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    z_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$jt, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Q_(e) {
        return (t)=>{
            this.Ci.enqueueAndForget(()=>this.D_ === e ? t() : ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$jt, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $368997c7fea60e4e$var$__PRIVATE_PersistentListenStream extends $368997c7fea60e4e$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    j_(e, t) {
        return this.connection.T_("Listen", e, t);
    }
    H_(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.M_.reset();
        const t = $368997c7fea60e4e$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $368997c7fea60e4e$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $368997c7fea60e4e$var$SnapshotVersion.min() : t.readTime ? $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.readTime) : $368997c7fea60e4e$var$SnapshotVersion.min();
        }(e);
        return this.listener.J_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ Z_(e) {
        const t = {};
        t.database = $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $368997c7fea60e4e$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $368997c7fea60e4e$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $368997c7fea60e4e$var$__PRIVATE_toQueryTarget(e, r).ft
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $368997c7fea60e4e$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $368997c7fea60e4e$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($368997c7fea60e4e$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $368997c7fea60e4e$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $368997c7fea60e4e$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $368997c7fea60e4e$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.K_(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ X_(e) {
        const t = {};
        t.database = $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.K_(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $368997c7fea60e4e$var$__PRIVATE_PersistentWriteStream extends $368997c7fea60e4e$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Y_() {
        return this.F_ > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    W_() {
        this.Y_ && this.ea([]);
    }
    j_(e, t) {
        return this.connection.T_("Write", e, t);
    }
    H_(e) {
        // Always capture the last stream token.
        return $368997c7fea60e4e$export$c18d01048907ea92(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $368997c7fea60e4e$export$c18d01048907ea92(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.ta();
    }
    onNext(e) {
        // Always capture the last stream token.
        $368997c7fea60e4e$export$c18d01048907ea92(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.M_.reset();
        const t = $368997c7fea60e4e$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $368997c7fea60e4e$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.na(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ ra() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.K_(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ ea(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$368997c7fea60e4e$var$toMutation(this.serializer, e))
        };
        this.K_(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $368997c7fea60e4e$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $368997c7fea60e4e$var$__PRIVATE_DatastoreImpl extends $368997c7fea60e4e$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.ia = !1;
    }
    sa() {
        if (this.ia) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Wo(e, t, n, r) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Wo(e, $368997c7fea60e4e$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $368997c7fea60e4e$export$e7094788287c5e9b.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ jo(e, t, n, r, i) {
        return this.sa(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, o])=>this.connection.jo(e, $368997c7fea60e4e$var$__PRIVATE_toResourcePath(t, n), r, s, o, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $368997c7fea60e4e$export$e7094788287c5e9b.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.ia = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function $368997c7fea60e4e$var$__PRIVATE_newDatastore(e, t, n, r) {
    return new $368997c7fea60e4e$var$__PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $368997c7fea60e4e$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.oa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.aa = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ ua() {
        0 === this.oa && (this.ca("Unknown" /* OnlineState.Unknown */ ), this._a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._a = null, this.la("Backend didn't respond within 10 seconds."), this.ca("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ ha(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.ca("Unknown" /* OnlineState.Unknown */ ) : (this.oa++, this.oa >= 1 && (this.Pa(), this.la(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.ca("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.Pa(), this.oa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.aa = !1), this.ca(e);
    }
    ca(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    la(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.aa ? ($368997c7fea60e4e$var$__PRIVATE_logError(t), this.aa = !1) : $368997c7fea60e4e$export$21579262ef46735b("OnlineStateTracker", t);
    }
    Pa() {
        null !== this._a && (this._a.cancel(), this._a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Ht = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $368997c7fea60e4e$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ta = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ia = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.Ea = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.Ra = [], this.Aa = i, this.Aa.Mo((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(this) && ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
                    t.Ea.add(4 /* OfflineCause.ConnectivityChange */ ), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(t), t.Va.set("Unknown" /* OnlineState.Unknown */ ), t.Ea.delete(4 /* OfflineCause.ConnectivityChange */ ), await $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.Va = new $368997c7fea60e4e$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(e) {
    if ($368997c7fea60e4e$var$__PRIVATE_canUseNetwork(e)) for (const t of e.Ra)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.Ra)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $368997c7fea60e4e$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    n.Ia.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.Ia.set(t.targetId, t), $368997c7fea60e4e$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $368997c7fea60e4e$var$__PRIVATE_startWatchStream(n) : $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(n).O_() && $368997c7fea60e4e$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(n);
    n.Ia.delete(t), r.O_() && $368997c7fea60e4e$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.Ia.size && (r.O_() ? r.L_() : $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.Va.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $368997c7fea60e4e$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.da.$e(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($368997c7fea60e4e$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(e).Z_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $368997c7fea60e4e$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.da.$e(t), $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(e).X_(t);
}
function $368997c7fea60e4e$var$__PRIVATE_startWatchStream(e) {
    e.da = new $368997c7fea60e4e$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        At: (t)=>e.Ia.get(t) || null,
        ht: ()=>e.datastore.serializer.databaseId
    }), $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(e).start(), e.Va.ua();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $368997c7fea60e4e$var$__PRIVATE_shouldStartWatchStream(e) {
    return $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(e) && !$368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(e).x_() && e.Ia.size > 0;
}
function $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $368997c7fea60e4e$var$__PRIVATE_debugCast(e).Ea.size;
}
function $368997c7fea60e4e$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.da = void 0;
}
async function $368997c7fea60e4e$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.Va.set("Online" /* OnlineState.Online */ );
}
async function $368997c7fea60e4e$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ia.forEach((t, n)=>{
        $368997c7fea60e4e$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $368997c7fea60e4e$var$__PRIVATE_onWatchStreamClose(e, t) {
    $368997c7fea60e4e$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $368997c7fea60e4e$var$__PRIVATE_shouldStartWatchStream(e) ? (e.Va.ha(t), $368997c7fea60e4e$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.Va.set("Unknown" /* OnlineState.Unknown */ );
}
async function $368997c7fea60e4e$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.Va.set("Online" /* OnlineState.Online */ ), t instanceof $368997c7fea60e4e$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.Ia.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.Ia.delete(r), e.da.removeTarget(r));
        }(e, t);
    } catch (n) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $368997c7fea60e4e$var$__PRIVATE_DocumentWatchChange ? e.da.Xe(t) : t instanceof $368997c7fea60e4e$var$__PRIVATE_ExistenceFilterChange ? e.da.st(t) : e.da.tt(t), !n.isEqual($368997c7fea60e4e$var$SnapshotVersion.min())) try {
        const t = await $368997c7fea60e4e$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.da.Tt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ia.get(r);
                    // A watched target might have been removed already.
                    i && e.Ia.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ia.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ia.set(t, r.withResumeToken($368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $368997c7fea60e4e$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $368997c7fea60e4e$var$TargetData(r.target, t, n, r.sequenceNumber);
                $368997c7fea60e4e$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "Failed to raise snapshot:", t), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $368997c7fea60e4e$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.Ea.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(e), e.Va.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$368997c7fea60e4e$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "Retrying IndexedDB access"), await n(), e.Ea.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $368997c7fea60e4e$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$368997c7fea60e4e$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), n = $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Ta.length > 0 ? t.Ta[t.Ta.length - 1].batchId : $368997c7fea60e4e$var$U;
    for(; $368997c7fea60e4e$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $368997c7fea60e4e$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ta.length && n.L_();
            break;
        }
        r = e.batchId, $368997c7fea60e4e$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $368997c7fea60e4e$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $368997c7fea60e4e$var$__PRIVATE_shouldStartWriteStream(t) && $368997c7fea60e4e$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $368997c7fea60e4e$var$__PRIVATE_canAddToWritePipeline(e) {
    return $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(e) && e.Ta.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $368997c7fea60e4e$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Ta.push(t);
    const n = $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e);
    n.O_() && n.Y_ && n.ea(t.mutations);
}
function $368997c7fea60e4e$var$__PRIVATE_shouldStartWriteStream(e) {
    return $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(e) && !$368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e).x_() && e.Ta.length > 0;
}
function $368997c7fea60e4e$var$__PRIVATE_startWriteStream(e) {
    $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $368997c7fea60e4e$var$__PRIVATE_onWriteStreamOpen(e) {
    $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e).ra();
}
async function $368997c7fea60e4e$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ta)t.ea(n.mutations);
}
async function $368997c7fea60e4e$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ta.shift(), i = $368997c7fea60e4e$var$MutationBatchResult.from(r, t, n);
    await $368997c7fea60e4e$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(e);
}
async function $368997c7fea60e4e$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e).Y_ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $368997c7fea60e4e$var$__PRIVATE_isPermanentError(e) && e !== $368997c7fea60e4e$export$e7094788287c5e9b.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ta.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e).B_(), await $368997c7fea60e4e$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $368997c7fea60e4e$var$__PRIVATE_shouldStartWriteStream(e) && $368997c7fea60e4e$var$__PRIVATE_startWriteStream(e);
}
async function $368997c7fea60e4e$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "RemoteStore received new credentials");
    const r = $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.Ea.add(3 /* OfflineCause.CredentialChange */ ), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.Va.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.Ea.delete(3 /* OfflineCause.CredentialChange */ ), await $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $368997c7fea60e4e$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    t ? (n.Ea.delete(2 /* OfflineCause.IsSecondary */ ), await $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.Ea.add(2 /* OfflineCause.IsSecondary */ ), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(n), n.Va.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $368997c7fea60e4e$var$__PRIVATE_ensureWatchStream(e) {
    return e.ma || // Create stream (but note that it is not started yet).
    (e.ma = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
        return r.sa(), new $368997c7fea60e4e$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: $368997c7fea60e4e$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        Yo: $368997c7fea60e4e$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        t_: $368997c7fea60e4e$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        J_: $368997c7fea60e4e$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.Ra.push(async (t)=>{
        t ? (e.ma.B_(), $368997c7fea60e4e$var$__PRIVATE_shouldStartWatchStream(e) ? $368997c7fea60e4e$var$__PRIVATE_startWatchStream(e) : e.Va.set("Unknown" /* OnlineState.Unknown */ )) : (await e.ma.stop(), $368997c7fea60e4e$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.ma;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $368997c7fea60e4e$var$__PRIVATE_ensureWriteStream(e) {
    return e.fa || // Create stream (but note that it is not started yet).
    (e.fa = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
        return r.sa(), new $368997c7fea60e4e$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Zo: ()=>Promise.resolve(),
        Yo: $368997c7fea60e4e$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        t_: $368997c7fea60e4e$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        ta: $368997c7fea60e4e$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        na: $368997c7fea60e4e$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.Ra.push(async (t)=>{
        t ? (e.fa.B_(), // This will start the write stream if necessary.
        await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(e)) : (await e.fa.stop(), e.Ta.length > 0 && ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, `Stopping write stream with ${e.Ta.length} pending writes`), e.Ta = []));
    })), e.fa;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $368997c7fea60e4e$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $368997c7fea60e4e$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $368997c7fea60e4e$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($368997c7fea60e4e$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $368997c7fea60e4e$export$25ce5a424b770e84 {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $368997c7fea60e4e$export$25ce5a424b770e84(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $368997c7fea60e4e$export$90a7f3efeed30595.comparator(t.key, n.key) : (e, t)=>$368997c7fea60e4e$export$90a7f3efeed30595.comparator(e.key, t.key), this.keyedMap = $368997c7fea60e4e$var$documentMap(), this.sortedSet = new $368997c7fea60e4e$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $368997c7fea60e4e$export$25ce5a424b770e84)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $368997c7fea60e4e$export$25ce5a424b770e84;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $368997c7fea60e4e$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.ga = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.ga.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.ga = this.ga.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.ga = this.ga.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.ga = this.ga.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.ga = this.ga.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.ga = this.ga.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $368997c7fea60e4e$export$3a6d5c9ae78a2c08(63341, {
            Vt: e,
            pa: n
        }) : this.ga = this.ga.insert(t, e);
    }
    ya() {
        const e = [];
        return this.ga.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $368997c7fea60e4e$export$e7c866399fa523f5 {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $368997c7fea60e4e$export$e7c866399fa523f5(e, t, $368997c7fea60e4e$export$25ce5a424b770e84.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $368997c7fea60e4e$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $368997c7fea60e4e$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.wa = void 0, this.ba = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    Sa() {
        return this.ba.some((e)=>e.Da());
    }
}
class $368997c7fea60e4e$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $368997c7fea60e4e$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Ca = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $368997c7fea60e4e$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.ba)e.onError(t);
            });
        }(this, new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.ABORTED, "Firestore shutting down"));
    }
}
function $368997c7fea60e4e$var$__PRIVATE_newQueriesObjectMap() {
    return new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyQuery(e), $368997c7fea60e4e$var$__PRIVATE_queryEquals);
}
async function $368997c7fea60e4e$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.Sa() && t.Da() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $368997c7fea60e4e$var$__PRIVATE_QueryListenersInfo, r = t.Da() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.wa = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$368997c7fea60e4e$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.ba.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.va(n.onlineState), s.wa) t.Fa(s.wa) && $368997c7fea60e4e$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $368997c7fea60e4e$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.ba.indexOf(t);
        e >= 0 && (s.ba.splice(e, 1), 0 === s.ba.length ? i = t.Da() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.Sa() && t.Da() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.ba)t.Fa(e) && (r = !0);
            i.wa = e;
        }
    }
    r && $368997c7fea60e4e$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $368997c7fea60e4e$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.ba)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $368997c7fea60e4e$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Ca.forEach((e)=>{
        e.next();
    });
}
var $368997c7fea60e4e$var$Jt, $368997c7fea60e4e$var$Zt;
/** Listen to both cache and server changes */ ($368997c7fea60e4e$var$Zt = $368997c7fea60e4e$var$Jt || ($368997c7fea60e4e$var$Jt = {})).Ma = "default", /** Listen to changes in cache only */ $368997c7fea60e4e$var$Zt.Cache = "cache";
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $368997c7fea60e4e$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.xa = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Oa = !1, this.Na = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Fa(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $368997c7fea60e4e$export$e7c866399fa523f5(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Oa ? this.Ba(e) && (this.xa.next(e), t = !0) : this.La(e, this.onlineState) && (this.ka(e), t = !0), this.Na = e, t;
    }
    onError(e) {
        this.xa.error(e);
    }
    /** Returns whether a snapshot was raised. */ va(e) {
        this.onlineState = e;
        let t = !1;
        return this.Na && !this.Oa && this.La(this.Na, e) && (this.ka(this.Na), t = !0), t;
    }
    La(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Da()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Ka || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Ba(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.Na && this.Na.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    ka(e) {
        e = $368997c7fea60e4e$export$e7c866399fa523f5.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Oa = !0, this.xa.next(e);
    }
    Da() {
        return this.options.source !== $368997c7fea60e4e$var$Jt.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $368997c7fea60e4e$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.qa = e, this.byteLength = t;
    }
    Ua() {
        return "metadata" in this.qa;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $368997c7fea60e4e$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Ks(e) {
        return $368997c7fea60e4e$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ qs(e) {
        return e.metadata.exists ? $368997c7fea60e4e$export$3a1a48c8f6ef640e(this.serializer, e.document, !1) : $368997c7fea60e4e$var$MutableDocument.newNoDocument(this.Ks(e.metadata.name), this.Us(e.metadata.readTime));
    }
    Us(e) {
        return $368997c7fea60e4e$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $368997c7fea60e4e$export$61196ced6d74a310 {
    constructor(e, t){
        this.$a = e, this.serializer = t, /** Batched queries to be saved into storage */ this.Wa = [], /** Batched documents to be saved into storage */ this.Qa = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $368997c7fea60e4e$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.Wa;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.Qa;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ Ga(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.qa.namedQuery) this.Wa.push(e.qa.namedQuery);
        else if (e.qa.documentMetadata) {
            this.Qa.push({
                metadata: e.qa.documentMetadata
            }), e.qa.documentMetadata.exists || ++t;
            const n = $368997c7fea60e4e$export$db202ddc8be9136.fromString(e.qa.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.qa.document && (this.Qa[this.Qa.length - 1].document = e.qa.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    za(e) {
        const t = new Map, n = new $368997c7fea60e4e$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Ks(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $368997c7fea60e4e$export$971d5caa766a69d7()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async ja(e) {
        const t = await $368997c7fea60e4e$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $368997c7fea60e4e$var$__PRIVATE_BundleConverterImpl(this.serializer), this.Qa, this.$a.id), n = this.za(this.documents);
        for (const t of this.Wa)await $368997c7fea60e4e$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Ha: this.collectionGroups,
            Ja: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $368997c7fea60e4e$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $368997c7fea60e4e$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Za = t, this.Xa = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Ya = $368997c7fea60e4e$export$971d5caa766a69d7(), /** Document Keys that have local changes */ this.mutatedKeys = $368997c7fea60e4e$export$971d5caa766a69d7(), this.eu = $368997c7fea60e4e$var$__PRIVATE_newQueryComparator(e), this.tu = new $368997c7fea60e4e$export$25ce5a424b770e84(this.eu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get nu() {
        return this.Za;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ru(e, t) {
        const n = t ? t.iu : new $368997c7fea60e4e$var$__PRIVATE_DocumentChangeSet, r = t ? t.tu : this.tu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $368997c7fea60e4e$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this.su(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.eu(c, _) > 0 || a && this.eu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            tu: s,
            iu: n,
            Ss: o,
            mutatedKeys: i
        };
    }
    su(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.tu;
        this.tu = e.tu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.iu.ya();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $368997c7fea60e4e$export$3a6d5c9ae78a2c08(20277, {
                                Vt: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.eu(e.doc, t.doc)), this.ou(n), r = r ?? !1;
        const o = t && !r ? this._u() : [], _ = 0 === this.Ya.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = _ !== this.Xa;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Xa = _, 0 !== s.length || a) return {
            snapshot: new $368997c7fea60e4e$export$e7c866399fa523f5(this.query, e.tu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === _, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            au: o
        };
        // no changes
        return {
            au: o
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ va(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            tu: this.tu,
            iu: new $368997c7fea60e4e$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Ss: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            au: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ uu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Za.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.tu.has(e) && !this.tu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ ou(e) {
        e && (e.addedDocuments.forEach((e)=>this.Za = this.Za.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Za = this.Za.delete(e)), this.current = e.current);
    }
    _u() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Ya;
        this.Ya = $368997c7fea60e4e$export$971d5caa766a69d7(), this.tu.forEach((e)=>{
            this.uu(e.key) && (this.Ya = this.Ya.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Ya.has(e) || t.push(new $368997c7fea60e4e$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Ya.forEach((n)=>{
            e.has(n) || t.push(new $368997c7fea60e4e$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    cu(e) {
        this.Za = e.ks, this.Ya = $368997c7fea60e4e$export$971d5caa766a69d7();
        const t = this.ru(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    lu() {
        return $368997c7fea60e4e$export$e7c866399fa523f5.fromInitialDocuments(this.query, this.tu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Xa, this.hasCachedResults);
    }
}
const $368997c7fea60e4e$var$Xt = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $368997c7fea60e4e$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $368997c7fea60e4e$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.hu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $368997c7fea60e4e$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Pu = {}, this.Tu = new $368997c7fea60e4e$var$ObjectMap((e)=>$368997c7fea60e4e$var$__PRIVATE_canonifyQuery(e), $368997c7fea60e4e$var$__PRIVATE_queryEquals), this.Iu = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Eu = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Ru = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Au = new Map, this.Vu = new $368997c7fea60e4e$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.du = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.mu = new Map, this.fu = $368997c7fea60e4e$var$__PRIVATE_TargetIdGenerator.ar(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.gu = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.gu;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $368997c7fea60e4e$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.Tu.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.lu()) : i = await $368997c7fea60e4e$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $368997c7fea60e4e$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_ensureWatchCallbacks(e);
    await $368997c7fea60e4e$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $368997c7fea60e4e$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $368997c7fea60e4e$var$__PRIVATE_queryToTarget(t)), s = i.targetId, o = e.sharedClientState.addLocalQueryTarget(s, n);
    let _;
    return r && (_ = await $368997c7fea60e4e$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === o, i.resumeToken)), e.isPrimaryClient && n && $368997c7fea60e4e$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), _;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $368997c7fea60e4e$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.pu = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ru(n);
            i.Ss && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $368997c7fea60e4e$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ru(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = r && null != r.targetMismatches.get(t.targetId), _ = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, o);
            return $368997c7fea60e4e$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, _.au), _.snapshot;
        })(e, t, n, r);
    const s = await $368997c7fea60e4e$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $368997c7fea60e4e$var$__PRIVATE_View(t, s.ks), _ = o.ru(s.documents), a = $368997c7fea60e4e$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $368997c7fea60e4e$var$__PRIVATE_updateTrackedLimbos(e, n, u.au);
    const c = new $368997c7fea60e4e$var$__PRIVATE_QueryView(t, n, o);
    return e.Tu.set(t, c), e.Iu.has(n) ? e.Iu.get(n).push(t) : e.Iu.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = r.Tu.get(t), s = r.Iu.get(i.targetId);
    if (s.length > 1) return r.Iu.set(i.targetId, s.filter((e)=>!$368997c7fea60e4e$var$__PRIVATE_queryEquals(e, t))), void r.Tu.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $368997c7fea60e4e$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = n.Tu.get(t), i = n.Iu.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = $368997c7fea60e4e$export$3d12bd131bb975d1.now(), i = t.reduce((e, t)=>e.add(t.key), $368997c7fea60e4e$export$971d5caa766a69d7());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $368997c7fea60e4e$var$__PRIVATE_mutableDocumentMap(), a = $368997c7fea60e4e$export$971d5caa766a69d7();
                return n.xs.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $368997c7fea60e4e$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $368997c7fea60e4e$var$__PRIVATE_PatchMutation(e.key, t, $368997c7fea60e4e$var$__PRIVATE_extractFieldMask(t.value.mapValue), $368997c7fea60e4e$export$78acf4525d8a74c4.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $368997c7fea60e4e$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.du[e.currentUser.toKey()];
            r || (r = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.du[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    try {
        const e = await $368997c7fea60e4e$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Au.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($368997c7fea60e4e$export$c18d01048907ea92(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.hu = !0 : e.modifiedDocuments.size > 0 ? $368997c7fea60e4e$export$c18d01048907ea92(r.hu, 14607) : e.removedDocuments.size > 0 && ($368997c7fea60e4e$export$c18d01048907ea92(r.hu, 42227), r.hu = !1));
        }), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Tu.forEach((n, r)=>{
            const i = r.view.va(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.ba)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.va(t) && (r = !0);
            }), r && $368997c7fea60e4e$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Pu.J_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Au.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $368997c7fea60e4e$var$MutableDocument.newNoDocument(s, $368997c7fea60e4e$var$SnapshotVersion.min()));
        const n = $368997c7fea60e4e$export$971d5caa766a69d7().add(s), i = new $368997c7fea60e4e$var$RemoteEvent($368997c7fea60e4e$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$var$__PRIVATE_primitiveComparator), e, n);
        await $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.Ru = r.Ru.remove(s), r.Au.delete(t), $368997c7fea60e4e$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $368997c7fea60e4e$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $368997c7fea60e4e$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $368997c7fea60e4e$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($368997c7fea60e4e$export$c18d01048907ea92(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $368997c7fea60e4e$var$__PRIVATE_processUserCallback(r, t, n), $368997c7fea60e4e$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    $368997c7fea60e4e$var$__PRIVATE_canUseNetwork(n.remoteStore) || $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $368997c7fea60e4e$var$U) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.mu.get(e) || [];
        r.push(t), n.mu.set(e, r);
    } catch (e) {
        const n = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $368997c7fea60e4e$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.mu.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.mu.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $368997c7fea60e4e$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    let i = r.du[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.du[r.currentUser.toKey()] = i;
    }
}
function $368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.Iu.get(t))e.Tu.delete(r), n && e.Pu.yu(r, n);
    if (e.Iu.delete(t), e.isPrimaryClient) e.Vu.Gr(t).forEach((t)=>{
        e.Vu.containsKey(t) || // We removed the last reference for this key
        $368997c7fea60e4e$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $368997c7fea60e4e$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Eu.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.Ru.get(t);
    null !== n && ($368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Ru = e.Ru.remove(t), e.Au.delete(n), $368997c7fea60e4e$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $368997c7fea60e4e$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $368997c7fea60e4e$var$__PRIVATE_AddedLimboDocument) e.Vu.addReference(r.key, t), $368997c7fea60e4e$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $368997c7fea60e4e$var$__PRIVATE_RemovedLimboDocument) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "Document no longer in limbo: " + r.key), e.Vu.removeReference(r.key, t);
        e.Vu.containsKey(r.key) || // We removed the last reference for this key
        $368997c7fea60e4e$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $368997c7fea60e4e$export$3a6d5c9ae78a2c08(19791, {
        wu: r
    });
}
function $368997c7fea60e4e$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.Ru.get(n) || e.Eu.has(r) || ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "New document in limbo: " + n), e.Eu.add(r), $368997c7fea60e4e$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $368997c7fea60e4e$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Eu.size > 0 && e.Ru.size < e.maxConcurrentLimboResolutions;){
        const t = e.Eu.values().next().value;
        e.Eu.delete(t);
        const n = new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.fromString(t)), r = e.fu.next();
        e.Au.set(r, new $368997c7fea60e4e$var$LimboResolution(n)), e.Ru = e.Ru.insert(n, r), $368997c7fea60e4e$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $368997c7fea60e4e$var$TargetData($368997c7fea60e4e$var$__PRIVATE_queryToTarget($368997c7fea60e4e$export$a93c5207d687da10(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $368997c7fea60e4e$var$__PRIVATE_ListenSequence.ce));
    }
}
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Tu.isEmpty() || (r.Tu.forEach((e, _)=>{
        o.push(r.pu(_, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(_.targetId)?.current;
                r.sharedClientState.updateQueryState(_.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $368997c7fea60e4e$var$__PRIVATE_LocalViewChanges.Es(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Pu.J_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$368997c7fea60e4e$var$PersistencePromise.forEach(t, (t)=>$368997c7fea60e4e$var$PersistencePromise.forEach(t.Ts, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$368997c7fea60e4e$var$PersistencePromise.forEach(t.Is, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Bt, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.vs.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.vs = n.vs.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "User change. New user:", t.toKey());
        const e = await $368997c7fea60e4e$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.mu.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.CANCELLED, t));
                });
            }), e.mu.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.Ns);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = n.Au.get(t);
    if (r && r.hu) return $368997c7fea60e4e$export$971d5caa766a69d7().add(r.key);
    {
        let e = $368997c7fea60e4e$export$971d5caa766a69d7();
        const r = n.Iu.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Tu.get(t);
            e = e.unionWith(r.view.nu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $368997c7fea60e4e$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = await $368997c7fea60e4e$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.cu(r);
    return n.isPrimaryClient && $368997c7fea60e4e$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.au), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return $368997c7fea60e4e$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = $368997c7fea60e4e$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Xn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $368997c7fea60e4e$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($368997c7fea60e4e$var$__PRIVATE_processUserCallback(i, t, r || null), $368997c7fea60e4e$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $368997c7fea60e4e$var$__PRIVATE_debugCast($368997c7fea60e4e$var$__PRIVATE_debugCast(e).mutationQueue).nr(t);
    }(i.localStore, t)) : $368997c7fea60e4e$export$3a6d5c9ae78a2c08(6720, "Unknown batchState", {
        bu: n
    }), await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    if ($368997c7fea60e4e$var$__PRIVATE_ensureWatchCallbacks(n), $368997c7fea60e4e$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.gu) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $368997c7fea60e4e$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.gu = !0, await $368997c7fea60e4e$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$368997c7fea60e4e$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.gu) {
        const e = [];
        let t = Promise.resolve();
        n.Iu.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(n, i), $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $368997c7fea60e4e$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            t.Au.forEach((e, n)=>{
                $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.Vu.zr(), t.Au = new Map, t.Ru = new $368997c7fea60e4e$var$SortedMap($368997c7fea60e4e$export$90a7f3efeed30595.comparator);
        }(n), n.gu = !1, await $368997c7fea60e4e$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $368997c7fea60e4e$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.Iu.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $368997c7fea60e4e$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Tu.get(e), n = await $368997c7fea60e4e$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $368997c7fea60e4e$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $368997c7fea60e4e$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $368997c7fea60e4e$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Pu.J_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $368997c7fea60e4e$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $368997c7fea60e4e$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $368997c7fea60e4e$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $368997c7fea60e4e$var$__PRIVATE_debugCast($368997c7fea60e4e$var$__PRIVATE_debugCast(e).persistence).hs();
    }($368997c7fea60e4e$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    if (i.gu) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "Ignoring unexpected query state notification.");
    const s = i.Iu.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $368997c7fea60e4e$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $368997c7fea60e4e$var$__PRIVATE_queryCollectionGroup(s[0])), r = $368997c7fea60e4e$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $368997c7fea60e4e$export$9d398bebfec1c039.EMPTY_BYTE_STRING);
                await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $368997c7fea60e4e$export$3a6d5c9ae78a2c08(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.gu) {
        for (const e of t){
            if (r.Iu.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Xt, "Adding an already active target " + e);
                continue;
            }
            const t = await $368997c7fea60e4e$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $368997c7fea60e4e$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $368997c7fea60e4e$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $368997c7fea60e4e$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $368997c7fea60e4e$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.Iu.has(e) && // Release queries that are still active.
        await $368997c7fea60e4e$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $368997c7fea60e4e$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $368997c7fea60e4e$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($368997c7fea60e4e$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $368997c7fea60e4e$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $368997c7fea60e4e$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Pu.J_ = $368997c7fea60e4e$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Pu.yu = $368997c7fea60e4e$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $368997c7fea60e4e$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $368997c7fea60e4e$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $368997c7fea60e4e$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $368997c7fea60e4e$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = $368997c7fea60e4e$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Pi.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($368997c7fea60e4e$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $368997c7fea60e4e$export$61196ced6d74a310(r, t.serializer);
            let s = await t.Su();
            for(; s;){
                const e = await i.Ga(s);
                e && n._updateProgress(e), s = await t.Su();
            }
            const o = await i.ja(e.localStore);
            return await $368997c7fea60e4e$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Ja, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Pi.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Ha);
        } catch (e) {
            return $368997c7fea60e4e$export$4c3d22f3d993c33f($368997c7fea60e4e$var$Xt, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $368997c7fea60e4e$export$d24c54395ce0c509 {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $368997c7fea60e4e$export$b4171a6734a65d42(e.databaseInfo.databaseId), this.sharedClientState = this.Du(e), this.persistence = this.Cu(e), await this.persistence.start(), this.localStore = this.vu(e), this.gcScheduler = this.Fu(e, this.localStore), this.indexBackfillerScheduler = this.Mu(e, this.localStore);
    }
    Fu(e, t) {
        return null;
    }
    Mu(e, t) {
        return null;
    }
    vu(e) {
        return $368997c7fea60e4e$var$__PRIVATE_newLocalStore(this.persistence, new $368997c7fea60e4e$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Cu(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_MemoryPersistence($368997c7fea60e4e$var$__PRIVATE_MemoryEagerDelegate.Vi, this.serializer);
    }
    Du(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$368997c7fea60e4e$export$d24c54395ce0c509.provider = {
    build: ()=>new $368997c7fea60e4e$export$d24c54395ce0c509
};
class $368997c7fea60e4e$export$8a5498727ef6be21 extends $368997c7fea60e4e$export$d24c54395ce0c509 {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Fu(e, t) {
        $368997c7fea60e4e$export$c18d01048907ea92(this.persistence.referenceDelegate instanceof $368997c7fea60e4e$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $368997c7fea60e4e$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Cu(e) {
        const t = void 0 !== this.cacheSizeBytes ? $368997c7fea60e4e$var$LruParams.withCacheSize(this.cacheSizeBytes) : $368997c7fea60e4e$var$LruParams.DEFAULT;
        return new $368997c7fea60e4e$var$__PRIVATE_MemoryPersistence((e)=>$368997c7fea60e4e$var$__PRIVATE_MemoryLruDelegate.Vi(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $368997c7fea60e4e$export$6554612db691658e extends $368997c7fea60e4e$export$d24c54395ce0c509 {
    constructor(e, t, n){
        super(), this.xu = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.xu.initialize(this, e), // Enqueue writes from a previous session
        await $368997c7fea60e4e$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.xu.syncEngine), await $368997c7fea60e4e$var$__PRIVATE_fillWritePipeline(this.xu.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    vu(e) {
        return $368997c7fea60e4e$var$__PRIVATE_newLocalStore(this.persistence, new $368997c7fea60e4e$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Fu(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $368997c7fea60e4e$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Mu(e, t) {
        const n = new $368997c7fea60e4e$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $368997c7fea60e4e$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Cu(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $368997c7fea60e4e$var$LruParams.withCacheSize(this.cacheSizeBytes) : $368997c7fea60e4e$var$LruParams.DEFAULT;
        return new $368997c7fea60e4e$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $368997c7fea60e4e$var$__PRIVATE_getWindow(), $368997c7fea60e4e$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Du(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $368997c7fea60e4e$export$493d36ec626b6698 extends $368997c7fea60e4e$export$6554612db691658e {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.xu = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.xu.syncEngine;
        this.sharedClientState instanceof $368997c7fea60e4e$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            So: $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            Do: $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Co: $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            hs: $368997c7fea60e4e$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            bo: $368997c7fea60e4e$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.zi(async (e)=>{
            await $368997c7fea60e4e$var$__PRIVATE_syncEngineApplyPrimaryState(this.xu.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Du(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_getWindow();
        if (!$368997c7fea60e4e$var$__PRIVATE_WebStorageSharedClientState.v(t)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $368997c7fea60e4e$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $368997c7fea60e4e$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $368997c7fea60e4e$export$2f6ca3d3b1f80bf5 {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$368997c7fea60e4e$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $368997c7fea60e4e$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $368997c7fea60e4e$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $368997c7fea60e4e$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $368997c7fea60e4e$export$b4171a6734a65d42(e.databaseInfo.databaseId), n = $368997c7fea60e4e$var$__PRIVATE_newConnection(e.databaseInfo);
        return $368997c7fea60e4e$var$__PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $368997c7fea60e4e$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$368997c7fea60e4e$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $368997c7fea60e4e$var$__PRIVATE_BrowserConnectivityMonitor.v() ? new $368997c7fea60e4e$var$__PRIVATE_BrowserConnectivityMonitor : new $368997c7fea60e4e$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $368997c7fea60e4e$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.gu = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Ht, "RemoteStore shutting down."), t.Ea.add(5 /* OfflineCause.Shutdown */ ), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(t), t.Aa.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.Va.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$368997c7fea60e4e$export$2f6ca3d3b1f80bf5.provider = {
    build: ()=>new $368997c7fea60e4e$export$2f6ca3d3b1f80bf5
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $368997c7fea60e4e$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $368997c7fea60e4e$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.Ou(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.Ou(this.observer.error, e) : $368997c7fea60e4e$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    Nu() {
        this.muted = !0;
    }
    Ou(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $368997c7fea60e4e$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Bu = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $368997c7fea60e4e$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Lu = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.ku().then((e)=>{
            e && e.Ua() ? this.metadata.resolve(e.qa.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.qa)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Bu.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Su() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.ku();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async ku() {
        const e = await this.Ku();
        if (null === e) return null;
        const t = this.Lu.decode(e), n = Number(t);
        isNaN(n) && this.qu(`length string (${t}) is not valid number`);
        const r = await this.Uu(n);
        return new $368997c7fea60e4e$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ $u() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async Ku() {
        for(; this.$u() < 0;){
            if (await this.Wu()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.$u();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.qu("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Uu(e) {
        for(; this.buffer.length < e;)await this.Wu() && this.qu("Reached the end of bundle when more is expected.");
        const t = this.Lu.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    qu(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Bu.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Wu() {
        const e = await this.Bu.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $368997c7fea60e4e$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Su();
        if (!n || !n.Ua()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.qa)}`);
        this.metadata = n;
        do n = this.Su(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ Qu() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Su() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.Ku(), t = this.Uu(e);
        return new $368997c7fea60e4e$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ Uu(e) {
        if (this.cursor + e > this.bundleData.length) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ Ku() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $368997c7fea60e4e$var$Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$368997c7fea60e4e$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.jo("BatchGetDocuments", n.serializer.databaseId, $368997c7fea60e4e$export$db202ddc8be9136.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $368997c7fea60e4e$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const o = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $368997c7fea60e4e$export$c18d01048907ea92(!!t, 55234, {
                    key: e
                }), o.push(t);
            }), o;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $368997c7fea60e4e$export$34aec0b863436764(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $368997c7fea60e4e$export$90a7f3efeed30595.fromPath(t);
            this.mutations.push(new $368997c7fea60e4e$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$368997c7fea60e4e$var$toMutation(n.serializer, e))
            };
            await n.Wo("Commit", n.serializer.databaseId, $368997c7fea60e4e$export$db202ddc8be9136.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(50498, {
                Gu: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $368997c7fea60e4e$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($368997c7fea60e4e$var$SnapshotVersion.min()) ? $368997c7fea60e4e$export$78acf4525d8a74c4.exists(!1) : $368997c7fea60e4e$export$78acf4525d8a74c4.updateTime(t) : $368997c7fea60e4e$export$78acf4525d8a74c4.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($368997c7fea60e4e$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $368997c7fea60e4e$export$78acf4525d8a74c4.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $368997c7fea60e4e$export$78acf4525d8a74c4.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $368997c7fea60e4e$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.zu = n.maxAttempts, this.M_ = new $368997c7fea60e4e$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ ju() {
        this.zu -= 1, this.Hu();
    }
    Hu() {
        this.M_.p_(async ()=>{
            const e = new $368997c7fea60e4e$var$Transaction(this.datastore), t = this.Ju(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Zu(e);
                    }));
            }).catch((e)=>{
                this.Zu(e);
            });
        });
    }
    Ju(e) {
        try {
            const t = this.updateFunction(e);
            return !$368997c7fea60e4e$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Zu(e) {
        this.zu > 0 && this.Xu(e) ? (this.zu -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Hu(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Xu(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$368997c7fea60e4e$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$Yt = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $368997c7fea60e4e$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = $368997c7fea60e4e$var$User.UNAUTHENTICATED, this.clientId = $368997c7fea60e4e$export$a07804094c3ecf2d.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $368997c7fea60e4e$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $368997c7fea60e4e$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $368997c7fea60e4e$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $368997c7fea60e4e$var$__PRIVATE_ensureOfflineComponents(e);
    $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$368997c7fea60e4e$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$368997c7fea60e4e$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $368997c7fea60e4e$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Using user provided OfflineComponentProvider");
            try {
                await $368997c7fea60e4e$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION || e.code === $368997c7fea60e4e$export$e7094788287c5e9b.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $368997c7fea60e4e$export$4c3d22f3d993c33f("Error using user provided cache. Falling back to memory cache: " + n), await $368997c7fea60e4e$var$__PRIVATE_setOfflineComponentProvider(e, new $368997c7fea60e4e$export$d24c54395ce0c509);
            }
        } else $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Using default OfflineComponentProvider"), await $368997c7fea60e4e$var$__PRIVATE_setOfflineComponentProvider(e, new $368997c7fea60e4e$export$8a5498727ef6be21(void 0));
    }
    return e._offlineComponents;
}
async function $368997c7fea60e4e$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Using user provided OnlineComponentProvider"), await $368997c7fea60e4e$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$Yt, "Using default OnlineComponentProvider"), await $368997c7fea60e4e$var$__PRIVATE_setOnlineComponentProvider(e, new $368997c7fea60e4e$export$2f6ca3d3b1f80bf5))), e._onlineComponents;
}
function $368997c7fea60e4e$var$__PRIVATE_getPersistence(e) {
    return $368997c7fea60e4e$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $368997c7fea60e4e$var$__PRIVATE_getRemoteStore(e) {
    return $368997c7fea60e4e$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $368997c7fea60e4e$var$__PRIVATE_getSyncEngine(e) {
    return $368997c7fea60e4e$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $368997c7fea60e4e$var$__PRIVATE_getDatastore$1(e) {
    return $368997c7fea60e4e$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $368997c7fea60e4e$var$__PRIVATE_getEventManager(e) {
    const t = await $368997c7fea60e4e$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $368997c7fea60e4e$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $368997c7fea60e4e$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $368997c7fea60e4e$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $368997c7fea60e4e$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $368997c7fea60e4e$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $368997c7fea60e4e$var$__PRIVATE_getPersistence(e), n = await $368997c7fea60e4e$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            return t.Ea.delete(0 /* OfflineCause.UserDisabled */ ), $368997c7fea60e4e$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $368997c7fea60e4e$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $368997c7fea60e4e$var$__PRIVATE_getPersistence(e), n = await $368997c7fea60e4e$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            t.Ea.add(0 /* OfflineCause.UserDisabled */ ), await $368997c7fea60e4e$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.Va.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $368997c7fea60e4e$export$c3950d9923825c02(e, t, n, r) {
    const i = new $368997c7fea60e4e$var$__PRIVATE_AsyncObserver(r), s = new $368997c7fea60e4e$var$__PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>$368997c7fea60e4e$var$__PRIVATE_eventManagerListen(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), s)), ()=>{
        i.Nu(), e.asyncQueue.enqueueAndForget(async ()=>$368997c7fea60e4e$var$__PRIVATE_eventManagerUnlisten(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), s));
    };
}
function $368997c7fea60e4e$export$6559d589eb85fbb6(e, t) {
    const n = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $368997c7fea60e4e$export$ce26c07117d59d6a(e, t, n = {}) {
    const r = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $368997c7fea60e4e$var$__PRIVATE_AsyncObserver({
                next: (_)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$368997c7fea60e4e$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const a = _.docs.has(n);
                    !a && _.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && _.fromCache && r && "server" === r.source ? i.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(_);
                },
                error: (e)=>i.reject(e)
            }), o = new $368997c7fea60e4e$var$__PRIVATE_QueryListener($368997c7fea60e4e$export$a93c5207d687da10(n.path), s, {
                includeMetadataChanges: !0,
                Ka: !0
            });
            return $368997c7fea60e4e$var$__PRIVATE_eventManagerListen(e, o);
        })(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $368997c7fea60e4e$export$a8550f7dbe79f93a(e, t) {
    const n = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $368997c7fea60e4e$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $368997c7fea60e4e$var$__PRIVATE_View(t, r.ks), s = i.ru(r.documents), o = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $368997c7fea60e4e$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $368997c7fea60e4e$export$efca4cbe5dd06740(e, t, n = {}) {
    const r = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $368997c7fea60e4e$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.Nu(), t.enqueueAndForget(()=>$368997c7fea60e4e$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $368997c7fea60e4e$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                Ka: !0
            });
            return $368997c7fea60e4e$var$__PRIVATE_eventManagerListen(e, o);
        })(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $368997c7fea60e4e$export$2329c99376c9d0a4(e, t, n) {
    const r = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $368997c7fea60e4e$var$__PRIVATE_getDatastore$1(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), { request: i, gt: s, parent: o } = $368997c7fea60e4e$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $368997c7fea60e4e$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ko || delete i.parent;
                const _ = (await r.jo("RunAggregationQuery", r.serializer.databaseId, o, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $368997c7fea60e4e$export$c18d01048907ea92(1 === _.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = _[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $368997c7fea60e4e$export$d22783b3c2400a3a(e, t) {
    const n = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await $368997c7fea60e4e$var$__PRIVATE_getDatastore$1(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = {
                    database: $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.jo("ExecutePipeline", n.serializer.databaseId, $368997c7fea60e4e$export$db202ddc8be9136.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push($368997c7fea60e4e$var$__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push($368997c7fea60e4e$var$__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function $368997c7fea60e4e$export$2219238a014317b0(e, t) {
    const n = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>$368997c7fea60e4e$var$__PRIVATE_syncEngineWrite(await $368997c7fea60e4e$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function $368997c7fea60e4e$export$555508cbc6add439(e, t) {
    const n = new $368997c7fea60e4e$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $368997c7fea60e4e$var$__PRIVATE_debugCast(e).Ca.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Nu(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $368997c7fea60e4e$var$__PRIVATE_debugCast(e).Ca.delete(t);
            })(await $368997c7fea60e4e$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $368997c7fea60e4e$export$3c2fa207a37baaea(e, t, n) {
    const r = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await $368997c7fea60e4e$var$__PRIVATE_getDatastore$1(e);
        new $368997c7fea60e4e$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).ju();
    }), r.promise;
}
function $368997c7fea60e4e$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $368997c7fea60e4e$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $368997c7fea60e4e$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $368997c7fea60e4e$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $368997c7fea60e4e$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $368997c7fea60e4e$export$b4171a6734a65d42(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $368997c7fea60e4e$var$__PRIVATE_syncEngineLoadBundle(await $368997c7fea60e4e$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $368997c7fea60e4e$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Pi.getNamedQuery(e, t));
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e), t));
}
function $368997c7fea60e4e$export$3466f893ebf79586(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $368997c7fea60e4e$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $368997c7fea60e4e$export$f38c853ae54ed474(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $368997c7fea60e4e$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$368997c7fea60e4e$var$PersistencePromise.waitFor(i)));
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e), t));
}
function $368997c7fea60e4e$export$ab83b03e4111b1d0(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $368997c7fea60e4e$var$__PRIVATE_debugCast(e).Cs.As = t;
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e), t));
}
function $368997c7fea60e4e$export$3b513254972cfc9c(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $368997c7fea60e4e$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $368997c7fea60e4e$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $368997c7fea60e4e$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$en = "ComponentProvider", $368997c7fea60e4e$var$tn = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function $368997c7fea60e4e$var$__PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new $368997c7fea60e4e$var$DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, $368997c7fea60e4e$var$__PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $368997c7fea60e4e$var$nn = "firestore.googleapis.com", $368997c7fea60e4e$var$rn = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $368997c7fea60e4e$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $368997c7fea60e4e$var$nn, this.ssl = $368997c7fea60e4e$var$rn;
        } else this.host = e.host, this.ssl = e.ssl ?? $368997c7fea60e4e$var$rn;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $368997c7fea60e4e$var$Dt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $368997c7fea60e4e$var$vt) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $368997c7fea60e4e$export$23ebac1979863676("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $368997c7fea60e4e$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $368997c7fea60e4e$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $368997c7fea60e4e$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $368997c7fea60e4e$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $368997c7fea60e4e$export$158acd800e1ef08b;
            switch(e.type){
                case "firstParty":
                    return new $368997c7fea60e4e$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $368997c7fea60e4e$var$tn.get(e);
            t && ($368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$en, "Removing Datastore"), $368997c7fea60e4e$var$tn.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $368997c7fea60e4e$export$f96d196f7728bb5(e, t, n, r = {}) {
    e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$var$Firestore$1);
    const i = (0, $9k0Bn.isCloudWorkstation)(t), s = e._getSettings(), o = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, _ = `${t}:${n}`;
    i && ((0, $9k0Bn.pingServer)(`https://${_}`), (0, $9k0Bn.updateEmulatorBanner)("Firestore", !0)), s.host !== $368997c7fea60e4e$var$nn && s.host !== _ && $368997c7fea60e4e$export$4c3d22f3d993c33f("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const a = {
        ...s,
        host: _,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $9k0Bn.deepEqual)(a, o) && (e._setSettings(a), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $368997c7fea60e4e$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $9k0Bn.createMockUserToken)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $368997c7fea60e4e$var$User(i);
        }
        e._authCredentials = new $368997c7fea60e4e$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $368997c7fea60e4e$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $368997c7fea60e4e$export$3722cfe417b6ed86 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $368997c7fea60e4e$export$3722cfe417b6ed86(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $368997c7fea60e4e$export$96f57966bedc81b4 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $368997c7fea60e4e$export$d66dc83d8cfc8dd(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $368997c7fea60e4e$export$96f57966bedc81b4(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $368997c7fea60e4e$export$96f57966bedc81b4._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($368997c7fea60e4e$export$9bb611d729802a56(t, $368997c7fea60e4e$export$96f57966bedc81b4._jsonSchema)) return new $368997c7fea60e4e$export$96f57966bedc81b4(e, n || null, new $368997c7fea60e4e$export$90a7f3efeed30595($368997c7fea60e4e$export$db202ddc8be9136.fromString(t.referencePath)));
    }
}
$368997c7fea60e4e$export$96f57966bedc81b4._jsonSchemaVersion = "firestore/documentReference/1.0", $368997c7fea60e4e$export$96f57966bedc81b4._jsonSchema = {
    type: $368997c7fea60e4e$export$ffb5f4729a158638("string", $368997c7fea60e4e$export$96f57966bedc81b4._jsonSchemaVersion),
    referencePath: $368997c7fea60e4e$export$ffb5f4729a158638("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $368997c7fea60e4e$export$d66dc83d8cfc8dd extends $368997c7fea60e4e$export$3722cfe417b6ed86 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $368997c7fea60e4e$export$a93c5207d687da10(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $368997c7fea60e4e$export$96f57966bedc81b4(this.firestore, /* converter= */ null, new $368997c7fea60e4e$export$90a7f3efeed30595(e));
    }
    withConverter(e) {
        return new $368997c7fea60e4e$export$d66dc83d8cfc8dd(this.firestore, e, this._path);
    }
}
function $368997c7fea60e4e$export$4ae495d48253603d(e) {
    return e instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd;
}
function $368997c7fea60e4e$export$c03999cb2f36933f(e, t, ...n) {
    if (e = (0, $9k0Bn.getModularInstance)(e), $368997c7fea60e4e$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $368997c7fea60e4e$var$Firestore$1) {
        const r = $368997c7fea60e4e$export$db202ddc8be9136.fromString(t, ...n);
        return $368997c7fea60e4e$var$__PRIVATE_validateCollectionPath(r), new $368997c7fea60e4e$export$d66dc83d8cfc8dd(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $368997c7fea60e4e$export$96f57966bedc81b4 || e instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($368997c7fea60e4e$export$db202ddc8be9136.fromString(t, ...n));
        return $368997c7fea60e4e$var$__PRIVATE_validateCollectionPath(r), new $368997c7fea60e4e$export$d66dc83d8cfc8dd(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $368997c7fea60e4e$export$2ed0fc6709e59212(e, t) {
    if (e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$var$Firestore$1), $368997c7fea60e4e$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $368997c7fea60e4e$export$3722cfe417b6ed86(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $368997c7fea60e4e$var$__PRIVATE_QueryImpl($368997c7fea60e4e$export$db202ddc8be9136.emptyPath(), e);
    }(t));
}
function $368997c7fea60e4e$export$2e2af4578d910ddf(e, t, ...n) {
    if (e = (0, $9k0Bn.getModularInstance)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $368997c7fea60e4e$export$a07804094c3ecf2d.newId()), $368997c7fea60e4e$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $368997c7fea60e4e$var$Firestore$1) {
        const r = $368997c7fea60e4e$export$db202ddc8be9136.fromString(t, ...n);
        return $368997c7fea60e4e$var$__PRIVATE_validateDocumentPath(r), new $368997c7fea60e4e$export$96f57966bedc81b4(e, /* converter= */ null, new $368997c7fea60e4e$export$90a7f3efeed30595(r));
    }
    {
        if (!(e instanceof $368997c7fea60e4e$export$96f57966bedc81b4 || e instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($368997c7fea60e4e$export$db202ddc8be9136.fromString(t, ...n));
        return $368997c7fea60e4e$var$__PRIVATE_validateDocumentPath(r), new $368997c7fea60e4e$export$96f57966bedc81b4(e.firestore, e instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd ? e.converter : null, new $368997c7fea60e4e$export$90a7f3efeed30595(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $368997c7fea60e4e$export$a17c37559e1db147(e, t) {
    return e = (0, $9k0Bn.getModularInstance)(e), t = (0, $9k0Bn.getModularInstance)(t), (e instanceof $368997c7fea60e4e$export$96f57966bedc81b4 || e instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd) && (t instanceof $368997c7fea60e4e$export$96f57966bedc81b4 || t instanceof $368997c7fea60e4e$export$d66dc83d8cfc8dd) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $368997c7fea60e4e$export$d141bba7fdc215a3(e, t) {
    return e = (0, $9k0Bn.getModularInstance)(e), t = (0, $9k0Bn.getModularInstance)(t), e instanceof $368997c7fea60e4e$export$3722cfe417b6ed86 && t instanceof $368997c7fea60e4e$export$3722cfe417b6ed86 && e.firestore === t.firestore && $368997c7fea60e4e$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$sn = "AsyncQueue";
class $368997c7fea60e4e$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Yu = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.ec = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.tc = [], // visible for testing
        this.nc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.rc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.sc = !1, // List of TimerIds to fast-forward delays for.
        this.oc = [], // Backoff timer used to schedule retries for retryable operations
        this.M_ = new $368997c7fea60e4e$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this._c = ()=>{
            const e = $368997c7fea60e4e$var$getDocument();
            e && $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$sn, "Visibility state changed to " + e.visibilityState), this.M_.w_();
        }, this.ac = e;
        const t = $368997c7fea60e4e$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this._c);
    }
    get isShuttingDown() {
        return this.ec;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.uc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.cc(e);
    }
    enterRestrictedMode(e) {
        if (!this.ec) {
            this.ec = !0, this.sc = e || !1;
            const t = $368997c7fea60e4e$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this._c);
        }
    }
    enqueue(e) {
        if (this.uc(), this.ec) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
        return this.cc(()=>this.ec && this.sc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Yu.push(e), this.lc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async lc() {
        if (0 !== this.Yu.length) {
            try {
                await this.Yu[0](), this.Yu.shift(), this.M_.reset();
            } catch (e) {
                if (!$368997c7fea60e4e$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$sn, "Operation failed with retryable error: " + e);
            }
            this.Yu.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.M_.p_(()=>this.lc());
        }
    }
    cc(e) {
        const t = this.ac.then(()=>(this.rc = !0, e().catch((e)=>{
                this.nc = e, this.rc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $368997c7fea60e4e$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $368997c7fea60e4e$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.rc = !1, e))));
        return this.ac = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.uc(), // Fast-forward delays for timerIds that have been overridden.
        this.oc.indexOf(e) > -1 && (t = 0);
        const r = $368997c7fea60e4e$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.hc(e));
        return this.tc.push(r), r;
    }
    uc() {
        this.nc && $368997c7fea60e4e$export$3a6d5c9ae78a2c08(47125, {
            Pc: $368997c7fea60e4e$var$__PRIVATE_getMessageOrStack(this.nc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async Tc() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.ac, await e;
        while (e !== this.ac);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ Ic(e) {
        for (const t of this.tc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ Ec(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.Tc().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.tc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.Tc();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ Rc(e) {
        this.oc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ hc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.tc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.tc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $368997c7fea60e4e$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class $368997c7fea60e4e$export$28f7fcd39efa255 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $368997c7fea60e4e$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $368997c7fea60e4e$export$1fbe638ecf81657e = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $368997c7fea60e4e$export$d66501df72047452 extends $368997c7fea60e4e$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $368997c7fea60e4e$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $368997c7fea60e4e$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $368997c7fea60e4e$export$527e9aa3390079e9(e, t, n) {
    n || (n = $368997c7fea60e4e$var$st);
    const r = (0, $bVYHX._getProvider)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $9k0Bn.deepEqual)(i, t)) return e;
        throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $368997c7fea60e4e$var$vt) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $9k0Bn.isCloudWorkstation)(t.host) && (0, $9k0Bn.pingServer)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $368997c7fea60e4e$export$1a8f5705751d8277(e, n) {
    const r = "object" == typeof e ? e : (0, $bVYHX.getApp)(), i = "string" == typeof e ? e : n || $368997c7fea60e4e$var$st, s = (0, $bVYHX._getProvider)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $9k0Bn.getDefaultEmulatorHostnameAndPort)("firestore");
        e && $368997c7fea60e4e$export$f96d196f7728bb5(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $368997c7fea60e4e$export$df995fae86a55f06(e) {
    if (e._terminated) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $368997c7fea60e4e$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $368997c7fea60e4e$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = $368997c7fea60e4e$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $368997c7fea60e4e$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $368997c7fea60e4e$export$317a3d46287192d8(e, t) {
    $368997c7fea60e4e$export$4c3d22f3d993c33f("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $368997c7fea60e4e$var$__PRIVATE_setPersistenceProviders(e, $368997c7fea60e4e$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $368997c7fea60e4e$export$6554612db691658e(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $368997c7fea60e4e$export$1ee57be6f6687d2c(e) {
    $368997c7fea60e4e$export$4c3d22f3d993c33f("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $368997c7fea60e4e$var$__PRIVATE_setPersistenceProviders(e, $368997c7fea60e4e$export$2f6ca3d3b1f80bf5.provider, {
        build: (e)=>new $368997c7fea60e4e$export$493d36ec626b6698(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $368997c7fea60e4e$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452))._firestoreClient || e._terminated) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $368997c7fea60e4e$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $368997c7fea60e4e$export$faec65b429be379(e) {
    if (e._initialized && !e._terminated) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$368997c7fea60e4e$var$__PRIVATE_SimpleDb.v()) return Promise.resolve();
                const t = e + $368997c7fea60e4e$var$Nt;
                await $368997c7fea60e4e$var$__PRIVATE_SimpleDb.delete(t);
            }($368997c7fea60e4e$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $368997c7fea60e4e$export$53c86fa97d611818(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $368997c7fea60e4e$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$368997c7fea60e4e$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $368997c7fea60e4e$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($368997c7fea60e4e$export$df995fae86a55f06(e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $368997c7fea60e4e$export$9d0e2d13d04f7070(e) {
    return $368997c7fea60e4e$var$__PRIVATE_firestoreClientEnableNetwork($368997c7fea60e4e$export$df995fae86a55f06(e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $368997c7fea60e4e$export$d377dcb2b61d6c4e(e) {
    return $368997c7fea60e4e$var$__PRIVATE_firestoreClientDisableNetwork($368997c7fea60e4e$export$df995fae86a55f06(e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $368997c7fea60e4e$export$d29e374196577086(e) {
    return (0, $bVYHX._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $368997c7fea60e4e$export$a9c996f45e5784d0(e, t) {
    const n = $368997c7fea60e4e$export$df995fae86a55f06(e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452)), r = new $368997c7fea60e4e$export$28f7fcd39efa255;
    return $368997c7fea60e4e$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $368997c7fea60e4e$export$7910e0436ed8d1de(e, t) {
    return $368997c7fea60e4e$var$__PRIVATE_firestoreClientGetNamedQuery($368997c7fea60e4e$export$df995fae86a55f06(e = $368997c7fea60e4e$export$4a5767248b18ef41(e, $368997c7fea60e4e$export$d66501df72047452)), t).then((t)=>t ? new $368997c7fea60e4e$export$3722cfe417b6ed86(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $368997c7fea60e4e$export$ef35774e6d314e91 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $368997c7fea60e4e$export$ef35774e6d314e91($368997c7fea60e4e$export$9d398bebfec1c039.fromBase64String(e));
        } catch (e) {
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $368997c7fea60e4e$export$ef35774e6d314e91($368997c7fea60e4e$export$9d398bebfec1c039.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $368997c7fea60e4e$export$ef35774e6d314e91._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($368997c7fea60e4e$export$9bb611d729802a56(e, $368997c7fea60e4e$export$ef35774e6d314e91._jsonSchema)) return $368997c7fea60e4e$export$ef35774e6d314e91.fromBase64String(e.bytes);
    }
}
$368997c7fea60e4e$export$ef35774e6d314e91._jsonSchemaVersion = "firestore/bytes/1.0", $368997c7fea60e4e$export$ef35774e6d314e91._jsonSchema = {
    type: $368997c7fea60e4e$export$ffb5f4729a158638("string", $368997c7fea60e4e$export$ef35774e6d314e91._jsonSchemaVersion),
    bytes: $368997c7fea60e4e$export$ffb5f4729a158638("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $368997c7fea60e4e$export$8743009a87fcb00f {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $368997c7fea60e4e$export$cf2f7c5792f80b46(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $368997c7fea60e4e$export$667d3bf0c5f83305() {
    return new $368997c7fea60e4e$export$8743009a87fcb00f($368997c7fea60e4e$export$7a0bdf7d4a91ea88);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $368997c7fea60e4e$export$92108d983e8ee699 {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $368997c7fea60e4e$export$9fa96a7d116ea3ce {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $368997c7fea60e4e$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $368997c7fea60e4e$export$9fa96a7d116ea3ce._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($368997c7fea60e4e$export$9bb611d729802a56(e, $368997c7fea60e4e$export$9fa96a7d116ea3ce._jsonSchema)) return new $368997c7fea60e4e$export$9fa96a7d116ea3ce(e.latitude, e.longitude);
    }
}
$368997c7fea60e4e$export$9fa96a7d116ea3ce._jsonSchemaVersion = "firestore/geoPoint/1.0", $368997c7fea60e4e$export$9fa96a7d116ea3ce._jsonSchema = {
    type: $368997c7fea60e4e$export$ffb5f4729a158638("string", $368997c7fea60e4e$export$9fa96a7d116ea3ce._jsonSchemaVersion),
    latitude: $368997c7fea60e4e$export$ffb5f4729a158638("number"),
    longitude: $368997c7fea60e4e$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class $368997c7fea60e4e$export$91c6e00c14e7e6fd {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $368997c7fea60e4e$export$91c6e00c14e7e6fd._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($368997c7fea60e4e$export$9bb611d729802a56(e, $368997c7fea60e4e$export$91c6e00c14e7e6fd._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $368997c7fea60e4e$export$91c6e00c14e7e6fd(e.vectorValues);
            throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$368997c7fea60e4e$export$91c6e00c14e7e6fd._jsonSchemaVersion = "firestore/vectorValue/1.0", $368997c7fea60e4e$export$91c6e00c14e7e6fd._jsonSchema = {
    type: $368997c7fea60e4e$export$ffb5f4729a158638("string", $368997c7fea60e4e$export$91c6e00c14e7e6fd._jsonSchemaVersion),
    vectorValues: $368997c7fea60e4e$export$ffb5f4729a158638("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $368997c7fea60e4e$var$_n = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $368997c7fea60e4e$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $368997c7fea60e4e$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $368997c7fea60e4e$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $368997c7fea60e4e$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $368997c7fea60e4e$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $368997c7fea60e4e$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $368997c7fea60e4e$var$ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ contextWith(e) {
        return new $368997c7fea60e4e$var$ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    childContextForField(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePathSegment(e), n;
    }
    childContextForFieldPath(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePath(), n;
    }
    childContextForArray(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.contextWith({
            path: void 0,
            arrayElement: !0
        });
    }
    createError(e) {
        return $368997c7fea60e4e$var$createError(e, this.settings.methodName, this.settings.hasConverter || !1, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    validatePath() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
    }
    validatePathSegment(e) {
        if (0 === e.length) throw this.createError("Document fields must not be empty");
        if ($368997c7fea60e4e$var$__PRIVATE_isWrite(this.dataSource) && $368997c7fea60e4e$var$_n.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $368997c7fea60e4e$export$c5d1328b37d47994 {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $368997c7fea60e4e$export$b4171a6734a65d42(e);
    }
    /** Creates a new top-level parse context. */ createContext(e, t, n, r = !1) {
        return new $368997c7fea60e4e$var$ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: $368997c7fea60e4e$export$cf2f7c5792f80b46.emptyPath(),
            arrayElement: !1,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $368997c7fea60e4e$export$2d1720544b23b823(e) {
    const t = e._freezeSettings(), n = $368997c7fea60e4e$export$b4171a6734a65d42(e._databaseId);
    return new $368997c7fea60e4e$export$c5d1328b37d47994(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $368997c7fea60e4e$export$71cec2538cb2c617(e, t, n, r, i, s = {}) {
    const o = e.createContext(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $368997c7fea60e4e$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $368997c7fea60e4e$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $368997c7fea60e4e$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $368997c7fea60e4e$export$23f2a1d2818174ef(t, r, n);
            if (!o.contains(i)) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $368997c7fea60e4e$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $368997c7fea60e4e$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $368997c7fea60e4e$var$ParsedSetData(new $368997c7fea60e4e$export$c4ce752e73470fba(_), a, u);
}
class $368997c7fea60e4e$var$__PRIVATE_DeleteFieldValueImpl extends $368997c7fea60e4e$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError(`${this._methodName}() can only appear at the top level of your update data`) : e.createError(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $368997c7fea60e4e$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $368997c7fea60e4e$var$ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $368997c7fea60e4e$var$__PRIVATE_ServerTimestampFieldValueImpl extends $368997c7fea60e4e$export$92108d983e8ee699 {
    _toFieldTransform(e) {
        return new $368997c7fea60e4e$var$FieldTransform(e.path, new $368997c7fea60e4e$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $368997c7fea60e4e$var$__PRIVATE_ArrayUnionFieldValueImpl extends $368997c7fea60e4e$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Ac = t;
    }
    _toFieldTransform(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ac.map((e)=>$368997c7fea60e4e$export$f074adc9fbd50943(e, t)), r = new $368997c7fea60e4e$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $368997c7fea60e4e$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $9k0Bn.deepEqual)(this.Ac, e.Ac);
    }
}
class $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $368997c7fea60e4e$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Ac = t;
    }
    _toFieldTransform(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Ac.map((e)=>$368997c7fea60e4e$export$f074adc9fbd50943(e, t)), r = new $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $368997c7fea60e4e$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $9k0Bn.deepEqual)(this.Ac, e.Ac);
    }
}
class $368997c7fea60e4e$var$__PRIVATE_NumericIncrementFieldValueImpl extends $368997c7fea60e4e$export$92108d983e8ee699 {
    constructor(e, t){
        super(e), this.Vc = t;
    }
    _toFieldTransform(e) {
        const t = new $368997c7fea60e4e$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $368997c7fea60e4e$export$b4d5ecaefe2b27f3(e.serializer, this.Vc));
        return new $368997c7fea60e4e$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $368997c7fea60e4e$var$__PRIVATE_NumericIncrementFieldValueImpl && this.Vc === e.Vc;
    }
}
/** Parse update data from an update() call. */ function $368997c7fea60e4e$export$3d8c2f653ac9d0b9(e, t, n, r) {
    const i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    $368997c7fea60e4e$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $368997c7fea60e4e$export$c4ce752e73470fba.empty();
    $368997c7fea60e4e$var$forEach(r, (e, r)=>{
        const _ = $368997c7fea60e4e$export$f787f51d84a910ad(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $9k0Bn.getModularInstance)(r);
        const a = i.childContextForFieldPath(_);
        if (r instanceof $368997c7fea60e4e$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $368997c7fea60e4e$export$f074adc9fbd50943(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $368997c7fea60e4e$var$FieldMask(s);
    return new $368997c7fea60e4e$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $368997c7fea60e4e$export$dc98b0b04f4c7758(e, t, n, r, i, s) {
    const o = e.createContext(1 /* UserDataSource.Update */ , t, n), _ = [
        $368997c7fea60e4e$export$23f2a1d2818174ef(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($368997c7fea60e4e$export$23f2a1d2818174ef(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $368997c7fea60e4e$export$c4ce752e73470fba.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$368997c7fea60e4e$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $9k0Bn.getModularInstance)(n);
        const r = o.childContextForFieldPath(t);
        if (n instanceof $368997c7fea60e4e$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $368997c7fea60e4e$export$f074adc9fbd50943(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $368997c7fea60e4e$var$FieldMask(u);
    return new $368997c7fea60e4e$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $368997c7fea60e4e$export$39b482c5e57630a8(e, t, n, r = !1) {
    return $368997c7fea60e4e$export$f074adc9fbd50943(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $368997c7fea60e4e$export$f074adc9fbd50943(e, t) {
    if ($368997c7fea60e4e$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $9k0Bn.getModularInstance)(e))) return $368997c7fea60e4e$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $368997c7fea60e4e$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $368997c7fea60e4e$export$92108d983e8ee699) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$368997c7fea60e4e$var$__PRIVATE_isWrite(t.dataSource)) throw t.createError(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.createError(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $368997c7fea60e4e$export$f074adc9fbd50943(i, t.childContextForArray(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $9k0Bn.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $368997c7fea60e4e$export$b4d5ecaefe2b27f3(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $368997c7fea60e4e$export$3d12bd131bb975d1.fromDate(e);
            return {
                timestampValue: $368997c7fea60e4e$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $368997c7fea60e4e$export$3d12bd131bb975d1) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $368997c7fea60e4e$export$3d12bd131bb975d1(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $368997c7fea60e4e$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $368997c7fea60e4e$export$9fa96a7d116ea3ce) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $368997c7fea60e4e$export$ef35774e6d314e91) return {
            bytesValue: $368997c7fea60e4e$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $368997c7fea60e4e$export$96f57966bedc81b4) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.createError(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $368997c7fea60e4e$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $368997c7fea60e4e$export$91c6e00c14e7e6fd) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = e instanceof $368997c7fea60e4e$export$91c6e00c14e7e6fd ? e.toArray() : e, r = {
                fields: {
                    [$368997c7fea60e4e$var$ot]: {
                        stringValue: $368997c7fea60e4e$var$ut
                    },
                    [$368997c7fea60e4e$var$ct]: {
                        arrayValue: {
                            values: n.map((e)=>{
                                if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                                return $368997c7fea60e4e$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: r
            };
        }(e, t);
        if ($368997c7fea60e4e$var$__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError(`Unsupported field value: ${$368997c7fea60e4e$export$efccba1c4a2ef57b(e)}`);
    }(e, t);
}
function $368997c7fea60e4e$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $368997c7fea60e4e$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $368997c7fea60e4e$var$forEach(e, (e, r)=>{
        const i = $368997c7fea60e4e$export$f074adc9fbd50943(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $368997c7fea60e4e$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $368997c7fea60e4e$export$3d12bd131bb975d1 || e instanceof $368997c7fea60e4e$export$9fa96a7d116ea3ce || e instanceof $368997c7fea60e4e$export$ef35774e6d314e91 || e instanceof $368997c7fea60e4e$export$96f57966bedc81b4 || e instanceof $368997c7fea60e4e$export$92108d983e8ee699 || e instanceof $368997c7fea60e4e$export$91c6e00c14e7e6fd || $368997c7fea60e4e$var$__PRIVATE_isProtoValueSerializable(e));
}
function $368997c7fea60e4e$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$368997c7fea60e4e$var$__PRIVATE_looksLikeJsonObject(n) || !$368997c7fea60e4e$export$7f557e5eb95176c2(n)) {
        const r = $368997c7fea60e4e$export$efccba1c4a2ef57b(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $368997c7fea60e4e$export$23f2a1d2818174ef(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $9k0Bn.getModularInstance)(t)) instanceof $368997c7fea60e4e$export$8743009a87fcb00f) return t._internalPath;
    if ("string" == typeof t) return $368997c7fea60e4e$export$f787f51d84a910ad(e, t);
    throw $368997c7fea60e4e$var$createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $368997c7fea60e4e$var$an = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $368997c7fea60e4e$export$f787f51d84a910ad(e, t, n) {
    if (t.search($368997c7fea60e4e$var$an) >= 0) throw $368997c7fea60e4e$var$createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $368997c7fea60e4e$export$8743009a87fcb00f(...t.split("."))._internalPath;
    } catch (r) {
        throw $368997c7fea60e4e$var$createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $368997c7fea60e4e$var$createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $368997c7fea60e4e$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function $368997c7fea60e4e$export$a36fb7d24305ed9d(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $368997c7fea60e4e$export$ebd11618f299a286 {
    convertValue(e, t = "none") {
        switch($368997c7fea60e4e$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($368997c7fea60e4e$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $368997c7fea60e4e$export$3a6d5c9ae78a2c08(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $368997c7fea60e4e$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$368997c7fea60e4e$var$ct].arrayValue?.values?.map((e)=>$368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $368997c7fea60e4e$export$91c6e00c14e7e6fd(t);
    }
    convertGeoPoint(e) {
        return new $368997c7fea60e4e$export$9fa96a7d116ea3ce($368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.latitude), $368997c7fea60e4e$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $368997c7fea60e4e$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($368997c7fea60e4e$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $368997c7fea60e4e$var$__PRIVATE_normalizeTimestamp(e);
        return new $368997c7fea60e4e$export$3d12bd131bb975d1(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $368997c7fea60e4e$export$db202ddc8be9136.fromString(e);
        $368997c7fea60e4e$export$c18d01048907ea92($368997c7fea60e4e$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $368997c7fea60e4e$export$890c4ad488842ce7(n.get(1), n.get(3)), i = new $368997c7fea60e4e$export$90a7f3efeed30595(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $368997c7fea60e4e$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$export$7f8ddf7c7c20b3cd extends $368997c7fea60e4e$export$ebd11618f299a286 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $368997c7fea60e4e$export$ef35774e6d314e91(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $368997c7fea60e4e$export$96f57966bedc81b4(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $368997c7fea60e4e$export$738ab4df8bf92ae9() {
    return new $368997c7fea60e4e$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $368997c7fea60e4e$export$fef3dfd9bad05307() {
    return new $368997c7fea60e4e$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $368997c7fea60e4e$export$9f4f30ee63539e24(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $368997c7fea60e4e$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $368997c7fea60e4e$export$91477dc880baac21(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $368997c7fea60e4e$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $368997c7fea60e4e$export$e171bab687b50e0(e) {
    return new $368997c7fea60e4e$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $368997c7fea60e4e$export$2ec5befb9e6c97d4(e) {
    return new $368997c7fea60e4e$export$91c6e00c14e7e6fd(e);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$export$151db275011178c4 {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = $368997c7fea60e4e$export$c4ce752e73470fba.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let o;
                if (i.nestedOptions && $368997c7fea60e4e$export$7f557e5eb95176c2(s)) o = {
                    mapValue: {
                        fields: new $368997c7fea60e4e$export$151db275011178c4(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (o = $368997c7fea60e4e$export$f074adc9fbd50943(s, t) ?? void 0);
                o && n.set($368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(i.serverName), o);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map($368997c7fea60e4e$export$a9c23c6ac3fc3eca(n, (t, n)=>[
                    $368997c7fea60e4e$export$cf2f7c5792f80b46.fromServerFormat(n),
                    void 0 !== t ? $368997c7fea60e4e$export$f074adc9fbd50943(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $368997c7fea60e4e$export$31e67cf12fc9668 {
    constructor(e = {}, t = {}){
        this.dc = e, this.mc = t, this.fc = new $368997c7fea60e4e$export$151db275011178c4({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.fc.getOptionsProto(e, this.dc, this.mc);
    }
}
class $368997c7fea60e4e$export$55ff3cc1821e8445 {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $368997c7fea60e4e$export$b9a6b53f9be3734(e) {
    const t = $368997c7fea60e4e$export$df995fae86a55f06($368997c7fea60e4e$export$4a5767248b18ef41(e.firestore, $368997c7fea60e4e$export$d66501df72047452)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $368997c7fea60e4e$var$__PRIVATE_toQueryTarget(n, $368997c7fea60e4e$var$__PRIVATE_queryToTarget(e._query)).ft;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $368997c7fea60e4e$export$a33b77bbdbb8366c(e, t) {
    const n = $368997c7fea60e4e$export$a9c23c6ac3fc3eca(t, (e, t)=>new $368997c7fea60e4e$export$7a38258bbe170828(t, e.aggregateType, e._internalFieldPath)), r = $368997c7fea60e4e$export$df995fae86a55f06($368997c7fea60e4e$export$4a5767248b18ef41(e.firestore, $368997c7fea60e4e$export$d66501df72047452)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $368997c7fea60e4e$var$__PRIVATE_toRunAggregationQueryRequest(i, $368997c7fea60e4e$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function $368997c7fea60e4e$export$acf3ba20e47771d(e) {
    const t = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore(e) {
        if (e._terminated) throw new $368997c7fea60e4e$export$4368d992c4eafac0($368997c7fea60e4e$export$e7094788287c5e9b.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!$368997c7fea60e4e$var$tn.has(e)) {
            $368997c7fea60e4e$export$21579262ef46735b($368997c7fea60e4e$var$en, "Initializing Datastore");
            const t = $368997c7fea60e4e$var$__PRIVATE_newConnection($368997c7fea60e4e$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = $368997c7fea60e4e$export$b4171a6734a65d42(e._databaseId), r = $368997c7fea60e4e$var$__PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            $368997c7fea60e4e$var$tn.set(e, r);
        }
        return $368997c7fea60e4e$var$tn.get(e);
    }($368997c7fea60e4e$export$4a5767248b18ef41(e._db, $368997c7fea60e4e$export$d66501df72047452)), n = t.serializer;
    if (void 0 === n) return null;
    const r = new $368997c7fea60e4e$export$55ff3cc1821e8445(e, new $368997c7fea60e4e$export$31e67cf12fc9668);
    return {
        database: $368997c7fea60e4e$var$__PRIVATE_getEncodedDatabaseId(n),
        structuredPipeline: r._toProto(n)
    };
}

});
parcelRegister("3Hs2j", function(module, exports) {

$parcel$export(module.exports, "Integer", function () { return $2b1b22adeed02bf0$export$70ffa26850098d01; });
$parcel$export(module.exports, "Md5", function () { return $2b1b22adeed02bf0$export$9f5a3dfc7a9f5dd; });
var $2b1b22adeed02bf0$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $2b1b22adeed02bf0$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $2b1b22adeed02bf0$export$70ffa26850098d01;
var $2b1b22adeed02bf0$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $2b1b22adeed02bf0$export$9f5a3dfc7a9f5dd = $2b1b22adeed02bf0$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $2b1b22adeed02bf0$export$70ffa26850098d01 = $2b1b22adeed02bf0$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $2b1b22adeed02bf0$var$commonjsGlobal !== 'undefined' ? $2b1b22adeed02bf0$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("9Necc", function(module, exports) {

$parcel$export(module.exports, "XhrIo", function () { return $7213b3a55b859772$export$26404658cda3ee02; });
$parcel$export(module.exports, "WebChannel", function () { return $7213b3a55b859772$export$aa726fb96ad3e039; });
$parcel$export(module.exports, "EventType", function () { return $7213b3a55b859772$export$3d7865934588d77e; });
$parcel$export(module.exports, "ErrorCode", function () { return $7213b3a55b859772$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Stat", function () { return $7213b3a55b859772$export$cbbc350c1dfc80cb; });
$parcel$export(module.exports, "Event", function () { return $7213b3a55b859772$export$d61e24a684f9e51; });
$parcel$export(module.exports, "getStatEventTarget", function () { return $7213b3a55b859772$export$888d0d9ab79d08fc; });
$parcel$export(module.exports, "createWebChannelTransport", function () { return $7213b3a55b859772$export$66869136fc133c3a; });
var $7213b3a55b859772$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $7213b3a55b859772$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $7213b3a55b859772$export$26404658cda3ee02;
var $7213b3a55b859772$export$ddb1030448106742;
var $7213b3a55b859772$export$aa726fb96ad3e039;
var $7213b3a55b859772$export$3d7865934588d77e;
var $7213b3a55b859772$export$d4e71bc0b80dc0fb;
var $7213b3a55b859772$export$cbbc350c1dfc80cb;
var $7213b3a55b859772$export$d61e24a684f9e51;
var $7213b3a55b859772$export$888d0d9ab79d08fc;
var $7213b3a55b859772$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $7213b3a55b859772$var$commonjsGlobal && $7213b3a55b859772$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $7213b3a55b859772$export$66869136fc133c3a = $7213b3a55b859772$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new bd;
    };
    $7213b3a55b859772$export$888d0d9ab79d08fc = $7213b3a55b859772$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return jb();
    };
    $7213b3a55b859772$export$d61e24a684f9e51 = $7213b3a55b859772$export$2e2bcd8739ae039.Event = I;
    $7213b3a55b859772$export$cbbc350c1dfc80cb = $7213b3a55b859772$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $7213b3a55b859772$export$d4e71bc0b80dc0fb = $7213b3a55b859772$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $7213b3a55b859772$export$3d7865934588d77e = $7213b3a55b859772$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $7213b3a55b859772$export$aa726fb96ad3e039 = $7213b3a55b859772$export$2e2bcd8739ae039.WebChannel = fb;
    $7213b3a55b859772$export$ddb1030448106742 = $7213b3a55b859772$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $7213b3a55b859772$export$26404658cda3ee02 = $7213b3a55b859772$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $7213b3a55b859772$var$commonjsGlobal !== 'undefined' ? $7213b3a55b859772$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

});

parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});







//# sourceMappingURL=auth.ddc1a2e5.js.map
